{
  "Total": {
    "ageData": {
      "2012": {
        "total": "142,469",
        "16to19": "4,426",
        "20to24": "13,408",
        "25to34": "30,701",
        "35to44": "30,576",
        "45to54": "32,874",
        "55to64": "23,239",
        "65+": "7,245",
        "medianAge": "23,239"
      }
    },
    "title": "Total",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "142,469",
        "women": "47.0",
        "white": "11.1",
        "black": "5.4",
        "asian": "15.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "102,749",
        "median": "$768",
        "maleWorkers": "57,286",
        "maleMedian": "$854",
        "femaleWorkers": "45,462",
        "femaleMedian": "$691"
      }
    }
  },
  "Management, professional, and related occupations": {
    "ageData": {
      "2012": {
        "total": "54,043",
        "16to19": "339",
        "20to24": "2,690",
        "25to34": "11,894",
        "35to44": "12,810",
        "45to54": "13,329",
        "55to64": "9,908",
        "65+": "3,074",
        "medianAge": "9,908"
      }
    },
    "title": "Management, professional, and related occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "54,043",
        "women": "51.5",
        "white": "8.7",
        "black": "6.9",
        "asian": "8.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "40,984",
        "median": "1,108",
        "maleWorkers": "19,926",
        "maleMedian": "1,328",
        "femaleWorkers": "21,059",
        "femaleMedian": "951"
      }
    }
  },
  "Management, business, and financial operations occupations": {
    "ageData": {
      "2012": {
        "total": "22,678",
        "16to19": "67",
        "20to24": "817",
        "25to34": "4,236",
        "35to44": "5,436",
        "45to54": "6,171",
        "55to64": "4,457",
        "65+": "1,494",
        "medianAge": "4,457"
      }
    },
    "title": "Management, business, and financial operations occupations",
    "depth": 2,
    "parent": "Management, professional, and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "22,678",
        "women": "43.6",
        "white": "7.8",
        "black": "5.8",
        "asian": "8.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16,991",
        "median": "1,171",
        "maleWorkers": "9,121",
        "maleMedian": "1,387",
        "femaleWorkers": "7,869",
        "femaleMedian": "993"
      }
    }
  },
  "Management occupations": {
    "ageData": {
      "2012": {
        "total": "16,042",
        "16to19": "52",
        "20to24": "500",
        "25to34": "2,691",
        "35to44": "3,829",
        "45to54": "4,571",
        "55to64": "3,260",
        "65+": "1,140",
        "medianAge": "3,260"
      }
    },
    "title": "Management occupations",
    "depth": 3,
    "parent": "Management, business, and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16,042",
        "women": "38.6",
        "white": "6.9",
        "black": "5.1",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11,547",
        "median": "1,248",
        "maleWorkers": "6,783",
        "maleMedian": "1,428",
        "femaleWorkers": "4,765",
        "femaleMedian": "1,036"
      }
    }
  },
  "Chief executives": {
    "ageData": {
      "2012": {
        "total": "1,513",
        "16to19": "1",
        "20to24": "5",
        "25to34": "107",
        "35to44": "318",
        "45to54": "532",
        "55to64": "413",
        "65+": "136",
        "medianAge": "413"
      }
    },
    "title": "Chief executives",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,513",
        "women": "27.4",
        "white": "3.7",
        "black": "4.2",
        "asian": "4.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,004",
        "median": "2,060",
        "maleWorkers": "739",
        "maleMedian": "2,275",
        "femaleWorkers": "265",
        "femaleMedian": "1,730"
      }
    }
  },
  "General and operations managers": {
    "ageData": {
      "2012": {
        "total": "1,064",
        "16to19": "0",
        "20to24": "30",
        "25to34": "193",
        "35to44": "283",
        "45to54": "326",
        "55to64": "195",
        "65+": "37",
        "medianAge": "195"
      }
    },
    "title": "General and operations managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,064",
        "women": "29.1",
        "white": "6.2",
        "black": "4.7",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "983",
        "median": "1,264",
        "maleWorkers": "705",
        "maleMedian": "1,436",
        "femaleWorkers": "278",
        "femaleMedian": "971"
      }
    }
  },
  "Legislators": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "3",
        "55to64": "3",
        "65+": "3",
        "medianAge": "3"
      }
    },
    "title": "Legislators",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Advertising and promotions managers": {
    "ageData": {
      "2012": {
        "total": "77",
        "16to19": "0",
        "20to24": "8",
        "25to34": "19",
        "35to44": "23",
        "45to54": "15",
        "55to64": "9",
        "65+": "3",
        "medianAge": "9"
      }
    },
    "title": "Advertising and promotions managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "77",
        "women": "49.4",
        "white": "6.7",
        "black": "4.3",
        "asian": "10.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "65",
        "median": "1,334",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Marketing and sales managers": {
    "ageData": {
      "2012": {
        "total": "967",
        "16to19": "2",
        "20to24": "43",
        "25to34": "238",
        "35to44": "284",
        "45to54": "244",
        "55to64": "136",
        "65+": "21",
        "medianAge": "136"
      }
    },
    "title": "Marketing and sales managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "967",
        "women": "45.2",
        "white": "4.2",
        "black": "6.0",
        "asian": "6.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "916",
        "median": "1,396",
        "maleWorkers": "514",
        "maleMedian": "1,640",
        "femaleWorkers": "402",
        "femaleMedian": "1,110"
      }
    }
  },
  "Public relations and fundraising managers": {
    "ageData": {
      "2012": {
        "total": "58",
        "16to19": "0",
        "20to24": "1",
        "25to34": "19",
        "35to44": "12",
        "45to54": "13",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Public relations and fundraising managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "58",
        "women": "69.3",
        "white": "5.8",
        "black": "3.4",
        "asian": "8.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "56",
        "median": "1,237",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Administrative services managers": {
    "ageData": {
      "2012": {
        "total": "144",
        "16to19": "0",
        "20to24": "5",
        "25to34": "17",
        "35to44": "25",
        "45to54": "55",
        "55to64": "35",
        "65+": "7",
        "medianAge": "35"
      }
    },
    "title": "Administrative services managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "144",
        "women": "44.1",
        "white": "6.4",
        "black": "4.4",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "133",
        "median": "1,103",
        "maleWorkers": "76",
        "maleMedian": "1,212",
        "femaleWorkers": "57",
        "femaleMedian": "1,038"
      }
    }
  },
  "Computer and information systems managers": {
    "ageData": {
      "2012": {
        "total": "605",
        "16to19": "1",
        "20to24": "6",
        "25to34": "106",
        "35to44": "222",
        "45to54": "172",
        "55to64": "89",
        "65+": "11",
        "medianAge": "89"
      }
    },
    "title": "Computer and information systems managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "605",
        "women": "26.8",
        "white": "5.6",
        "black": "14.5",
        "asian": "5.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "568",
        "median": "1,672",
        "maleWorkers": "423",
        "maleMedian": "1,740",
        "femaleWorkers": "145",
        "femaleMedian": "1,527"
      }
    }
  },
  "Financial managers": {
    "ageData": {
      "2012": {
        "total": "1,228",
        "16to19": "1",
        "20to24": "37",
        "25to34": "287",
        "35to44": "296",
        "45to54": "331",
        "55to64": "220",
        "65+": "55",
        "medianAge": "220"
      }
    },
    "title": "Financial managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,228",
        "women": "53.5",
        "white": "8.6",
        "black": "5.7",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,125",
        "median": "1,169",
        "maleWorkers": "509",
        "maleMedian": "1,405",
        "femaleWorkers": "616",
        "femaleMedian": "988"
      }
    }
  },
  "Compensation and benefits managers": {
    "ageData": {
      "2012": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "4",
        "45to54": "4",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Compensation and benefits managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Human resources managers": {
    "ageData": {
      "2012": {
        "total": "224",
        "16to19": "1",
        "20to24": "4",
        "25to34": "40",
        "35to44": "58",
        "45to54": "72",
        "55to64": "43",
        "65+": "6",
        "medianAge": "43"
      }
    },
    "title": "Human resources managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "224",
        "women": "72.7",
        "white": "11.3",
        "black": "2.4",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "216",
        "median": "1,271",
        "maleWorkers": "56",
        "maleMedian": "1,447",
        "femaleWorkers": "160",
        "femaleMedian": "1,208"
      }
    }
  },
  "Training and development managers": {
    "ageData": {
      "2012": {
        "total": "36",
        "16to19": "1",
        "20to24": "2",
        "25to34": "6",
        "35to44": "5",
        "45to54": "14",
        "55to64": "8",
        "65+": "1",
        "medianAge": "8"
      }
    },
    "title": "Training and development managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "36",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial production managers": {
    "ageData": {
      "2012": {
        "total": "261",
        "16to19": "1",
        "20to24": "5",
        "25to34": "39",
        "35to44": "59",
        "45to54": "94",
        "55to64": "50",
        "65+": "12",
        "medianAge": "50"
      }
    },
    "title": "Industrial production managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "261",
        "women": "17.6",
        "white": "3.4",
        "black": "5.1",
        "asian": "11.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "219",
        "median": "1,183",
        "maleWorkers": "185",
        "maleMedian": "1,181",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "Purchasing managers": {
    "ageData": {
      "2012": {
        "total": "218",
        "16to19": "0",
        "20to24": "7",
        "25to34": "33",
        "35to44": "48",
        "45to54": "81",
        "55to64": "44",
        "65+": "6",
        "medianAge": "44"
      }
    },
    "title": "Purchasing managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "218",
        "women": "50.9",
        "white": "8.4",
        "black": "4.6",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "204",
        "median": "1,319",
        "maleWorkers": "104",
        "maleMedian": "1,467",
        "femaleWorkers": "99",
        "femaleMedian": "1,072"
      }
    }
  },
  "Transportation, storage, and distribution managers": {
    "ageData": {
      "2012": {
        "total": "287",
        "16to19": "1",
        "20to24": "10",
        "25to34": "57",
        "35to44": "76",
        "45to54": "78",
        "55to64": "52",
        "65+": "13",
        "medianAge": "52"
      }
    },
    "title": "Transportation, storage, and distribution managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "287",
        "women": "15.6",
        "white": "11.1",
        "black": "3.3",
        "asian": "11.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "276",
        "median": "953",
        "maleWorkers": "240",
        "maleMedian": "938",
        "femaleWorkers": "36",
        "femaleMedian": "-"
      }
    }
  },
  "Farmers, ranchers, and other agricultural managers": {
    "ageData": {
      "2012": {
        "total": "944",
        "16to19": "12",
        "20to24": "31",
        "25to34": "88",
        "35to44": "111",
        "45to54": "201",
        "55to64": "249",
        "65+": "252",
        "medianAge": "249"
      }
    },
    "title": "Farmers, ranchers, and other agricultural managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "944",
        "women": "24.5",
        "white": "0.8",
        "black": "1.2",
        "asian": "4.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "104",
        "median": "708",
        "maleWorkers": "89",
        "maleMedian": "699",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Construction managers": {
    "ageData": {
      "2012": {
        "total": "983",
        "16to19": "1",
        "20to24": "24",
        "25to34": "150",
        "35to44": "239",
        "45to54": "318",
        "55to64": "200",
        "65+": "52",
        "medianAge": "200"
      }
    },
    "title": "Construction managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "983",
        "women": "6.4",
        "white": "3.7",
        "black": "2.2",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "460",
        "median": "1,208",
        "maleWorkers": "425",
        "maleMedian": "1,233",
        "femaleWorkers": "35",
        "femaleMedian": "-"
      }
    }
  },
  "Education administrators": {
    "ageData": {
      "2012": {
        "total": "811",
        "16to19": "1",
        "20to24": "18",
        "25to34": "117",
        "35to44": "221",
        "45to54": "218",
        "55to64": "191",
        "65+": "45",
        "medianAge": "191"
      }
    },
    "title": "Education administrators",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "811",
        "women": "64.4",
        "white": "13.8",
        "black": "2.2",
        "asian": "7.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "704",
        "median": "1,255",
        "maleWorkers": "250",
        "maleMedian": "1,566",
        "femaleWorkers": "454",
        "femaleMedian": "1,052"
      }
    }
  },
  "Architectural and engineering managers": {
    "ageData": {
      "2012": {
        "total": "120",
        "16to19": "0",
        "20to24": "0",
        "25to34": "16",
        "35to44": "31",
        "45to54": "40",
        "55to64": "28",
        "65+": "5",
        "medianAge": "28"
      }
    },
    "title": "Architectural and engineering managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "120",
        "women": "10.9",
        "white": "2.8",
        "black": "7.7",
        "asian": "2.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "111",
        "median": "2,122",
        "maleWorkers": "101",
        "maleMedian": "2,116",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Food service managers": {
    "ageData": {
      "2012": {
        "total": "1,085",
        "16to19": "22",
        "20to24": "140",
        "25to34": "273",
        "35to44": "234",
        "45to54": "245",
        "55to64": "135",
        "65+": "36",
        "medianAge": "135"
      }
    },
    "title": "Food service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,085",
        "women": "47.2",
        "white": "8.8",
        "black": "9.5",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "678",
        "median": "689",
        "maleWorkers": "351",
        "maleMedian": "744",
        "femaleWorkers": "327",
        "femaleMedian": "601"
      }
    }
  },
  "Funeral service managers": {
    "ageData": {
      "2012": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "2",
        "45to54": "4",
        "55to64": "3",
        "65+": "5",
        "medianAge": "3"
      }
    },
    "title": "Funeral service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Gaming managers": {
    "ageData": {
      "2012": {
        "total": "26",
        "16to19": "0",
        "20to24": "4",
        "25to34": "6",
        "35to44": "6",
        "45to54": "7",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Gaming managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "26",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Lodging managers": {
    "ageData": {
      "2012": {
        "total": "154",
        "16to19": "0",
        "20to24": "6",
        "25to34": "32",
        "35to44": "26",
        "45to54": "37",
        "55to64": "34",
        "65+": "19",
        "medianAge": "34"
      }
    },
    "title": "Lodging managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "154",
        "women": "45.0",
        "white": "8.0",
        "black": "13.9",
        "asian": "11.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "100",
        "median": "774",
        "maleWorkers": "53",
        "maleMedian": "1,131",
        "femaleWorkers": "47",
        "femaleMedian": "-"
      }
    }
  },
  "Medical and health services managers": {
    "ageData": {
      "2012": {
        "total": "585",
        "16to19": "0",
        "20to24": "8",
        "25to34": "89",
        "35to44": "125",
        "45to54": "176",
        "55to64": "148",
        "65+": "40",
        "medianAge": "148"
      }
    },
    "title": "Medical and health services managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "585",
        "women": "69.7",
        "white": "10.9",
        "black": "5.1",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "502",
        "median": "1,280",
        "maleWorkers": "144",
        "maleMedian": "1,544",
        "femaleWorkers": "358",
        "femaleMedian": "1,190"
      }
    }
  },
  "Natural sciences managers": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "6",
        "45to54": "5",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Natural sciences managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Postmasters and mail superintendents": {
    "ageData": {
      "2012": {
        "total": "39",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "8",
        "45to54": "13",
        "55to64": "13",
        "65+": "3",
        "medianAge": "13"
      }
    },
    "title": "Postmasters and mail superintendents",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "39",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Property, real estate, and community association managers": {
    "ageData": {
      "2012": {
        "total": "644",
        "16to19": "1",
        "20to24": "10",
        "25to34": "109",
        "35to44": "125",
        "45to54": "172",
        "55to64": "139",
        "65+": "87",
        "medianAge": "139"
      }
    },
    "title": "Property, real estate, and community association managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "644",
        "women": "50.7",
        "white": "8.5",
        "black": "3.4",
        "asian": "11.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "353",
        "median": "907",
        "maleWorkers": "153",
        "maleMedian": "1,045",
        "femaleWorkers": "200",
        "femaleMedian": "817"
      }
    }
  },
  "Social and community service managers": {
    "ageData": {
      "2012": {
        "total": "315",
        "16to19": "0",
        "20to24": "15",
        "25to34": "56",
        "35to44": "84",
        "45to54": "72",
        "55to64": "59",
        "65+": "28",
        "medianAge": "59"
      }
    },
    "title": "Social and community service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "315",
        "women": "70.5",
        "white": "14.6",
        "black": "3.7",
        "asian": "8.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "260",
        "median": "947",
        "maleWorkers": "76",
        "maleMedian": "1,151",
        "femaleWorkers": "184",
        "femaleMedian": "883"
      }
    }
  },
  "Emergency management directors": {
    "ageData": {
      "2012": {
        "total": "6",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "1",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Emergency management directors",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Managers, all other": {
    "ageData": {
      "2012": {
        "total": "3,594",
        "16to19": "7",
        "20to24": "79",
        "25to34": "583",
        "35to44": "897",
        "45to54": "1,028",
        "55to64": "748",
        "65+": "253",
        "medianAge": "748"
      }
    },
    "title": "Managers, all other",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,594",
        "women": "35.0",
        "white": "7.3",
        "black": "5.0",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,367",
        "median": "1,258",
        "maleWorkers": "1,465",
        "maleMedian": "1,409",
        "femaleWorkers": "902",
        "femaleMedian": "1,078"
      }
    }
  },
  "Business and financial operations occupations": {
    "ageData": {
      "2012": {
        "total": "6,636",
        "16to19": "15",
        "20to24": "317",
        "25to34": "1,546",
        "35to44": "1,607",
        "45to54": "1,600",
        "55to64": "1,197",
        "65+": "355",
        "medianAge": "1,197"
      }
    },
    "title": "Business and financial operations occupations",
    "depth": 3,
    "parent": "Management, business, and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6,636",
        "women": "55.8",
        "white": "9.8",
        "black": "7.4",
        "asian": "8.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5,443",
        "median": "1,058",
        "maleWorkers": "2,339",
        "maleMedian": "1,274",
        "femaleWorkers": "3,105",
        "femaleMedian": "952"
      }
    }
  },
  "Agents and business managers of artists, performers, and athletes": {
    "ageData": {
      "2012": {
        "total": "47",
        "16to19": "1",
        "20to24": "3",
        "25to34": "10",
        "35to44": "13",
        "45to54": "7",
        "55to64": "7",
        "65+": "4",
        "medianAge": "7"
      }
    },
    "title": "Agents and business managers of artists, performers, and athletes",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Buyers and purchasing agents, farm products": {
    "ageData": {
      "2012": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "3",
        "45to54": "3",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Buyers and purchasing agents, farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Wholesale and retail buyers, except farm products": {
    "ageData": {
      "2012": {
        "total": "198",
        "16to19": "3",
        "20to24": "14",
        "25to34": "47",
        "35to44": "38",
        "45to54": "39",
        "55to64": "47",
        "65+": "11",
        "medianAge": "47"
      }
    },
    "title": "Wholesale and retail buyers, except farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "198",
        "women": "55.2",
        "white": "7.1",
        "black": "7.7",
        "asian": "10.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "141",
        "median": "850",
        "maleWorkers": "66",
        "maleMedian": "853",
        "femaleWorkers": "75",
        "femaleMedian": "847"
      }
    }
  },
  "Purchasing agents, except wholesale, retail, and farm products": {
    "ageData": {
      "2012": {
        "total": "261",
        "16to19": "1",
        "20to24": "11",
        "25to34": "40",
        "35to44": "65",
        "45to54": "71",
        "55to64": "65",
        "65+": "9",
        "medianAge": "65"
      }
    },
    "title": "Purchasing agents, except wholesale, retail, and farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "261",
        "women": "55.1",
        "white": "6.1",
        "black": "4.4",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "239",
        "median": "987",
        "maleWorkers": "109",
        "maleMedian": "1,057",
        "femaleWorkers": "130",
        "femaleMedian": "942"
      }
    }
  },
  "Claims adjusters, appraisers, examiners, and investigators": {
    "ageData": {
      "2012": {
        "total": "323",
        "16to19": "0",
        "20to24": "12",
        "25to34": "75",
        "35to44": "86",
        "45to54": "73",
        "55to64": "61",
        "65+": "16",
        "medianAge": "61"
      }
    },
    "title": "Claims adjusters, appraisers, examiners, and investigators",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "323",
        "women": "63.4",
        "white": "17.5",
        "black": "3.1",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "307",
        "median": "909",
        "maleWorkers": "104",
        "maleMedian": "1,158",
        "femaleWorkers": "203",
        "femaleMedian": "803"
      }
    }
  },
  "Compliance officers": {
    "ageData": {
      "2012": {
        "total": "199",
        "16to19": "0",
        "20to24": "1",
        "25to34": "36",
        "35to44": "47",
        "45to54": "57",
        "55to64": "51",
        "65+": "6",
        "medianAge": "51"
      }
    },
    "title": "Compliance officers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "199",
        "women": "50.6",
        "white": "9.1",
        "black": "3.3",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "192",
        "median": "1,183",
        "maleWorkers": "101",
        "maleMedian": "1,304",
        "femaleWorkers": "91",
        "femaleMedian": "999"
      }
    }
  },
  "Cost estimators": {
    "ageData": {
      "2012": {
        "total": "114",
        "16to19": "0",
        "20to24": "7",
        "25to34": "20",
        "35to44": "30",
        "45to54": "23",
        "55to64": "24",
        "65+": "9",
        "medianAge": "24"
      }
    },
    "title": "Cost estimators",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "114",
        "women": "11.7",
        "white": "1.5",
        "black": "2.0",
        "asian": "6.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "91",
        "median": "1,154",
        "maleWorkers": "81",
        "maleMedian": "1,164",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Human resources workers": {
    "ageData": {
      "2012": {
        "total": "603",
        "16to19": "1",
        "20to24": "31",
        "25to34": "148",
        "35to44": "168",
        "45to54": "141",
        "55to64": "97",
        "65+": "16",
        "medianAge": "97"
      }
    },
    "title": "Human resources workers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "603",
        "women": "71.8",
        "white": "15.4",
        "black": "4.4",
        "asian": "11.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "559",
        "median": "994",
        "maleWorkers": "158",
        "maleMedian": "1,249",
        "femaleWorkers": "401",
        "femaleMedian": "944"
      }
    }
  },
  "Compensation, benefits, and job analysis specialists": {
    "ageData": {
      "2012": {
        "total": "71",
        "16to19": "0",
        "20to24": "2",
        "25to34": "13",
        "35to44": "19",
        "45to54": "16",
        "55to64": "20",
        "65+": "1",
        "medianAge": "20"
      }
    },
    "title": "Compensation, benefits, and job analysis specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "71",
        "women": "81.1",
        "white": "6.9",
        "black": "4.2",
        "asian": "11.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "72",
        "median": "961",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "59",
        "femaleMedian": "866"
      }
    }
  },
  "Training and development specialists": {
    "ageData": {
      "2012": {
        "total": "126",
        "16to19": "0",
        "20to24": "4",
        "25to34": "28",
        "35to44": "34",
        "45to54": "30",
        "55to64": "25",
        "65+": "4",
        "medianAge": "25"
      }
    },
    "title": "Training and development specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "126",
        "women": "56.4",
        "white": "15.9",
        "black": "0.8",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "120",
        "median": "983",
        "maleWorkers": "51",
        "maleMedian": "1,144",
        "femaleWorkers": "69",
        "femaleMedian": "866"
      }
    }
  },
  "Logisticians": {
    "ageData": {
      "2012": {
        "total": "94",
        "16to19": "0",
        "20to24": "4",
        "25to34": "26",
        "35to44": "20",
        "45to54": "28",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Logisticians",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "94",
        "women": "36.8",
        "white": "12.3",
        "black": "2.2",
        "asian": "11.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "88",
        "median": "1,009",
        "maleWorkers": "57",
        "maleMedian": "1,225",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Management analysts": {
    "ageData": {
      "2012": {
        "total": "773",
        "16to19": "1",
        "20to24": "25",
        "25to34": "151",
        "35to44": "178",
        "45to54": "181",
        "55to64": "160",
        "65+": "77",
        "medianAge": "160"
      }
    },
    "title": "Management analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "773",
        "women": "39.8",
        "white": "6.8",
        "black": "8.8",
        "asian": "4.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "479",
        "median": "1,452",
        "maleWorkers": "277",
        "maleMedian": "1,535",
        "femaleWorkers": "202",
        "femaleMedian": "1,325"
      }
    }
  },
  "Meeting, convention, and event planners": {
    "ageData": {
      "2012": {
        "total": "127",
        "16to19": "2",
        "20to24": "15",
        "25to34": "41",
        "35to44": "28",
        "45to54": "24",
        "55to64": "11",
        "65+": "7",
        "medianAge": "11"
      }
    },
    "title": "Meeting, convention, and event planners",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "127",
        "women": "73.3",
        "white": "8.1",
        "black": "4.2",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "86",
        "median": "819",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "72",
        "femaleMedian": "824"
      }
    }
  },
  "Fundraisers": {
    "ageData": {
      "2012": {
        "total": "86",
        "16to19": "2",
        "20to24": "8",
        "25to34": "24",
        "35to44": "19",
        "45to54": "18",
        "55to64": "12",
        "65+": "3",
        "medianAge": "12"
      }
    },
    "title": "Fundraisers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "86",
        "women": "75.3",
        "white": "5.1",
        "black": "4.6",
        "asian": "3.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "61",
        "median": "1,058",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "45",
        "femaleMedian": "-"
      }
    }
  },
  "Market research analysts and marketing specialists": {
    "ageData": {
      "2012": {
        "total": "219",
        "16to19": "0",
        "20to24": "14",
        "25to34": "68",
        "35to44": "57",
        "45to54": "48",
        "55to64": "27",
        "65+": "6",
        "medianAge": "27"
      }
    },
    "title": "Market research analysts and marketing specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "219",
        "women": "54.2",
        "white": "5.4",
        "black": "9.1",
        "asian": "4.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "175",
        "median": "1,148",
        "maleWorkers": "85",
        "maleMedian": "1,197",
        "femaleWorkers": "90",
        "femaleMedian": "1,073"
      }
    }
  },
  "Business operations specialists, all other": {
    "ageData": {
      "2012": {
        "total": "251",
        "16to19": "2",
        "20to24": "9",
        "25to34": "59",
        "35to44": "59",
        "45to54": "71",
        "55to64": "41",
        "65+": "10",
        "medianAge": "41"
      }
    },
    "title": "Business operations specialists, all other",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "251",
        "women": "67.3",
        "white": "14.2",
        "black": "5.6",
        "asian": "9.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "220",
        "median": "970",
        "maleWorkers": "73",
        "maleMedian": "1,271",
        "femaleWorkers": "147",
        "femaleMedian": "904"
      }
    }
  },
  "Accountants and auditors": {
    "ageData": {
      "2012": {
        "total": "1,765",
        "16to19": "1",
        "20to24": "95",
        "25to34": "443",
        "35to44": "436",
        "45to54": "424",
        "55to64": "274",
        "65+": "91",
        "medianAge": "274"
      }
    },
    "title": "Accountants and auditors",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,765",
        "women": "60.9",
        "white": "9.7",
        "black": "12.0",
        "asian": "6.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,471",
        "median": "1,110",
        "maleWorkers": "585",
        "maleMedian": "1,350",
        "femaleWorkers": "886",
        "femaleMedian": "996"
      }
    }
  },
  "Appraisers and assessors of real estate": {
    "ageData": {
      "2012": {
        "total": "93",
        "16to19": "0",
        "20to24": "1",
        "25to34": "16",
        "35to44": "16",
        "45to54": "27",
        "55to64": "25",
        "65+": "7",
        "medianAge": "25"
      }
    },
    "title": "Appraisers and assessors of real estate",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "93",
        "women": "40.6",
        "white": "9.8",
        "black": "2.7",
        "asian": "1.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "48",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Budget analysts": {
    "ageData": {
      "2012": {
        "total": "55",
        "16to19": "0",
        "20to24": "0",
        "25to34": "11",
        "35to44": "14",
        "45to54": "17",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Budget analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "55",
        "women": "52.5",
        "white": "11.5",
        "black": "8.7",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "52",
        "median": "1,207",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Credit analysts": {
    "ageData": {
      "2012": {
        "total": "30",
        "16to19": "0",
        "20to24": "4",
        "25to34": "13",
        "35to44": "6",
        "45to54": "5",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Credit analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Financial analysts": {
    "ageData": {
      "2012": {
        "total": "89",
        "16to19": "0",
        "20to24": "7",
        "25to34": "25",
        "35to44": "27",
        "45to54": "21",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Financial analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "89",
        "women": "36.8",
        "white": "3.7",
        "black": "9.0",
        "asian": "6.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "77",
        "median": "1,487",
        "maleWorkers": "48",
        "maleMedian": "-",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Personal financial advisors": {
    "ageData": {
      "2012": {
        "total": "378",
        "16to19": "0",
        "20to24": "19",
        "25to34": "79",
        "35to44": "87",
        "45to54": "83",
        "55to64": "78",
        "65+": "31",
        "medianAge": "78"
      }
    },
    "title": "Personal financial advisors",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "378",
        "women": "31.2",
        "white": "4.8",
        "black": "6.2",
        "asian": "4.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "278",
        "median": "1,327",
        "maleWorkers": "182",
        "maleMedian": "1,532",
        "femaleWorkers": "96",
        "femaleMedian": "1,016"
      }
    }
  },
  "Insurance underwriters": {
    "ageData": {
      "2012": {
        "total": "103",
        "16to19": "0",
        "20to24": "2",
        "25to34": "23",
        "35to44": "24",
        "45to54": "30",
        "55to64": "21",
        "65+": "3",
        "medianAge": "21"
      }
    },
    "title": "Insurance underwriters",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "103",
        "women": "70.4",
        "white": "10.7",
        "black": "0.7",
        "asian": "10.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "91",
        "median": "954",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "66",
        "femaleMedian": "933"
      }
    }
  },
  "Financial examiners": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "1",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Financial examiners",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Credit counselors and loan officers": {
    "ageData": {
      "2012": {
        "total": "333",
        "16to19": "1",
        "20to24": "13",
        "25to34": "98",
        "35to44": "75",
        "45to54": "83",
        "55to64": "57",
        "65+": "6",
        "medianAge": "57"
      }
    },
    "title": "Credit counselors and loan officers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "333",
        "women": "59.2",
        "white": "13.2",
        "black": "6.0",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "310",
        "median": "934",
        "maleWorkers": "130",
        "maleMedian": "1,074",
        "femaleWorkers": "181",
        "femaleMedian": "850"
      }
    }
  },
  "Tax examiners and collectors, and revenue agents": {
    "ageData": {
      "2012": {
        "total": "82",
        "16to19": "0",
        "20to24": "1",
        "25to34": "14",
        "35to44": "14",
        "45to54": "32",
        "55to64": "17",
        "65+": "4",
        "medianAge": "17"
      }
    },
    "title": "Tax examiners and collectors, and revenue agents",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "82",
        "women": "62.4",
        "white": "13.9",
        "black": "11.5",
        "asian": "13.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "87",
        "median": "937",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "54",
        "femaleMedian": "849"
      }
    }
  },
  "Tax preparers": {
    "ageData": {
      "2012": {
        "total": "107",
        "16to19": "0",
        "20to24": "6",
        "25to34": "12",
        "35to44": "25",
        "45to54": "23",
        "55to64": "23",
        "65+": "17",
        "medianAge": "23"
      }
    },
    "title": "Tax preparers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "107",
        "women": "59.6",
        "white": "10.4",
        "black": "7.1",
        "asian": "15.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "48",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Financial specialists, all other": {
    "ageData": {
      "2012": {
        "total": "82",
        "16to19": "0",
        "20to24": "6",
        "25to34": "18",
        "35to44": "19",
        "45to54": "23",
        "55to64": "14",
        "65+": "3",
        "medianAge": "14"
      }
    },
    "title": "Financial specialists, all other",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "82",
        "women": "66.5",
        "white": "10.9",
        "black": "8.4",
        "asian": "11.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "68",
        "median": "1,025",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "48",
        "femaleMedian": "-"
      }
    }
  },
  "Professional and related occupations": {
    "ageData": {
      "2012": {
        "total": "31,365",
        "16to19": "272",
        "20to24": "1,874",
        "25to34": "7,657",
        "35to44": "7,373",
        "45to54": "7,158",
        "55to64": "5,451",
        "65+": "1,580",
        "medianAge": "5,451"
      }
    },
    "title": "Professional and related occupations",
    "depth": 2,
    "parent": "Management, professional, and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "31,365",
        "women": "57.2",
        "white": "9.3",
        "black": "7.8",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23,993",
        "median": "1,053",
        "maleWorkers": "10,804",
        "maleMedian": "1,267",
        "femaleWorkers": "13,189",
        "femaleMedian": "928"
      }
    }
  },
  "Computer and mathematical occupations": {
    "ageData": {
      "2012": {
        "total": "3,816",
        "16to19": "11",
        "20to24": "213",
        "25to34": "1,062",
        "35to44": "1,103",
        "45to54": "873",
        "55to64": "461",
        "65+": "94",
        "medianAge": "461"
      }
    },
    "title": "Computer and mathematical occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,816",
        "women": "25.6",
        "white": "7.4",
        "black": "17.5",
        "asian": "6.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3,416",
        "median": "1,349",
        "maleWorkers": "2,544",
        "maleMedian": "1,414",
        "femaleWorkers": "872",
        "femaleMedian": "1,146"
      }
    }
  },
  "Computer and information research scientists": {
    "ageData": {
      "2012": {
        "total": "29",
        "16to19": "0",
        "20to24": "3",
        "25to34": "10",
        "35to44": "4",
        "45to54": "10",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Computer and information research scientists",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "27",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Computer systems analysts": {
    "ageData": {
      "2012": {
        "total": "499",
        "16to19": "1",
        "20to24": "17",
        "25to34": "126",
        "35to44": "123",
        "45to54": "134",
        "55to64": "80",
        "65+": "19",
        "medianAge": "80"
      }
    },
    "title": "Computer systems analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "499",
        "women": "30.9",
        "white": "8.8",
        "black": "15.8",
        "asian": "4.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "440",
        "median": "1,406",
        "maleWorkers": "295",
        "maleMedian": "1,477",
        "femaleWorkers": "145",
        "femaleMedian": "1,254"
      }
    }
  },
  "Information security analysts": {
    "ageData": {
      "2012": {
        "total": "52",
        "16to19": "0",
        "20to24": "2",
        "25to34": "14",
        "35to44": "17",
        "45to54": "11",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Information security analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "52",
        "women": "15.1",
        "white": "11.8",
        "black": "14.2",
        "asian": "4.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "51",
        "median": "1,592",
        "maleWorkers": "43",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Computer programmers": {
    "ageData": {
      "2012": {
        "total": "480",
        "16to19": "2",
        "20to24": "33",
        "25to34": "113",
        "35to44": "132",
        "45to54": "124",
        "55to64": "66",
        "65+": "11",
        "medianAge": "66"
      }
    },
    "title": "Computer programmers",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "480",
        "women": "22.5",
        "white": "5.9",
        "black": "17.3",
        "asian": "5.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "439",
        "median": "1,324",
        "maleWorkers": "340",
        "maleMedian": "1,363",
        "femaleWorkers": "100",
        "femaleMedian": "1,148"
      }
    }
  },
  "Software developers, applications and systems software": {
    "ageData": {
      "2012": {
        "total": "1,084",
        "16to19": "1",
        "20to24": "53",
        "25to34": "338",
        "35to44": "348",
        "45to54": "226",
        "55to64": "102",
        "65+": "16",
        "medianAge": "102"
      }
    },
    "title": "Software developers, applications and systems software",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,084",
        "women": "19.7",
        "white": "4.0",
        "black": "29.4",
        "asian": "5.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,005",
        "median": "1,591",
        "maleWorkers": "808",
        "maleMedian": "1,674",
        "femaleWorkers": "197",
        "femaleMedian": "1,362"
      }
    }
  },
  "Web developers": {
    "ageData": {
      "2012": {
        "total": "190",
        "16to19": "1",
        "20to24": "21",
        "25to34": "72",
        "35to44": "48",
        "45to54": "28",
        "55to64": "16",
        "65+": "4",
        "medianAge": "16"
      }
    },
    "title": "Web developers",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "190",
        "women": "33.7",
        "white": "4.1",
        "black": "8.0",
        "asian": "5.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "123",
        "median": "1,082",
        "maleWorkers": "86",
        "maleMedian": "1,204",
        "femaleWorkers": "36",
        "femaleMedian": "-"
      }
    }
  },
  "Computer support specialists": {
    "ageData": {
      "2012": {
        "total": "476",
        "16to19": "3",
        "20to24": "45",
        "25to34": "130",
        "35to44": "127",
        "45to54": "90",
        "55to64": "72",
        "65+": "9",
        "medianAge": "72"
      }
    },
    "title": "Computer support specialists",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "476",
        "women": "27.1",
        "white": "12.0",
        "black": "7.7",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "429",
        "median": "960",
        "maleWorkers": "313",
        "maleMedian": "985",
        "femaleWorkers": "116",
        "femaleMedian": "881"
      }
    }
  },
  "Database administrators": {
    "ageData": {
      "2012": {
        "total": "101",
        "16to19": "0",
        "20to24": "1",
        "25to34": "14",
        "35to44": "35",
        "45to54": "36",
        "55to64": "12",
        "65+": "3",
        "medianAge": "12"
      }
    },
    "title": "Database administrators",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "101",
        "women": "36.6",
        "white": "4.1",
        "black": "10.0",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "97",
        "median": "1,376",
        "maleWorkers": "57",
        "maleMedian": "1,657",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Network and computer systems administrators": {
    "ageData": {
      "2012": {
        "total": "226",
        "16to19": "0",
        "20to24": "9",
        "25to34": "70",
        "35to44": "81",
        "45to54": "38",
        "55to64": "24",
        "65+": "4",
        "medianAge": "24"
      }
    },
    "title": "Network and computer systems administrators",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "226",
        "women": "25.0",
        "white": "10.0",
        "black": "11.0",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "204",
        "median": "1,191",
        "maleWorkers": "153",
        "maleMedian": "1,253",
        "femaleWorkers": "51",
        "femaleMedian": "1,056"
      }
    }
  },
  "Computer network architects": {
    "ageData": {
      "2012": {
        "total": "127",
        "16to19": "1",
        "20to24": "1",
        "25to34": "26",
        "35to44": "49",
        "45to54": "39",
        "55to64": "5",
        "65+": "6",
        "medianAge": "5"
      }
    },
    "title": "Computer network architects",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "127",
        "women": "8.1",
        "white": "10.0",
        "black": "14.6",
        "asian": "4.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "115",
        "median": "1,548",
        "maleWorkers": "104",
        "maleMedian": "1,569",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Computer occupations, all other": {
    "ageData": {
      "2012": {
        "total": "341",
        "16to19": "3",
        "20to24": "20",
        "25to34": "86",
        "35to44": "89",
        "45to54": "88",
        "55to64": "44",
        "65+": "12",
        "medianAge": "44"
      }
    },
    "title": "Computer occupations, all other",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "341",
        "women": "24.4",
        "white": "11.4",
        "black": "11.7",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "288",
        "median": "1,110",
        "maleWorkers": "223",
        "maleMedian": "1,155",
        "femaleWorkers": "65",
        "femaleMedian": "887"
      }
    }
  },
  "Actuaries": {
    "ageData": {
      "2012": {
        "total": "26",
        "16to19": "0",
        "20to24": "1",
        "25to34": "8",
        "35to44": "4",
        "45to54": "6",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Actuaries",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "26",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "19",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Mathematicians": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Mathematicians",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Operations research analysts": {
    "ageData": {
      "2012": {
        "total": "130",
        "16to19": "0",
        "20to24": "3",
        "25to34": "38",
        "35to44": "29",
        "45to54": "32",
        "55to64": "21",
        "65+": "7",
        "medianAge": "21"
      }
    },
    "title": "Operations research analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "130",
        "women": "54.9",
        "white": "8.3",
        "black": "9.3",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "127",
        "median": "1,334",
        "maleWorkers": "57",
        "maleMedian": "1,551",
        "femaleWorkers": "70",
        "femaleMedian": "1,169"
      }
    }
  },
  "Statisticians": {
    "ageData": {
      "2012": {
        "total": "47",
        "16to19": "0",
        "20to24": "1",
        "25to34": "16",
        "35to44": "15",
        "45to54": "10",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Statisticians",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous mathematical science occupations": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Miscellaneous mathematical science occupations",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Architecture and engineering occupations": {
    "ageData": {
      "2012": {
        "total": "2,846",
        "16to19": "11",
        "20to24": "158",
        "25to34": "650",
        "35to44": "628",
        "45to54": "768",
        "55to64": "513",
        "65+": "120",
        "medianAge": "513"
      }
    },
    "title": "Architecture and engineering occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,846",
        "women": "13.7",
        "white": "5.6",
        "black": "10.8",
        "asian": "7.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,588",
        "median": "1,337",
        "maleWorkers": "2,269",
        "maleMedian": "1,358",
        "femaleWorkers": "319",
        "femaleMedian": "1,136"
      }
    }
  },
  "Architects, except naval": {
    "ageData": {
      "2012": {
        "total": "195",
        "16to19": "0",
        "20to24": "3",
        "25to34": "45",
        "35to44": "42",
        "45to54": "55",
        "55to64": "42",
        "65+": "8",
        "medianAge": "42"
      }
    },
    "title": "Architects, except naval",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "195",
        "women": "23.5",
        "white": "1.3",
        "black": "6.2",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "130",
        "median": "1,325",
        "maleWorkers": "102",
        "maleMedian": "1,415",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Surveyors, cartographers, and photogrammetrists": {
    "ageData": {
      "2012": {
        "total": "51",
        "16to19": "0",
        "20to24": "2",
        "25to34": "12",
        "35to44": "11",
        "45to54": "13",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Surveyors, cartographers, and photogrammetrists",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "51",
        "women": "27.8",
        "white": "4.3",
        "black": "5.4",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "45",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Aerospace engineers": {
    "ageData": {
      "2012": {
        "total": "119",
        "16to19": "0",
        "20to24": "4",
        "25to34": "23",
        "35to44": "30",
        "45to54": "34",
        "55to64": "24",
        "65+": "5",
        "medianAge": "24"
      }
    },
    "title": "Aerospace engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "119",
        "women": "9.0",
        "white": "1.8",
        "black": "13.4",
        "asian": "4.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "120",
        "median": "1,645",
        "maleWorkers": "111",
        "maleMedian": "1,665",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural engineers": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Agricultural engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Biomedical engineers": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "3",
        "45to54": "4",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Biomedical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical engineers": {
    "ageData": {
      "2012": {
        "total": "71",
        "16to19": "0",
        "20to24": "6",
        "25to34": "17",
        "35to44": "20",
        "45to54": "14",
        "55to64": "12",
        "65+": "2",
        "medianAge": "12"
      }
    },
    "title": "Chemical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "71",
        "women": "17.7",
        "white": "5.9",
        "black": "9.3",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "71",
        "median": "1,509",
        "maleWorkers": "61",
        "maleMedian": "1,582",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Civil engineers": {
    "ageData": {
      "2012": {
        "total": "358",
        "16to19": "1",
        "20to24": "25",
        "25to34": "91",
        "35to44": "81",
        "45to54": "85",
        "55to64": "57",
        "65+": "18",
        "medianAge": "57"
      }
    },
    "title": "Civil engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "358",
        "women": "13.7",
        "white": "5.4",
        "black": "9.0",
        "asian": "3.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "334",
        "median": "1,367",
        "maleWorkers": "287",
        "maleMedian": "1,428",
        "femaleWorkers": "47",
        "femaleMedian": "-"
      }
    }
  },
  "Computer hardware engineers": {
    "ageData": {
      "2012": {
        "total": "91",
        "16to19": "0",
        "20to24": "3",
        "25to34": "34",
        "35to44": "16",
        "45to54": "26",
        "55to64": "11",
        "65+": "1",
        "medianAge": "11"
      }
    },
    "title": "Computer hardware engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "91",
        "women": "15.1",
        "white": "8.5",
        "black": "20.8",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "73",
        "median": "1,548",
        "maleWorkers": "66",
        "maleMedian": "1,571",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics engineers": {
    "ageData": {
      "2012": {
        "total": "335",
        "16to19": "0",
        "20to24": "10",
        "25to34": "66",
        "35to44": "78",
        "45to54": "102",
        "55to64": "60",
        "65+": "19",
        "medianAge": "60"
      }
    },
    "title": "Electrical and electronics engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "335",
        "women": "9.0",
        "white": "3.5",
        "black": "16.6",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "311",
        "median": "1,550",
        "maleWorkers": "284",
        "maleMedian": "1,614",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Environmental engineers": {
    "ageData": {
      "2012": {
        "total": "43",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "14",
        "45to54": "10",
        "55to64": "9",
        "65+": "4",
        "medianAge": "9"
      }
    },
    "title": "Environmental engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "43",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial engineers, including health and safety": {
    "ageData": {
      "2012": {
        "total": "197",
        "16to19": "0",
        "20to24": "16",
        "25to34": "43",
        "35to44": "41",
        "45to54": "54",
        "55to64": "39",
        "65+": "4",
        "medianAge": "39"
      }
    },
    "title": "Industrial engineers, including health and safety",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "197",
        "women": "18.8",
        "white": "6.2",
        "black": "9.6",
        "asian": "10.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "202",
        "median": "1,393",
        "maleWorkers": "167",
        "maleMedian": "1,408",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "Marine engineers and naval architects": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "3",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Marine engineers and naval architects",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Materials engineers": {
    "ageData": {
      "2012": {
        "total": "40",
        "16to19": "1",
        "20to24": "2",
        "25to34": "12",
        "35to44": "7",
        "45to54": "12",
        "55to64": "4",
        "65+": "2",
        "medianAge": "4"
      }
    },
    "title": "Materials engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "36",
        "median": "-",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Mechanical engineers": {
    "ageData": {
      "2012": {
        "total": "288",
        "16to19": "1",
        "20to24": "26",
        "25to34": "63",
        "35to44": "63",
        "45to54": "83",
        "55to64": "43",
        "65+": "10",
        "medianAge": "43"
      }
    },
    "title": "Mechanical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "288",
        "women": "4.5",
        "white": "6.3",
        "black": "12.3",
        "asian": "4.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "280",
        "median": "1,434",
        "maleWorkers": "270",
        "maleMedian": "1,442",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Mining and geological engineers, including mining safety engineers": {
    "ageData": {
      "2012": {
        "total": "9",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "1",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Mining and geological engineers, including mining safety engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Nuclear engineers": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "1",
        "45to54": "5",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Nuclear engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Petroleum engineers": {
    "ageData": {
      "2012": {
        "total": "38",
        "16to19": "0",
        "20to24": "7",
        "25to34": "8",
        "35to44": "8",
        "45to54": "6",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Petroleum engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Engineers, all other": {
    "ageData": {
      "2012": {
        "total": "359",
        "16to19": "1",
        "20to24": "10",
        "25to34": "90",
        "35to44": "84",
        "45to54": "97",
        "55to64": "55",
        "65+": "22",
        "medianAge": "55"
      }
    },
    "title": "Engineers, all other",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "359",
        "women": "13.2",
        "white": "3.9",
        "black": "15.4",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "315",
        "median": "1,439",
        "maleWorkers": "275",
        "maleMedian": "1,456",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Drafters": {
    "ageData": {
      "2012": {
        "total": "149",
        "16to19": "1",
        "20to24": "6",
        "25to34": "41",
        "35to44": "35",
        "45to54": "32",
        "55to64": "30",
        "65+": "4",
        "medianAge": "30"
      }
    },
    "title": "Drafters",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "149",
        "women": "16.6",
        "white": "3.0",
        "black": "7.7",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "129",
        "median": "962",
        "maleWorkers": "108",
        "maleMedian": "958",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Engineering technicians, except drafters": {
    "ageData": {
      "2012": {
        "total": "395",
        "16to19": "5",
        "20to24": "32",
        "25to34": "66",
        "35to44": "77",
        "45to54": "114",
        "55to64": "87",
        "65+": "14",
        "medianAge": "87"
      }
    },
    "title": "Engineering technicians, except drafters",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "395",
        "women": "16.3",
        "white": "10.8",
        "black": "5.0",
        "asian": "12.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "360",
        "median": "989",
        "maleWorkers": "312",
        "maleMedian": "1,008",
        "femaleWorkers": "48",
        "femaleMedian": "-"
      }
    }
  },
  "Surveying and mapping technicians": {
    "ageData": {
      "2012": {
        "total": "77",
        "16to19": "0",
        "20to24": "4",
        "25to34": "20",
        "35to44": "14",
        "45to54": "18",
        "55to64": "18",
        "65+": "3",
        "medianAge": "18"
      }
    },
    "title": "Surveying and mapping technicians",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "77",
        "women": "4.3",
        "white": "5.3",
        "black": "2.5",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "67",
        "median": "885",
        "maleWorkers": "63",
        "maleMedian": "891",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Life, physical, and social science occupations": {
    "ageData": {
      "2012": {
        "total": "1,316",
        "16to19": "8",
        "20to24": "82",
        "25to34": "375",
        "35to44": "284",
        "45to54": "295",
        "55to64": "210",
        "65+": "62",
        "medianAge": "210"
      }
    },
    "title": "Life, physical, and social science occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,316",
        "women": "45.3",
        "white": "6.5",
        "black": "9.9",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,098",
        "median": "1,134",
        "maleWorkers": "631",
        "maleMedian": "1,226",
        "femaleWorkers": "467",
        "femaleMedian": "1,015"
      }
    }
  },
  "Agricultural and food scientists": {
    "ageData": {
      "2012": {
        "total": "42",
        "16to19": "0",
        "20to24": "3",
        "25to34": "8",
        "35to44": "9",
        "45to54": "9",
        "55to64": "9",
        "65+": "4",
        "medianAge": "9"
      }
    },
    "title": "Agricultural and food scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "34",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Biological scientists": {
    "ageData": {
      "2012": {
        "total": "101",
        "16to19": "0",
        "20to24": "7",
        "25to34": "28",
        "35to44": "21",
        "45to54": "22",
        "55to64": "20",
        "65+": "3",
        "medianAge": "20"
      }
    },
    "title": "Biological scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "101",
        "women": "50.1",
        "white": "3.7",
        "black": "11.7",
        "asian": "7.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "94",
        "median": "1,181",
        "maleWorkers": "51",
        "maleMedian": "1,331",
        "femaleWorkers": "43",
        "femaleMedian": "-"
      }
    }
  },
  "Conservation scientists and foresters": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "6",
        "45to54": "5",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Conservation scientists and foresters",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Medical scientists": {
    "ageData": {
      "2012": {
        "total": "136",
        "16to19": "0",
        "20to24": "4",
        "25to34": "39",
        "35to44": "38",
        "45to54": "32",
        "55to64": "20",
        "65+": "3",
        "medianAge": "20"
      }
    },
    "title": "Medical scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "136",
        "women": "52.8",
        "white": "5.3",
        "black": "22.4",
        "asian": "5.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "123",
        "median": "1,163",
        "maleWorkers": "64",
        "maleMedian": "1,331",
        "femaleWorkers": "59",
        "femaleMedian": "1,060"
      }
    }
  },
  "Life scientists, all other": {
    "ageData": {
      "2012": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Life scientists, all other",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    }
  },
  "Astronomers and physicists": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "3",
        "45to54": "10",
        "55to64": "4",
        "65+": "5",
        "medianAge": "4"
      }
    },
    "title": "Astronomers and physicists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Atmospheric and space scientists": {
    "ageData": {
      "2012": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "3",
        "45to54": "6",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Atmospheric and space scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Chemists and materials scientists": {
    "ageData": {
      "2012": {
        "total": "105",
        "16to19": "0",
        "20to24": "9",
        "25to34": "32",
        "35to44": "22",
        "45to54": "29",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Chemists and materials scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "105",
        "women": "44.2",
        "white": "4.0",
        "black": "9.2",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "98",
        "median": "1,163",
        "maleWorkers": "56",
        "maleMedian": "1,226",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Environmental scientists and geoscientists": {
    "ageData": {
      "2012": {
        "total": "105",
        "16to19": "0",
        "20to24": "3",
        "25to34": "31",
        "35to44": "22",
        "45to54": "28",
        "55to64": "16",
        "65+": "5",
        "medianAge": "16"
      }
    },
    "title": "Environmental scientists and geoscientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "105",
        "women": "25.7",
        "white": "7.0",
        "black": "1.3",
        "asian": "1.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "93",
        "median": "1,266",
        "maleWorkers": "68",
        "maleMedian": "1,390",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Physical scientists, all other": {
    "ageData": {
      "2012": {
        "total": "154",
        "16to19": "0",
        "20to24": "9",
        "25to34": "48",
        "35to44": "42",
        "45to54": "24",
        "55to64": "22",
        "65+": "9",
        "medianAge": "22"
      }
    },
    "title": "Physical scientists, all other",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "154",
        "women": "35.1",
        "white": "2.7",
        "black": "20.4",
        "asian": "3.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "145",
        "median": "1,456",
        "maleWorkers": "96",
        "maleMedian": "1,522",
        "femaleWorkers": "50",
        "femaleMedian": "1,171"
      }
    }
  },
  "Economists": {
    "ageData": {
      "2012": {
        "total": "26",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "6",
        "45to54": "5",
        "55to64": "6",
        "65+": "3",
        "medianAge": "6"
      }
    },
    "title": "Economists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "26",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Survey researchers": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Survey researchers",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Psychologists": {
    "ageData": {
      "2012": {
        "total": "178",
        "16to19": "0",
        "20to24": "0",
        "25to34": "43",
        "35to44": "38",
        "45to54": "34",
        "55to64": "46",
        "65+": "18",
        "medianAge": "46"
      }
    },
    "title": "Psychologists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "178",
        "women": "72.7",
        "white": "6.0",
        "black": "3.9",
        "asian": "6.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "93",
        "median": "1,228",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "72",
        "femaleMedian": "1,155"
      }
    }
  },
  "Sociologists": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Sociologists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Urban and regional planners": {
    "ageData": {
      "2012": {
        "total": "28",
        "16to19": "0",
        "20to24": "0",
        "25to34": "13",
        "35to44": "7",
        "45to54": "4",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Urban and regional planners",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "28",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous social scientists and related workers": {
    "ageData": {
      "2012": {
        "total": "57",
        "16to19": "0",
        "20to24": "1",
        "25to34": "17",
        "35to44": "16",
        "45to54": "13",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Miscellaneous social scientists and related workers",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "57",
        "women": "54.3",
        "white": "10.8",
        "black": "5.5",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "22",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural and food science technicians": {
    "ageData": {
      "2012": {
        "total": "32",
        "16to19": "0",
        "20to24": "2",
        "25to34": "11",
        "35to44": "4",
        "45to54": "8",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Agricultural and food science technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Biological technicians": {
    "ageData": {
      "2012": {
        "total": "19",
        "16to19": "0",
        "20to24": "2",
        "25to34": "5",
        "35to44": "3",
        "45to54": "6",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Biological technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical technicians": {
    "ageData": {
      "2012": {
        "total": "70",
        "16to19": "0",
        "20to24": "5",
        "25to34": "26",
        "35to44": "8",
        "45to54": "18",
        "55to64": "10",
        "65+": "2",
        "medianAge": "10"
      }
    },
    "title": "Chemical technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "70",
        "women": "29.9",
        "white": "15.4",
        "black": "4.8",
        "asian": "7.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "62",
        "median": "779",
        "maleWorkers": "45",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Geological and petroleum technicians": {
    "ageData": {
      "2012": {
        "total": "21",
        "16to19": "0",
        "20to24": "2",
        "25to34": "7",
        "35to44": "3",
        "45to54": "8",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Geological and petroleum technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Nuclear technicians": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Nuclear technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Social science research assistants": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Social science research assistants",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous life, physical, and social science technicians": {
    "ageData": {
      "2012": {
        "total": "160",
        "16to19": "7",
        "20to24": "31",
        "25to34": "44",
        "35to44": "30",
        "45to54": "30",
        "55to64": "15",
        "65+": "3",
        "medianAge": "15"
      }
    },
    "title": "Miscellaneous life, physical, and social science technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "160",
        "women": "52.8",
        "white": "12.8",
        "black": "14.4",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "128",
        "median": "745",
        "maleWorkers": "62",
        "maleMedian": "825",
        "femaleWorkers": "66",
        "femaleMedian": "620"
      }
    }
  },
  "Community and social service occupations": {
    "ageData": {
      "2012": {
        "total": "2,265",
        "16to19": "15",
        "20to24": "127",
        "25to34": "508",
        "35to44": "507",
        "45to54": "477",
        "55to64": "468",
        "65+": "162",
        "medianAge": "468"
      }
    },
    "title": "Community and social service occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,265",
        "women": "63.8",
        "white": "18.8",
        "black": "3.2",
        "asian": "11.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,891",
        "median": "838",
        "maleWorkers": "714",
        "maleMedian": "869",
        "femaleWorkers": "1,177",
        "femaleMedian": "820"
      }
    }
  },
  "Counselors": {
    "ageData": {
      "2012": {
        "total": "661",
        "16to19": "5",
        "20to24": "43",
        "25to34": "157",
        "35to44": "152",
        "45to54": "127",
        "55to64": "140",
        "65+": "35",
        "medianAge": "140"
      }
    },
    "title": "Counselors",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "661",
        "women": "69.3",
        "white": "19.4",
        "black": "2.9",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "519",
        "median": "848",
        "maleWorkers": "172",
        "maleMedian": "833",
        "femaleWorkers": "347",
        "femaleMedian": "855"
      }
    }
  },
  "Social workers": {
    "ageData": {
      "2012": {
        "total": "734",
        "16to19": "2",
        "20to24": "34",
        "25to34": "195",
        "35to44": "205",
        "45to54": "159",
        "55to64": "115",
        "65+": "23",
        "medianAge": "115"
      }
    },
    "title": "Social workers",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "734",
        "women": "80.6",
        "white": "23.0",
        "black": "3.1",
        "asian": "12.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "668",
        "median": "847",
        "maleWorkers": "134",
        "maleMedian": "856",
        "femaleWorkers": "535",
        "femaleMedian": "845"
      }
    }
  },
  "Probation officers and correctional treatment specialists": {
    "ageData": {
      "2012": {
        "total": "88",
        "16to19": "0",
        "20to24": "3",
        "25to34": "26",
        "35to44": "30",
        "45to54": "17",
        "55to64": "11",
        "65+": "1",
        "medianAge": "11"
      }
    },
    "title": "Probation officers and correctional treatment specialists",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "88",
        "women": "47.5",
        "white": "20.7",
        "black": "1.3",
        "asian": "15.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "85",
        "median": "948",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Social and human service assistants": {
    "ageData": {
      "2012": {
        "total": "151",
        "16to19": "1",
        "20to24": "18",
        "25to34": "39",
        "35to44": "27",
        "45to54": "22",
        "55to64": "35",
        "65+": "9",
        "medianAge": "35"
      }
    },
    "title": "Social and human service assistants",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "151",
        "women": "77.1",
        "white": "24.4",
        "black": "3.8",
        "asian": "15.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "124",
        "median": "637",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "99",
        "femaleMedian": "656"
      }
    }
  },
  "Miscellaneous community and social service specialists, including health educators and community health workers": {
    "ageData": {
      "2012": {
        "total": "94",
        "16to19": "1",
        "20to24": "7",
        "25to34": "21",
        "35to44": "15",
        "45to54": "30",
        "55to64": "14",
        "65+": "5",
        "medianAge": "14"
      }
    },
    "title": "Miscellaneous community and social service specialists, including health educators and community health workers",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "94",
        "women": "75.7",
        "white": "16.9",
        "black": "2.4",
        "asian": "18.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "74",
        "median": "667",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "51",
        "femaleMedian": "642"
      }
    }
  },
  "Clergy": {
    "ageData": {
      "2012": {
        "total": "408",
        "16to19": "2",
        "20to24": "10",
        "25to34": "49",
        "35to44": "62",
        "45to54": "94",
        "55to64": "120",
        "65+": "70",
        "medianAge": "120"
      }
    },
    "title": "Clergy",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "408",
        "women": "20.5",
        "white": "11.2",
        "black": "4.2",
        "asian": "6.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "344",
        "median": "895",
        "maleWorkers": "281",
        "maleMedian": "959",
        "femaleWorkers": "63",
        "femaleMedian": "777"
      }
    }
  },
  "Directors, religious activities and education": {
    "ageData": {
      "2012": {
        "total": "61",
        "16to19": "0",
        "20to24": "2",
        "25to34": "13",
        "35to44": "9",
        "45to54": "16",
        "55to64": "15",
        "65+": "6",
        "medianAge": "15"
      }
    },
    "title": "Directors, religious activities and education",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "61",
        "women": "66.3",
        "white": "7.4",
        "black": "2.1",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Religious workers, all other": {
    "ageData": {
      "2012": {
        "total": "69",
        "16to19": "3",
        "20to24": "9",
        "25to34": "8",
        "35to44": "7",
        "45to54": "13",
        "55to64": "17",
        "65+": "12",
        "medianAge": "17"
      }
    },
    "title": "Religious workers, all other",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "69",
        "women": "62.4",
        "white": "10.0",
        "black": "2.8",
        "asian": "8.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "40",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Legal occupations": {
    "ageData": {
      "2012": {
        "total": "1,786",
        "16to19": "5",
        "20to24": "49",
        "25to34": "385",
        "35to44": "415",
        "45to54": "421",
        "55to64": "354",
        "65+": "156",
        "medianAge": "354"
      }
    },
    "title": "Legal occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,786",
        "women": "50.4",
        "white": "7.1",
        "black": "3.9",
        "asian": "7.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,315",
        "median": "1,328",
        "maleWorkers": "600",
        "maleMedian": "1,884",
        "femaleWorkers": "716",
        "femaleMedian": "1,013"
      }
    }
  },
  "Lawyers": {
    "ageData": {
      "2012": {
        "total": "1,061",
        "16to19": "0",
        "20to24": "1",
        "25to34": "213",
        "35to44": "258",
        "45to54": "240",
        "55to64": "223",
        "65+": "125",
        "medianAge": "223"
      }
    },
    "title": "Lawyers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,061",
        "women": "31.1",
        "white": "4.4",
        "black": "4.3",
        "asian": "4.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "690",
        "median": "1,909",
        "maleWorkers": "462",
        "maleMedian": "2,055",
        "femaleWorkers": "228",
        "femaleMedian": "1,636"
      }
    }
  },
  "Judicial law clerks": {
    "ageData": {
      "2012": {
        "total": "17",
        "16to19": "0",
        "20to24": "2",
        "25to34": "5",
        "35to44": "2",
        "45to54": "2",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Judicial law clerks",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Judges, magistrates, and other judicial workers": {
    "ageData": {
      "2012": {
        "total": "67",
        "16to19": "0",
        "20to24": "0",
        "25to34": "9",
        "35to44": "9",
        "45to54": "16",
        "55to64": "26",
        "65+": "8",
        "medianAge": "26"
      }
    },
    "title": "Judges, magistrates, and other judicial workers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "67",
        "women": "39.0",
        "white": "12.8",
        "black": "0.7",
        "asian": "4.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "64",
        "median": "1,637",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Paralegals and legal assistants": {
    "ageData": {
      "2012": {
        "total": "418",
        "16to19": "3",
        "20to24": "38",
        "25to34": "104",
        "35to44": "97",
        "45to54": "100",
        "55to64": "62",
        "65+": "13",
        "medianAge": "62"
      }
    },
    "title": "Paralegals and legal assistants",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "418",
        "women": "85.9",
        "white": "10.7",
        "black": "4.6",
        "asian": "17.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "372",
        "median": "872",
        "maleWorkers": "54",
        "maleMedian": "919",
        "femaleWorkers": "317",
        "femaleMedian": "865"
      }
    }
  },
  "Miscellaneous legal support workers": {
    "ageData": {
      "2012": {
        "total": "223",
        "16to19": "1",
        "20to24": "8",
        "25to34": "55",
        "35to44": "49",
        "45to54": "63",
        "55to64": "38",
        "65+": "9",
        "medianAge": "38"
      }
    },
    "title": "Miscellaneous legal support workers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "223",
        "women": "79.0",
        "white": "11.9",
        "black": "1.4",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "181",
        "median": "815",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "139",
        "femaleMedian": "754"
      }
    }
  },
  "Education, training, and library occupations": {
    "ageData": {
      "2012": {
        "total": "8,543",
        "16to19": "114",
        "20to24": "602",
        "25to34": "2,003",
        "35to44": "1,877",
        "45to54": "1,937",
        "55to64": "1,543",
        "65+": "468",
        "medianAge": "1,543"
      }
    },
    "title": "Education, training, and library occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8,543",
        "women": "73.6",
        "white": "9.5",
        "black": "4.3",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6,454",
        "median": "915",
        "maleWorkers": "1,766",
        "maleMedian": "1,133",
        "femaleWorkers": "4,687",
        "femaleMedian": "858"
      }
    }
  },
  "Postsecondary teachers": {
    "ageData": {
      "2012": {
        "total": "1,350",
        "16to19": "6",
        "20to24": "95",
        "25to34": "304",
        "35to44": "262",
        "45to54": "274",
        "55to64": "274",
        "65+": "136",
        "medianAge": "274"
      }
    },
    "title": "Postsecondary teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,350",
        "women": "48.2",
        "white": "7.9",
        "black": "11.3",
        "asian": "6.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "920",
        "median": "1,216",
        "maleWorkers": "497",
        "maleMedian": "1,366",
        "femaleWorkers": "424",
        "femaleMedian": "1,055"
      }
    }
  },
  "Preschool and kindergarten teachers": {
    "ageData": {
      "2012": {
        "total": "678",
        "16to19": "15",
        "20to24": "70",
        "25to34": "183",
        "35to44": "161",
        "45to54": "145",
        "55to64": "82",
        "65+": "22",
        "medianAge": "82"
      }
    },
    "title": "Preschool and kindergarten teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "678",
        "women": "98.1",
        "white": "11.8",
        "black": "4.2",
        "asian": "12.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "494",
        "median": "589",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "485",
        "femaleMedian": "588"
      }
    }
  },
  "Elementary and middle school teachers": {
    "ageData": {
      "2012": {
        "total": "2,838",
        "16to19": "8",
        "20to24": "117",
        "25to34": "722",
        "35to44": "731",
        "45to54": "647",
        "55to64": "502",
        "65+": "111",
        "medianAge": "502"
      }
    },
    "title": "Elementary and middle school teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,838",
        "women": "81.4",
        "white": "9.8",
        "black": "2.1",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,435",
        "median": "942",
        "maleWorkers": "464",
        "maleMedian": "1,128",
        "femaleWorkers": "1,971",
        "femaleMedian": "921"
      }
    }
  },
  "Secondary school teachers": {
    "ageData": {
      "2012": {
        "total": "1,127",
        "16to19": "3",
        "20to24": "53",
        "25to34": "303",
        "35to44": "272",
        "45to54": "268",
        "55to64": "184",
        "65+": "44",
        "medianAge": "184"
      }
    },
    "title": "Secondary school teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,127",
        "women": "57.3",
        "white": "6.0",
        "black": "3.1",
        "asian": "7.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,043",
        "median": "1,009",
        "maleWorkers": "465",
        "maleMedian": "1,050",
        "femaleWorkers": "578",
        "femaleMedian": "978"
      }
    }
  },
  "Special education teachers": {
    "ageData": {
      "2012": {
        "total": "366",
        "16to19": "3",
        "20to24": "13",
        "25to34": "94",
        "35to44": "70",
        "45to54": "106",
        "55to64": "67",
        "65+": "14",
        "medianAge": "67"
      }
    },
    "title": "Special education teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "366",
        "women": "86.2",
        "white": "6.9",
        "black": "1.1",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "307",
        "median": "944",
        "maleWorkers": "43",
        "maleMedian": "-",
        "femaleWorkers": "264",
        "femaleMedian": "940"
      }
    }
  },
  "Other teachers and instructors": {
    "ageData": {
      "2012": {
        "total": "860",
        "16to19": "48",
        "20to24": "137",
        "25to34": "178",
        "35to44": "126",
        "45to54": "144",
        "55to64": "158",
        "65+": "69",
        "medianAge": "158"
      }
    },
    "title": "Other teachers and instructors",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "860",
        "women": "65.6",
        "white": "10.7",
        "black": "5.9",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "372",
        "median": "785",
        "maleWorkers": "151",
        "maleMedian": "917",
        "femaleWorkers": "220",
        "femaleMedian": "729"
      }
    }
  },
  "Archivists, curators, and museum technicians": {
    "ageData": {
      "2012": {
        "total": "46",
        "16to19": "1",
        "20to24": "3",
        "25to34": "5",
        "35to44": "10",
        "45to54": "10",
        "55to64": "12",
        "65+": "6",
        "medianAge": "12"
      }
    },
    "title": "Archivists, curators, and museum technicians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "40",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Librarians": {
    "ageData": {
      "2012": {
        "total": "181",
        "16to19": "1",
        "20to24": "7",
        "25to34": "24",
        "35to44": "31",
        "45to54": "46",
        "55to64": "57",
        "65+": "15",
        "medianAge": "57"
      }
    },
    "title": "Librarians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "181",
        "women": "86.8",
        "white": "7.9",
        "black": "2.5",
        "asian": "2.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "143",
        "median": "966",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "120",
        "femaleMedian": "960"
      }
    }
  },
  "Library technicians": {
    "ageData": {
      "2012": {
        "total": "45",
        "16to19": "6",
        "20to24": "7",
        "25to34": "8",
        "35to44": "6",
        "45to54": "5",
        "55to64": "12",
        "65+": "1",
        "medianAge": "12"
      }
    },
    "title": "Library technicians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Teacher assistants": {
    "ageData": {
      "2012": {
        "total": "898",
        "16to19": "18",
        "20to24": "92",
        "25to34": "152",
        "35to44": "180",
        "45to54": "254",
        "55to64": "164",
        "65+": "36",
        "medianAge": "164"
      }
    },
    "title": "Teacher assistants",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "898",
        "women": "91.1",
        "white": "14.5",
        "black": "2.7",
        "asian": "15.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "567",
        "median": "458",
        "maleWorkers": "51",
        "maleMedian": "493",
        "femaleWorkers": "515",
        "femaleMedian": "452"
      }
    }
  },
  "Other education, training, and library workers": {
    "ageData": {
      "2012": {
        "total": "153",
        "16to19": "3",
        "20to24": "8",
        "25to34": "31",
        "35to44": "29",
        "45to54": "37",
        "55to64": "31",
        "65+": "14",
        "medianAge": "31"
      }
    },
    "title": "Other education, training, and library workers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "153",
        "women": "67.3",
        "white": "11.7",
        "black": "2.5",
        "asian": "11.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "110",
        "median": "1,011",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "72",
        "femaleMedian": "932"
      }
    }
  },
  "Arts, design, entertainment, sports, and media occupations": {
    "ageData": {
      "2012": {
        "total": "2,814",
        "16to19": "78",
        "20to24": "285",
        "25to34": "706",
        "35to44": "592",
        "45to54": "564",
        "55to64": "415",
        "65+": "175",
        "medianAge": "415"
      }
    },
    "title": "Arts, design, entertainment, sports, and media occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,814",
        "women": "48.3",
        "white": "6.0",
        "black": "5.2",
        "asian": "8.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,440",
        "median": "969",
        "maleWorkers": "809",
        "maleMedian": "1,055",
        "femaleWorkers": "631",
        "femaleMedian": "885"
      }
    }
  },
  "Artists and related workers": {
    "ageData": {
      "2012": {
        "total": "212",
        "16to19": "0",
        "20to24": "10",
        "25to34": "44",
        "35to44": "53",
        "45to54": "42",
        "55to64": "46",
        "65+": "17",
        "medianAge": "46"
      }
    },
    "title": "Artists and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "212",
        "women": "51.6",
        "white": "4.0",
        "black": "9.3",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "68",
        "median": "1,131",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Designers": {
    "ageData": {
      "2012": {
        "total": "756",
        "16to19": "7",
        "20to24": "61",
        "25to34": "196",
        "35to44": "174",
        "45to54": "176",
        "55to64": "107",
        "65+": "35",
        "medianAge": "107"
      }
    },
    "title": "Designers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "756",
        "women": "55.3",
        "white": "3.9",
        "black": "5.9",
        "asian": "8.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "467",
        "median": "953",
        "maleWorkers": "241",
        "maleMedian": "1,028",
        "femaleWorkers": "226",
        "femaleMedian": "855"
      }
    }
  },
  "Actors": {
    "ageData": {
      "2012": {
        "total": "37",
        "16to19": "2",
        "20to24": "7",
        "25to34": "10",
        "35to44": "9",
        "45to54": "5",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Actors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Producers and directors": {
    "ageData": {
      "2012": {
        "total": "121",
        "16to19": "0",
        "20to24": "10",
        "25to34": "37",
        "35to44": "28",
        "45to54": "22",
        "55to64": "19",
        "65+": "4",
        "medianAge": "19"
      }
    },
    "title": "Producers and directors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "121",
        "women": "40.8",
        "white": "8.2",
        "black": "3.3",
        "asian": "4.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "75",
        "median": "1,048",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "Athletes, coaches, umpires, and related workers": {
    "ageData": {
      "2012": {
        "total": "267",
        "16to19": "44",
        "20to24": "60",
        "25to34": "48",
        "35to44": "38",
        "45to54": "38",
        "55to64": "30",
        "65+": "9",
        "medianAge": "30"
      }
    },
    "title": "Athletes, coaches, umpires, and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "267",
        "women": "36.5",
        "white": "6.4",
        "black": "1.4",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "89",
        "median": "958",
        "maleWorkers": "63",
        "maleMedian": "1,018",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Dancers and choreographers": {
    "ageData": {
      "2012": {
        "total": "21",
        "16to19": "4",
        "20to24": "5",
        "25to34": "9",
        "35to44": "3",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Dancers and choreographers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Musicians, singers, and related workers": {
    "ageData": {
      "2012": {
        "total": "203",
        "16to19": "7",
        "20to24": "18",
        "25to34": "51",
        "35to44": "35",
        "45to54": "34",
        "55to64": "38",
        "65+": "20",
        "medianAge": "38"
      }
    },
    "title": "Musicians, singers, and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "203",
        "women": "35.5",
        "white": "10.9",
        "black": "2.8",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Entertainers and performers, sports and related workers, all other": {
    "ageData": {
      "2012": {
        "total": "41",
        "16to19": "2",
        "20to24": "5",
        "25to34": "14",
        "35to44": "6",
        "45to54": "6",
        "55to64": "2",
        "65+": "5",
        "medianAge": "2"
      }
    },
    "title": "Entertainers and performers, sports and related workers, all other",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Announcers": {
    "ageData": {
      "2012": {
        "total": "50",
        "16to19": "0",
        "20to24": "5",
        "25to34": "9",
        "35to44": "14",
        "45to54": "13",
        "55to64": "5",
        "65+": "5",
        "medianAge": "5"
      }
    },
    "title": "Announcers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "50",
        "women": "23.6",
        "white": "12.0",
        "black": "8.3",
        "asian": "15.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "News analysts, reporters and correspondents": {
    "ageData": {
      "2012": {
        "total": "82",
        "16to19": "1",
        "20to24": "12",
        "25to34": "20",
        "35to44": "11",
        "45to54": "20",
        "55to64": "15",
        "65+": "5",
        "medianAge": "15"
      }
    },
    "title": "News analysts, reporters and correspondents",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "82",
        "women": "45.7",
        "white": "9.2",
        "black": "6.1",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "63",
        "median": "1,021",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Public relations specialists": {
    "ageData": {
      "2012": {
        "total": "155",
        "16to19": "0",
        "20to24": "11",
        "25to34": "46",
        "35to44": "39",
        "45to54": "25",
        "55to64": "27",
        "65+": "8",
        "medianAge": "27"
      }
    },
    "title": "Public relations specialists",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "155",
        "women": "58.2",
        "white": "7.3",
        "black": "5.8",
        "asian": "8.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "133",
        "median": "1,127",
        "maleWorkers": "55",
        "maleMedian": "1,351",
        "femaleWorkers": "79",
        "femaleMedian": "989"
      }
    }
  },
  "Editors": {
    "ageData": {
      "2012": {
        "total": "159",
        "16to19": "2",
        "20to24": "21",
        "25to34": "41",
        "35to44": "30",
        "45to54": "30",
        "55to64": "23",
        "65+": "11",
        "medianAge": "23"
      }
    },
    "title": "Editors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "159",
        "women": "50.7",
        "white": "4.8",
        "black": "3.2",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "121",
        "median": "946",
        "maleWorkers": "59",
        "maleMedian": "993",
        "femaleWorkers": "62",
        "femaleMedian": "889"
      }
    }
  },
  "Technical writers": {
    "ageData": {
      "2012": {
        "total": "58",
        "16to19": "0",
        "20to24": "1",
        "25to34": "8",
        "35to44": "17",
        "45to54": "18",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Technical writers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "58",
        "women": "55.5",
        "white": "2.7",
        "black": "6.7",
        "asian": "3.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "52",
        "median": "1,227",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Writers and authors": {
    "ageData": {
      "2012": {
        "total": "208",
        "16to19": "1",
        "20to24": "13",
        "25to34": "48",
        "35to44": "27",
        "45to54": "49",
        "55to64": "42",
        "65+": "28",
        "medianAge": "42"
      }
    },
    "title": "Writers and authors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "208",
        "women": "55.6",
        "white": "5.4",
        "black": "4.2",
        "asian": "2.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "86",
        "median": "899",
        "maleWorkers": "40",
        "maleMedian": "-",
        "femaleWorkers": "46",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous media and communication workers": {
    "ageData": {
      "2012": {
        "total": "98",
        "16to19": "2",
        "20to24": "8",
        "25to34": "27",
        "35to44": "21",
        "45to54": "21",
        "55to64": "13",
        "65+": "7",
        "medianAge": "13"
      }
    },
    "title": "Miscellaneous media and communication workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "98",
        "women": "79.2",
        "white": "5.6",
        "black": "15.0",
        "asian": "35.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "43",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Broadcast and sound engineering technicians and radio operators": {
    "ageData": {
      "2012": {
        "total": "108",
        "16to19": "2",
        "20to24": "14",
        "25to34": "32",
        "35to44": "23",
        "45to54": "22",
        "55to64": "12",
        "65+": "3",
        "medianAge": "12"
      }
    },
    "title": "Broadcast and sound engineering technicians and radio operators",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "108",
        "women": "8.4",
        "white": "4.1",
        "black": "1.6",
        "asian": "12.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "70",
        "median": "875",
        "maleWorkers": "64",
        "maleMedian": "924",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Photographers": {
    "ageData": {
      "2012": {
        "total": "178",
        "16to19": "4",
        "20to24": "19",
        "25to34": "49",
        "35to44": "44",
        "45to54": "30",
        "55to64": "20",
        "65+": "12",
        "medianAge": "20"
      }
    },
    "title": "Photographers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "178",
        "women": "52.2",
        "white": "6.2",
        "black": "4.3",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Television, video, and motion picture camera operators and editors": {
    "ageData": {
      "2012": {
        "total": "57",
        "16to19": "1",
        "20to24": "5",
        "25to34": "16",
        "35to44": "18",
        "45to54": "12",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Television, video, and motion picture camera operators and editors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "57",
        "women": "21.4",
        "white": "4.4",
        "black": "5.6",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "34",
        "median": "-",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Media and communication equipment workers, all other": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Media and communication equipment workers, all other",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Healthcare practitioners and technical occupations": {
    "ageData": {
      "2012": {
        "total": "7,977",
        "16to19": "31",
        "20to24": "358",
        "25to34": "1,969",
        "35to44": "1,968",
        "45to54": "1,823",
        "55to64": "1,487",
        "65+": "341",
        "medianAge": "1,487"
      }
    },
    "title": "Healthcare practitioners and technical occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7,977",
        "women": "75.0",
        "white": "10.6",
        "black": "8.4",
        "asian": "7.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5,791",
        "median": "1,028",
        "maleWorkers": "1,471",
        "maleMedian": "1,245",
        "femaleWorkers": "4,320",
        "femaleMedian": "980"
      }
    }
  },
  "Chiropractors": {
    "ageData": {
      "2012": {
        "total": "58",
        "16to19": "0",
        "20to24": "0",
        "25to34": "9",
        "35to44": "17",
        "45to54": "15",
        "55to64": "10",
        "65+": "6",
        "medianAge": "10"
      }
    },
    "title": "Chiropractors",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "58",
        "women": "22.3",
        "white": "0.0",
        "black": "3.5",
        "asian": "4.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Dentists": {
    "ageData": {
      "2012": {
        "total": "167",
        "16to19": "0",
        "20to24": "0",
        "25to34": "17",
        "35to44": "39",
        "45to54": "51",
        "55to64": "37",
        "65+": "22",
        "medianAge": "37"
      }
    },
    "title": "Dentists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "167",
        "women": "24.2",
        "white": "1.7",
        "black": "10.6",
        "asian": "2.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "37",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Dietitians and nutritionists": {
    "ageData": {
      "2012": {
        "total": "116",
        "16to19": "2",
        "20to24": "4",
        "25to34": "24",
        "35to44": "22",
        "45to54": "26",
        "55to64": "32",
        "65+": "6",
        "medianAge": "32"
      }
    },
    "title": "Dietitians and nutritionists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "116",
        "women": "93.3",
        "white": "13.7",
        "black": "5.1",
        "asian": "7.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "79",
        "median": "840",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "73",
        "femaleMedian": "845"
      }
    }
  },
  "Optometrists": {
    "ageData": {
      "2012": {
        "total": "33",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "3",
        "45to54": "10",
        "55to64": "7",
        "65+": "4",
        "medianAge": "7"
      }
    },
    "title": "Optometrists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Pharmacists": {
    "ageData": {
      "2012": {
        "total": "286",
        "16to19": "0",
        "20to24": "8",
        "25to34": "94",
        "35to44": "73",
        "45to54": "49",
        "55to64": "45",
        "65+": "16",
        "medianAge": "45"
      }
    },
    "title": "Pharmacists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "286",
        "women": "53.7",
        "white": "6.8",
        "black": "18.5",
        "asian": "5.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "223",
        "median": "1,877",
        "maleWorkers": "107",
        "maleMedian": "1,879",
        "femaleWorkers": "116",
        "femaleMedian": "1,871"
      }
    }
  },
  "Physicians and surgeons": {
    "ageData": {
      "2012": {
        "total": "911",
        "16to19": "0",
        "20to24": "3",
        "25to34": "179",
        "35to44": "238",
        "45to54": "218",
        "55to64": "181",
        "65+": "92",
        "medianAge": "181"
      }
    },
    "title": "Physicians and surgeons",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "911",
        "women": "34.3",
        "white": "7.2",
        "black": "18.1",
        "asian": "5.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "655",
        "median": "1,887",
        "maleWorkers": "429",
        "maleMedian": "2,099",
        "femaleWorkers": "226",
        "femaleMedian": "1,418"
      }
    }
  },
  "Physician assistants": {
    "ageData": {
      "2012": {
        "total": "108",
        "16to19": "0",
        "20to24": "5",
        "25to34": "34",
        "35to44": "35",
        "45to54": "22",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Physician assistants",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "108",
        "women": "69.4",
        "white": "8.2",
        "black": "9.0",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "88",
        "median": "1,329",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "61",
        "femaleMedian": "1,364"
      }
    }
  },
  "Podiatrists": {
    "ageData": {
      "2012": {
        "total": "9",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "3",
        "45to54": "3",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Podiatrists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Audiologists": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "5",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Audiologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Occupational therapists": {
    "ageData": {
      "2012": {
        "total": "118",
        "16to19": "0",
        "20to24": "2",
        "25to34": "38",
        "35to44": "34",
        "45to54": "26",
        "55to64": "16",
        "65+": "3",
        "medianAge": "16"
      }
    },
    "title": "Occupational therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "118",
        "women": "94.0",
        "white": "2.5",
        "black": "4.0",
        "asian": "5.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "85",
        "median": "1,189",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "82",
        "femaleMedian": "1,200"
      }
    }
  },
  "Physical therapists": {
    "ageData": {
      "2012": {
        "total": "211",
        "16to19": "1",
        "20to24": "6",
        "25to34": "74",
        "35to44": "53",
        "45to54": "46",
        "55to64": "27",
        "65+": "5",
        "medianAge": "27"
      }
    },
    "title": "Physical therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "211",
        "women": "70.7",
        "white": "4.4",
        "black": "9.1",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "144",
        "median": "1,287",
        "maleWorkers": "56",
        "maleMedian": "1,362",
        "femaleWorkers": "88",
        "femaleMedian": "1,190"
      }
    }
  },
  "Radiation therapists": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "5",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Radiation therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Recreational therapists": {
    "ageData": {
      "2012": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "2",
        "45to54": "4",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Recreational therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Respiratory therapists": {
    "ageData": {
      "2012": {
        "total": "111",
        "16to19": "0",
        "20to24": "3",
        "25to34": "27",
        "35to44": "34",
        "45to54": "24",
        "55to64": "20",
        "65+": "3",
        "medianAge": "20"
      }
    },
    "title": "Respiratory therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "111",
        "women": "60.4",
        "white": "12.1",
        "black": "5.6",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "92",
        "median": "979",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "56",
        "femaleMedian": "936"
      }
    }
  },
  "Speech-language pathologists": {
    "ageData": {
      "2012": {
        "total": "146",
        "16to19": "0",
        "20to24": "4",
        "25to34": "50",
        "35to44": "40",
        "45to54": "21",
        "55to64": "29",
        "65+": "1",
        "medianAge": "29"
      }
    },
    "title": "Speech-language pathologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "146",
        "women": "95.2",
        "white": "3.1",
        "black": "1.7",
        "asian": "8.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "88",
        "median": "1,128",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "86",
        "femaleMedian": "1,121"
      }
    }
  },
  "Exercise physiologists": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Exercise physiologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Therapists, all other": {
    "ageData": {
      "2012": {
        "total": "148",
        "16to19": "1",
        "20to24": "12",
        "25to34": "41",
        "35to44": "40",
        "45to54": "25",
        "55to64": "23",
        "65+": "6",
        "medianAge": "23"
      }
    },
    "title": "Therapists, all other",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "148",
        "women": "83.6",
        "white": "10.3",
        "black": "2.9",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "88",
        "median": "926",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "71",
        "femaleMedian": "877"
      }
    }
  },
  "Veterinarians": {
    "ageData": {
      "2012": {
        "total": "85",
        "16to19": "1",
        "20to24": "1",
        "25to34": "19",
        "35to44": "30",
        "45to54": "16",
        "55to64": "14",
        "65+": "3",
        "medianAge": "14"
      }
    },
    "title": "Veterinarians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "85",
        "women": "54.7",
        "white": "1.9",
        "black": "1.3",
        "asian": "6.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Registered nurses": {
    "ageData": {
      "2012": {
        "total": "2,875",
        "16to19": "1",
        "20to24": "104",
        "25to34": "655",
        "35to44": "695",
        "45to54": "699",
        "55to64": "626",
        "65+": "95",
        "medianAge": "626"
      }
    },
    "title": "Registered nurses",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,875",
        "women": "90.6",
        "white": "11.5",
        "black": "7.3",
        "asian": "6.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,176",
        "median": "1,097",
        "maleWorkers": "230",
        "maleMedian": "1,189",
        "femaleWorkers": "1,946",
        "femaleMedian": "1,086"
      }
    }
  },
  "Nurse anesthetists": {
    "ageData": {
      "2012": {
        "total": "27",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "9",
        "45to54": "8",
        "55to64": "9",
        "65+": "0",
        "medianAge": "9"
      }
    },
    "title": "Nurse anesthetists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Nurse midwives": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Nurse midwives",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Nurse practitioners": {
    "ageData": {
      "2012": {
        "total": "103",
        "16to19": "0",
        "20to24": "0",
        "25to34": "15",
        "35to44": "38",
        "45to54": "26",
        "55to64": "23",
        "65+": "2",
        "medianAge": "23"
      }
    },
    "title": "Nurse practitioners",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "103",
        "women": "86.1",
        "white": "4.5",
        "black": "4.6",
        "asian": "2.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "77",
        "median": "1,610",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "65",
        "femaleMedian": "1,530"
      }
    }
  },
  "Health diagnosing and treating practitioners, all other": {
    "ageData": {
      "2012": {
        "total": "23",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "3",
        "45to54": "9",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Health diagnosing and treating practitioners, all other",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Clinical laboratory technologists and technicians": {
    "ageData": {
      "2012": {
        "total": "319",
        "16to19": "1",
        "20to24": "17",
        "25to34": "81",
        "35to44": "62",
        "45to54": "86",
        "55to64": "57",
        "65+": "15",
        "medianAge": "57"
      }
    },
    "title": "Clinical laboratory technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "319",
        "women": "72.8",
        "white": "13.5",
        "black": "14.0",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "256",
        "median": "869",
        "maleWorkers": "76",
        "maleMedian": "943",
        "femaleWorkers": "180",
        "femaleMedian": "842"
      }
    }
  },
  "Dental hygienists": {
    "ageData": {
      "2012": {
        "total": "163",
        "16to19": "0",
        "20to24": "8",
        "25to34": "47",
        "35to44": "42",
        "45to54": "38",
        "55to64": "25",
        "65+": "2",
        "medianAge": "25"
      }
    },
    "title": "Dental hygienists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "163",
        "women": "99.3",
        "white": "3.3",
        "black": "5.6",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "51",
        "median": "1,045",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "50",
        "femaleMedian": "1,047"
      }
    }
  },
  "Diagnostic related technologists and technicians": {
    "ageData": {
      "2012": {
        "total": "308",
        "16to19": "2",
        "20to24": "14",
        "25to34": "80",
        "35to44": "89",
        "45to54": "64",
        "55to64": "52",
        "65+": "6",
        "medianAge": "52"
      }
    },
    "title": "Diagnostic related technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "308",
        "women": "74.5",
        "white": "9.0",
        "black": "4.1",
        "asian": "7.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "241",
        "median": "961",
        "maleWorkers": "67",
        "maleMedian": "1,131",
        "femaleWorkers": "174",
        "femaleMedian": "912"
      }
    }
  },
  "Emergency medical technicians and paramedics": {
    "ageData": {
      "2012": {
        "total": "172",
        "16to19": "5",
        "20to24": "17",
        "25to34": "73",
        "35to44": "40",
        "45to54": "25",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Emergency medical technicians and paramedics",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "172",
        "women": "31.2",
        "white": "5.0",
        "black": "1.6",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "145",
        "median": "780",
        "maleWorkers": "100",
        "maleMedian": "809",
        "femaleWorkers": "44",
        "femaleMedian": "-"
      }
    }
  },
  "Health practitioner support technologists and technicians": {
    "ageData": {
      "2012": {
        "total": "544",
        "16to19": "9",
        "20to24": "96",
        "25to34": "179",
        "35to44": "106",
        "45to54": "90",
        "55to64": "50",
        "65+": "14",
        "medianAge": "50"
      }
    },
    "title": "Health practitioner support technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "544",
        "women": "83.6",
        "white": "15.8",
        "black": "5.9",
        "asian": "12.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "403",
        "median": "615",
        "maleWorkers": "82",
        "maleMedian": "599",
        "femaleWorkers": "322",
        "femaleMedian": "621"
      }
    }
  },
  "Licensed practical and licensed vocational nurses": {
    "ageData": {
      "2012": {
        "total": "531",
        "16to19": "3",
        "20to24": "25",
        "25to34": "127",
        "35to44": "133",
        "45to54": "140",
        "55to64": "85",
        "65+": "18",
        "medianAge": "85"
      }
    },
    "title": "Licensed practical and licensed vocational nurses",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "531",
        "women": "94.2",
        "white": "23.3",
        "black": "5.1",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "433",
        "median": "731",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "400",
        "femaleMedian": "730"
      }
    }
  },
  "Medical records and health information technicians": {
    "ageData": {
      "2012": {
        "total": "90",
        "16to19": "1",
        "20to24": "4",
        "25to34": "19",
        "35to44": "17",
        "45to54": "25",
        "55to64": "19",
        "65+": "4",
        "medianAge": "19"
      }
    },
    "title": "Medical records and health information technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "90",
        "women": "89.3",
        "white": "17.1",
        "black": "4.3",
        "asian": "15.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "74",
        "median": "618",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "65",
        "femaleMedian": "663"
      }
    }
  },
  "Opticians, dispensing": {
    "ageData": {
      "2012": {
        "total": "54",
        "16to19": "0",
        "20to24": "7",
        "25to34": "7",
        "35to44": "10",
        "45to54": "12",
        "55to64": "17",
        "65+": "2",
        "medianAge": "17"
      }
    },
    "title": "Opticians, dispensing",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "54",
        "women": "59.6",
        "white": "8.2",
        "black": "3.8",
        "asian": "4.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "41",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous health technologists and technicians": {
    "ageData": {
      "2012": {
        "total": "140",
        "16to19": "2",
        "20to24": "10",
        "25to34": "31",
        "35to44": "33",
        "45to54": "31",
        "55to64": "26",
        "65+": "7",
        "medianAge": "26"
      }
    },
    "title": "Miscellaneous health technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "140",
        "women": "60.2",
        "white": "18.7",
        "black": "11.0",
        "asian": "10.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "113",
        "median": "772",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "71",
        "femaleMedian": "714"
      }
    }
  },
  "Other healthcare practitioners and technical occupations": {
    "ageData": {
      "2012": {
        "total": "75",
        "16to19": "1",
        "20to24": "6",
        "25to34": "19",
        "35to44": "17",
        "45to54": "9",
        "55to64": "19",
        "65+": "3",
        "medianAge": "19"
      }
    },
    "title": "Other healthcare practitioners and technical occupations",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "75",
        "women": "50.3",
        "white": "8.8",
        "black": "3.1",
        "asian": "5.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "69",
        "median": "900",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "Service occupations": {
    "ageData": {
      "2012": {
        "total": "25,459",
        "16to19": "1,812",
        "20to24": "3,917",
        "25to34": "5,658",
        "35to44": "4,800",
        "45to54": "4,949",
        "55to64": "3,190",
        "65+": "1,133",
        "medianAge": "3,190"
      }
    },
    "title": "Service occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25,459",
        "women": "56.3",
        "white": "15.9",
        "black": "5.6",
        "asian": "22.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14,839",
        "median": "485",
        "maleWorkers": "7,511",
        "maleMedian": "543",
        "femaleWorkers": "7,328",
        "femaleMedian": "435"
      }
    }
  },
  "Healthcare support occupations": {
    "ageData": {
      "2012": {
        "total": "3,496",
        "16to19": "69",
        "20to24": "528",
        "25to34": "911",
        "35to44": "667",
        "45to54": "710",
        "55to64": "478",
        "65+": "133",
        "medianAge": "478"
      }
    },
    "title": "Healthcare support occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,496",
        "women": "87.6",
        "white": "26.5",
        "black": "4.5",
        "asian": "15.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,350",
        "median": "482",
        "maleWorkers": "290",
        "maleMedian": "529",
        "femaleWorkers": "2,060",
        "femaleMedian": "477"
      }
    }
  },
  "Nursing, psychiatric, and home health aides": {
    "ageData": {
      "2012": {
        "total": "2,119",
        "16to19": "41",
        "20to24": "311",
        "25to34": "489",
        "35to44": "393",
        "45to54": "463",
        "55to64": "323",
        "65+": "98",
        "medianAge": "323"
      }
    },
    "title": "Nursing, psychiatric, and home health aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,119",
        "women": "87.9",
        "white": "34.5",
        "black": "4.6",
        "asian": "14.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,458",
        "median": "451",
        "maleWorkers": "173",
        "maleMedian": "508",
        "femaleWorkers": "1,285",
        "femaleMedian": "445"
      }
    }
  },
  "Occupational therapy assistants and aides": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "0",
        "20to24": "4",
        "25to34": "9",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Occupational therapy assistants and aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Physical therapist assistants and aides": {
    "ageData": {
      "2012": {
        "total": "66",
        "16to19": "0",
        "20to24": "14",
        "25to34": "20",
        "35to44": "14",
        "45to54": "9",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Physical therapist assistants and aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "66",
        "women": "66.4",
        "white": "14.7",
        "black": "3.6",
        "asian": "5.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "45",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Massage therapists": {
    "ageData": {
      "2012": {
        "total": "158",
        "16to19": "1",
        "20to24": "17",
        "25to34": "46",
        "35to44": "32",
        "45to54": "27",
        "55to64": "25",
        "65+": "9",
        "medianAge": "25"
      }
    },
    "title": "Massage therapists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "158",
        "women": "81.5",
        "white": "5.4",
        "black": "7.7",
        "asian": "12.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Dental assistants": {
    "ageData": {
      "2012": {
        "total": "274",
        "16to19": "5",
        "20to24": "39",
        "25to34": "87",
        "35to44": "61",
        "45to54": "51",
        "55to64": "26",
        "65+": "4",
        "medianAge": "26"
      }
    },
    "title": "Dental assistants",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "274",
        "women": "97.9",
        "white": "9.6",
        "black": "3.6",
        "asian": "21.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "174",
        "median": "579",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "172",
        "femaleMedian": "581"
      }
    }
  },
  "Medical assistants": {
    "ageData": {
      "2012": {
        "total": "429",
        "16to19": "3",
        "20to24": "67",
        "25to34": "163",
        "35to44": "96",
        "45to54": "59",
        "55to64": "36",
        "65+": "5",
        "medianAge": "36"
      }
    },
    "title": "Medical assistants",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "429",
        "women": "93.8",
        "white": "15.0",
        "black": "3.8",
        "asian": "22.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "323",
        "median": "514",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "302",
        "femaleMedian": "515"
      }
    }
  },
  "Medical transcriptionists": {
    "ageData": {
      "2012": {
        "total": "55",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "10",
        "45to54": "20",
        "55to64": "13",
        "65+": "5",
        "medianAge": "13"
      }
    },
    "title": "Medical transcriptionists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "55",
        "women": "98.2",
        "white": "7.0",
        "black": "0.3",
        "asian": "4.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Pharmacy aides": {
    "ageData": {
      "2012": {
        "total": "45",
        "16to19": "1",
        "20to24": "13",
        "25to34": "11",
        "35to44": "7",
        "45to54": "4",
        "55to64": "9",
        "65+": "0",
        "medianAge": "9"
      }
    },
    "title": "Pharmacy aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Veterinary assistants and laboratory animal caretakers": {
    "ageData": {
      "2012": {
        "total": "47",
        "16to19": "4",
        "20to24": "14",
        "25to34": "14",
        "35to44": "6",
        "45to54": "3",
        "55to64": "6",
        "65+": "0",
        "medianAge": "6"
      }
    },
    "title": "Veterinary assistants and laboratory animal caretakers",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Phlebotomists": {
    "ageData": {
      "2012": {
        "total": "119",
        "16to19": "1",
        "20to24": "14",
        "25to34": "38",
        "35to44": "21",
        "45to54": "32",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Phlebotomists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "119",
        "women": "80.2",
        "white": "26.5",
        "black": "4.8",
        "asian": "15.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "101",
        "median": "520",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "82",
        "femaleMedian": "516"
      }
    }
  },
  "Miscellaneous healthcare support occupations, including medical equipment preparers": {
    "ageData": {
      "2012": {
        "total": "166",
        "16to19": "13",
        "20to24": "32",
        "25to34": "27",
        "35to44": "26",
        "45to54": "40",
        "55to64": "22",
        "65+": "7",
        "medianAge": "22"
      }
    },
    "title": "Miscellaneous healthcare support occupations, including medical equipment preparers",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "166",
        "women": "69.0",
        "white": "21.9",
        "black": "4.0",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "112",
        "median": "487",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "77",
        "femaleMedian": "462"
      }
    }
  },
  "Protective service occupations": {
    "ageData": {
      "2012": {
        "total": "3,096",
        "16to19": "92",
        "20to24": "231",
        "25to34": "754",
        "35to44": "792",
        "45to54": "684",
        "55to64": "402",
        "65+": "140",
        "medianAge": "402"
      }
    },
    "title": "Protective service occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,096",
        "women": "20.9",
        "white": "17.2",
        "black": "2.7",
        "asian": "13.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,655",
        "median": "791",
        "maleWorkers": "2,154",
        "maleMedian": "841",
        "femaleWorkers": "500",
        "femaleMedian": "658"
      }
    }
  },
  "First-line supervisors of correctional officers": {
    "ageData": {
      "2012": {
        "total": "46",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "13",
        "45to54": "17",
        "55to64": "5",
        "65+": "3",
        "medianAge": "5"
      }
    },
    "title": "First-line supervisors of correctional officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "51",
        "median": "820",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of police and detectives": {
    "ageData": {
      "2012": {
        "total": "112",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "41",
        "45to54": "44",
        "55to64": "17",
        "65+": "3",
        "medianAge": "17"
      }
    },
    "title": "First-line supervisors of police and detectives",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "112",
        "women": "15.2",
        "white": "9.2",
        "black": "4.4",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "105",
        "median": "1,216",
        "maleWorkers": "89",
        "maleMedian": "1,240",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of fire fighting and prevention workers": {
    "ageData": {
      "2012": {
        "total": "64",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "21",
        "45to54": "23",
        "55to64": "15",
        "65+": "0",
        "medianAge": "15"
      }
    },
    "title": "First-line supervisors of fire fighting and prevention workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "64",
        "women": "0.5",
        "white": "10.7",
        "black": "0.0",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "59",
        "median": "1,271",
        "maleWorkers": "59",
        "maleMedian": "1,272",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of protective service workers, all other": {
    "ageData": {
      "2012": {
        "total": "93",
        "16to19": "0",
        "20to24": "2",
        "25to34": "13",
        "35to44": "24",
        "45to54": "23",
        "55to64": "24",
        "65+": "8",
        "medianAge": "24"
      }
    },
    "title": "First-line supervisors of protective service workers, all other",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "93",
        "women": "29.9",
        "white": "17.4",
        "black": "0.4",
        "asian": "12.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "80",
        "median": "881",
        "maleWorkers": "54",
        "maleMedian": "806",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Firefighters": {
    "ageData": {
      "2012": {
        "total": "295",
        "16to19": "0",
        "20to24": "21",
        "25to34": "97",
        "35to44": "97",
        "45to54": "59",
        "55to64": "20",
        "65+": "1",
        "medianAge": "20"
      }
    },
    "title": "Firefighters",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "295",
        "women": "3.4",
        "white": "7.7",
        "black": "1.1",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "276",
        "median": "1,068",
        "maleWorkers": "268",
        "maleMedian": "1,073",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Fire inspectors": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "4",
        "45to54": "6",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Fire inspectors",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Bailiffs, correctional officers, and jailers": {
    "ageData": {
      "2012": {
        "total": "371",
        "16to19": "5",
        "20to24": "22",
        "25to34": "95",
        "35to44": "124",
        "45to54": "89",
        "55to64": "32",
        "65+": "4",
        "medianAge": "32"
      }
    },
    "title": "Bailiffs, correctional officers, and jailers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "371",
        "women": "28.0",
        "white": "22.7",
        "black": "1.1",
        "asian": "18.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "363",
        "median": "722",
        "maleWorkers": "261",
        "maleMedian": "768",
        "femaleWorkers": "102",
        "femaleMedian": "643"
      }
    }
  },
  "Detectives and criminal investigators": {
    "ageData": {
      "2012": {
        "total": "160",
        "16to19": "0",
        "20to24": "1",
        "25to34": "30",
        "35to44": "56",
        "45to54": "47",
        "55to64": "20",
        "65+": "5",
        "medianAge": "20"
      }
    },
    "title": "Detectives and criminal investigators",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "160",
        "women": "24.8",
        "white": "9.8",
        "black": "3.5",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "151",
        "median": "1,062",
        "maleWorkers": "114",
        "maleMedian": "1,171",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Fish and game wardens": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "3",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Fish and game wardens",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Parking enforcement workers": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Parking enforcement workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Police and sheriff's patrol officers": {
    "ageData": {
      "2012": {
        "total": "657",
        "16to19": "2",
        "20to24": "25",
        "25to34": "200",
        "35to44": "216",
        "45to54": "148",
        "55to64": "53",
        "65+": "14",
        "medianAge": "53"
      }
    },
    "title": "Police and sheriff's patrol officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "657",
        "women": "12.6",
        "white": "12.8",
        "black": "3.1",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "629",
        "median": "979",
        "maleWorkers": "554",
        "maleMedian": "1,016",
        "femaleWorkers": "76",
        "femaleMedian": "815"
      }
    }
  },
  "Transit and railroad police": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "2",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Transit and railroad police",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Animal control workers": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Animal control workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Private detectives and investigators": {
    "ageData": {
      "2012": {
        "total": "103",
        "16to19": "1",
        "20to24": "5",
        "25to34": "25",
        "35to44": "25",
        "45to54": "23",
        "55to64": "17",
        "65+": "7",
        "medianAge": "17"
      }
    },
    "title": "Private detectives and investigators",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "103",
        "women": "44.0",
        "white": "8.0",
        "black": "2.2",
        "asian": "11.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "76",
        "median": "848",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "Security guards and gaming surveillance officers": {
    "ageData": {
      "2012": {
        "total": "903",
        "16to19": "16",
        "20to24": "114",
        "25to34": "231",
        "35to44": "146",
        "45to54": "163",
        "55to64": "163",
        "65+": "70",
        "medianAge": "163"
      }
    },
    "title": "Security guards and gaming surveillance officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "903",
        "women": "18.5",
        "white": "26.6",
        "black": "4.1",
        "asian": "15.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "742",
        "median": "528",
        "maleWorkers": "603",
        "maleMedian": "537",
        "femaleWorkers": "138",
        "femaleMedian": "501"
      }
    }
  },
  "Crossing guards": {
    "ageData": {
      "2012": {
        "total": "61",
        "16to19": "1",
        "20to24": "3",
        "25to34": "7",
        "35to44": "6",
        "45to54": "17",
        "55to64": "14",
        "65+": "14",
        "medianAge": "14"
      }
    },
    "title": "Crossing guards",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "61",
        "women": "55.3",
        "white": "19.7",
        "black": "1.8",
        "asian": "16.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation security screeners": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "8",
        "35to44": "6",
        "45to54": "7",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Transportation security screeners",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Lifeguards and other recreational, and all other protective service workers": {
    "ageData": {
      "2012": {
        "total": "162",
        "16to19": "67",
        "20to24": "35",
        "25to34": "15",
        "35to44": "6",
        "45to54": "13",
        "55to64": "16",
        "65+": "10",
        "medianAge": "16"
      }
    },
    "title": "Lifeguards and other recreational, and all other protective service workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "162",
        "women": "52.6",
        "white": "7.8",
        "black": "1.2",
        "asian": "9.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "55",
        "median": "472",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Food preparation and serving related occupations": {
    "ageData": {
      "2012": {
        "total": "8,018",
        "16to19": "1,143",
        "20to24": "1,939",
        "25to34": "1,896",
        "35to44": "1,151",
        "45to54": "1,077",
        "55to64": "609",
        "65+": "203",
        "medianAge": "609"
      }
    },
    "title": "Food preparation and serving related occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8,018",
        "women": "54.5",
        "white": "12.1",
        "black": "6.2",
        "asian": "23.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4,164",
        "median": "410",
        "maleWorkers": "2,189",
        "maleMedian": "433",
        "femaleWorkers": "1,975",
        "femaleMedian": "389"
      }
    }
  },
  "Chefs and head cooks": {
    "ageData": {
      "2012": {
        "total": "403",
        "16to19": "7",
        "20to24": "45",
        "25to34": "125",
        "35to44": "96",
        "45to54": "77",
        "55to64": "48",
        "65+": "6",
        "medianAge": "48"
      }
    },
    "title": "Chefs and head cooks",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "403",
        "women": "21.5",
        "white": "11.9",
        "black": "14.2",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "318",
        "median": "562",
        "maleWorkers": "261",
        "maleMedian": "582",
        "femaleWorkers": "56",
        "femaleMedian": "462"
      }
    }
  },
  "First-line supervisors of food preparation and serving workers": {
    "ageData": {
      "2012": {
        "total": "552",
        "16to19": "23",
        "20to24": "113",
        "25to34": "149",
        "35to44": "103",
        "45to54": "93",
        "55to64": "57",
        "65+": "14",
        "medianAge": "57"
      }
    },
    "title": "First-line supervisors of food preparation and serving workers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "552",
        "women": "59.3",
        "white": "13.9",
        "black": "4.0",
        "asian": "17.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "415",
        "median": "491",
        "maleWorkers": "170",
        "maleMedian": "561",
        "femaleWorkers": "245",
        "femaleMedian": "451"
      }
    }
  },
  "Cooks": {
    "ageData": {
      "2012": {
        "total": "1,970",
        "16to19": "202",
        "20to24": "358",
        "25to34": "506",
        "35to44": "349",
        "45to54": "313",
        "55to64": "178",
        "65+": "63",
        "medianAge": "178"
      }
    },
    "title": "Cooks",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,970",
        "women": "37.7",
        "white": "16.6",
        "black": "6.0",
        "asian": "31.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,240",
        "median": "389",
        "maleWorkers": "833",
        "maleMedian": "403",
        "femaleWorkers": "408",
        "femaleMedian": "361"
      }
    }
  },
  "Food preparation workers": {
    "ageData": {
      "2012": {
        "total": "868",
        "16to19": "144",
        "20to24": "233",
        "25to34": "178",
        "35to44": "100",
        "45to54": "110",
        "55to64": "80",
        "65+": "22",
        "medianAge": "80"
      }
    },
    "title": "Food preparation workers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "868",
        "women": "58.0",
        "white": "12.1",
        "black": "5.7",
        "asian": "27.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "432",
        "median": "383",
        "maleWorkers": "191",
        "maleMedian": "408",
        "femaleWorkers": "241",
        "femaleMedian": "357"
      }
    }
  },
  "Bartenders": {
    "ageData": {
      "2012": {
        "total": "412",
        "16to19": "5",
        "20to24": "82",
        "25to34": "148",
        "35to44": "66",
        "45to54": "69",
        "55to64": "30",
        "65+": "12",
        "medianAge": "30"
      }
    },
    "title": "Bartenders",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "412",
        "women": "59.9",
        "white": "5.2",
        "black": "3.5",
        "asian": "13.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "209",
        "median": "460",
        "maleWorkers": "97",
        "maleMedian": "520",
        "femaleWorkers": "112",
        "femaleMedian": "421"
      }
    }
  },
  "Combined food preparation and serving workers, including fast food": {
    "ageData": {
      "2012": {
        "total": "343",
        "16to19": "57",
        "20to24": "89",
        "25to34": "55",
        "35to44": "44",
        "45to54": "56",
        "55to64": "32",
        "65+": "11",
        "medianAge": "32"
      }
    },
    "title": "Combined food preparation and serving workers, including fast food",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "343",
        "women": "64.9",
        "white": "14.1",
        "black": "3.1",
        "asian": "18.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "166",
        "median": "382",
        "maleWorkers": "57",
        "maleMedian": "406",
        "femaleWorkers": "109",
        "femaleMedian": "368"
      }
    }
  },
  "Counter attendants, cafeteria, food concession, and coffee shop": {
    "ageData": {
      "2012": {
        "total": "233",
        "16to19": "109",
        "20to24": "62",
        "25to34": "21",
        "35to44": "17",
        "45to54": "14",
        "55to64": "7",
        "65+": "3",
        "medianAge": "7"
      }
    },
    "title": "Counter attendants, cafeteria, food concession, and coffee shop",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "233",
        "women": "70.8",
        "white": "10.9",
        "black": "4.8",
        "asian": "16.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "56",
        "median": "350",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Waiters and waitresses": {
    "ageData": {
      "2012": {
        "total": "2,124",
        "16to19": "307",
        "20to24": "697",
        "25to34": "544",
        "35to44": "250",
        "45to54": "212",
        "55to64": "87",
        "65+": "28",
        "medianAge": "87"
      }
    },
    "title": "Waiters and waitresses",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,124",
        "women": "71.2",
        "white": "7.9",
        "black": "7.1",
        "asian": "19.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "891",
        "median": "411",
        "maleWorkers": "322",
        "maleMedian": "456",
        "femaleWorkers": "569",
        "femaleMedian": "396"
      }
    }
  },
  "Food servers, nonrestaurant": {
    "ageData": {
      "2012": {
        "total": "217",
        "16to19": "28",
        "20to24": "48",
        "25to34": "38",
        "35to44": "32",
        "45to54": "37",
        "55to64": "24",
        "65+": "10",
        "medianAge": "24"
      }
    },
    "title": "Food servers, nonrestaurant",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "217",
        "women": "64.9",
        "white": "22.2",
        "black": "6.4",
        "asian": "20.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "112",
        "median": "456",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "63",
        "femaleMedian": "434"
      }
    }
  },
  "Dining room and cafeteria attendants and bartender helpers": {
    "ageData": {
      "2012": {
        "total": "359",
        "16to19": "94",
        "20to24": "76",
        "25to34": "52",
        "35to44": "40",
        "45to54": "47",
        "55to64": "30",
        "65+": "20",
        "medianAge": "30"
      }
    },
    "title": "Dining room and cafeteria attendants and bartender helpers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "359",
        "women": "43.4",
        "white": "10.0",
        "black": "5.5",
        "asian": "31.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "137",
        "median": "370",
        "maleWorkers": "70",
        "maleMedian": "374",
        "femaleWorkers": "67",
        "femaleMedian": "366"
      }
    }
  },
  "Dishwashers": {
    "ageData": {
      "2012": {
        "total": "271",
        "16to19": "56",
        "20to24": "52",
        "25to34": "57",
        "35to44": "40",
        "45to54": "35",
        "55to64": "23",
        "65+": "8",
        "medianAge": "23"
      }
    },
    "title": "Dishwashers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "271",
        "women": "18.7",
        "white": "12.9",
        "black": "5.5",
        "asian": "40.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "127",
        "median": "345",
        "maleWorkers": "106",
        "maleMedian": "337",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Hosts and hostesses, restaurant, lounge, and coffee shop": {
    "ageData": {
      "2012": {
        "total": "260",
        "16to19": "111",
        "20to24": "81",
        "25to34": "23",
        "35to44": "12",
        "45to54": "13",
        "55to64": "13",
        "65+": "7",
        "medianAge": "13"
      }
    },
    "title": "Hosts and hostesses, restaurant, lounge, and coffee shop",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "260",
        "women": "81.5",
        "white": "10.2",
        "black": "5.4",
        "asian": "14.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "59",
        "median": "391",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "44",
        "femaleMedian": "-"
      }
    }
  },
  "Food preparation and serving related workers, all other": {
    "ageData": {
      "2012": {
        "total": "6",
        "16to19": "1",
        "20to24": "3",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Food preparation and serving related workers, all other",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Building and grounds cleaning and maintenance occupations": {
    "ageData": {
      "2012": {
        "total": "5,591",
        "16to19": "196",
        "20to24": "481",
        "25to34": "990",
        "35to44": "1,185",
        "45to54": "1,431",
        "55to64": "970",
        "65+": "338",
        "medianAge": "970"
      }
    },
    "title": "Building and grounds cleaning and maintenance occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5,591",
        "women": "38.6",
        "white": "15.0",
        "black": "3.3",
        "asian": "36.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3,430",
        "median": "465",
        "maleWorkers": "2,275",
        "maleMedian": "501",
        "femaleWorkers": "1,156",
        "femaleMedian": "407"
      }
    }
  },
  "First-line supervisors of housekeeping and janitorial workers": {
    "ageData": {
      "2012": {
        "total": "277",
        "16to19": "3",
        "20to24": "8",
        "25to34": "39",
        "35to44": "56",
        "45to54": "92",
        "55to64": "65",
        "65+": "14",
        "medianAge": "65"
      }
    },
    "title": "First-line supervisors of housekeeping and janitorial workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "277",
        "women": "47.1",
        "white": "16.9",
        "black": "3.3",
        "asian": "21.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "159",
        "median": "569",
        "maleWorkers": "88",
        "maleMedian": "687",
        "femaleWorkers": "72",
        "femaleMedian": "505"
      }
    }
  },
  "First-line supervisors of landscaping, lawn service, and groundskeeping workers": {
    "ageData": {
      "2012": {
        "total": "281",
        "16to19": "3",
        "20to24": "7",
        "25to34": "48",
        "35to44": "83",
        "45to54": "68",
        "55to64": "57",
        "65+": "15",
        "medianAge": "57"
      }
    },
    "title": "First-line supervisors of landscaping, lawn service, and groundskeeping workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "281",
        "women": "7.6",
        "white": "6.6",
        "black": "1.1",
        "asian": "19.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "109",
        "median": "745",
        "maleWorkers": "105",
        "maleMedian": "748",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Janitors and building cleaners": {
    "ageData": {
      "2012": {
        "total": "2,205",
        "16to19": "80",
        "20to24": "182",
        "25to34": "334",
        "35to44": "394",
        "45to54": "585",
        "55to64": "454",
        "65+": "176",
        "medianAge": "454"
      }
    },
    "title": "Janitors and building cleaners",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,205",
        "women": "29.7",
        "white": "18.4",
        "black": "3.6",
        "asian": "30.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,514",
        "median": "484",
        "maleWorkers": "1,134",
        "maleMedian": "511",
        "femaleWorkers": "380",
        "femaleMedian": "408"
      }
    }
  },
  "Maids and housekeeping cleaners": {
    "ageData": {
      "2012": {
        "total": "1,457",
        "16to19": "32",
        "20to24": "108",
        "25to34": "249",
        "35to44": "354",
        "45to54": "391",
        "55to64": "242",
        "65+": "81",
        "medianAge": "242"
      }
    },
    "title": "Maids and housekeeping cleaners",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,457",
        "women": "88.1",
        "white": "17.2",
        "black": "4.8",
        "asian": "43.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "791",
        "median": "399",
        "maleWorkers": "123",
        "maleMedian": "425",
        "femaleWorkers": "668",
        "femaleMedian": "395"
      }
    }
  },
  "Pest control workers": {
    "ageData": {
      "2012": {
        "total": "73",
        "16to19": "1",
        "20to24": "4",
        "25to34": "16",
        "35to44": "18",
        "45to54": "21",
        "55to64": "10",
        "65+": "4",
        "medianAge": "10"
      }
    },
    "title": "Pest control workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "73",
        "women": "4.7",
        "white": "7.7",
        "black": "0.1",
        "asian": "20.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "62",
        "median": "571",
        "maleWorkers": "59",
        "maleMedian": "570",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Grounds maintenance workers": {
    "ageData": {
      "2012": {
        "total": "1,298",
        "16to19": "77",
        "20to24": "171",
        "25to34": "303",
        "35to44": "280",
        "45to54": "275",
        "55to64": "143",
        "65+": "48",
        "medianAge": "143"
      }
    },
    "title": "Grounds maintenance workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,298",
        "women": "5.1",
        "white": "8.7",
        "black": "1.7",
        "asian": "44.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "795",
        "median": "455",
        "maleWorkers": "766",
        "maleMedian": "452",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Personal care and service occupations": {
    "ageData": {
      "2012": {
        "total": "5,258",
        "16to19": "312",
        "20to24": "738",
        "25to34": "1,107",
        "35to44": "1,004",
        "45to54": "1,047",
        "55to64": "731",
        "65+": "319",
        "medianAge": "731"
      }
    },
    "title": "Personal care and service occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5,258",
        "women": "77.7",
        "white": "14.7",
        "black": "9.5",
        "asian": "16.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,241",
        "median": "468",
        "maleWorkers": "603",
        "maleMedian": "569",
        "femaleWorkers": "1,637",
        "femaleMedian": "428"
      }
    }
  },
  "First-line supervisors of gaming workers": {
    "ageData": {
      "2012": {
        "total": "146",
        "16to19": "1",
        "20to24": "16",
        "25to34": "29",
        "35to44": "37",
        "45to54": "37",
        "55to64": "21",
        "65+": "4",
        "medianAge": "21"
      }
    },
    "title": "First-line supervisors of gaming workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "146",
        "women": "43.0",
        "white": "5.2",
        "black": "9.2",
        "asian": "10.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "92",
        "median": "752",
        "maleWorkers": "59",
        "maleMedian": "864",
        "femaleWorkers": "34",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of personal service workers": {
    "ageData": {
      "2012": {
        "total": "246",
        "16to19": "1",
        "20to24": "13",
        "25to34": "49",
        "35to44": "75",
        "45to54": "63",
        "55to64": "34",
        "65+": "11",
        "medianAge": "34"
      }
    },
    "title": "First-line supervisors of personal service workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "246",
        "women": "70.3",
        "white": "10.7",
        "black": "19.8",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "83",
        "median": "600",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "53",
        "femaleMedian": "518"
      }
    }
  },
  "Animal trainers": {
    "ageData": {
      "2012": {
        "total": "44",
        "16to19": "1",
        "20to24": "9",
        "25to34": "9",
        "35to44": "8",
        "45to54": "12",
        "55to64": "3",
        "65+": "3",
        "medianAge": "3"
      }
    },
    "title": "Animal trainers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Nonfarm animal caretakers": {
    "ageData": {
      "2012": {
        "total": "179",
        "16to19": "16",
        "20to24": "50",
        "25to34": "33",
        "35to44": "25",
        "45to54": "29",
        "55to64": "21",
        "65+": "5",
        "medianAge": "21"
      }
    },
    "title": "Nonfarm animal caretakers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "179",
        "women": "74.2",
        "white": "4.3",
        "black": "1.8",
        "asian": "12.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "78",
        "median": "414",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "57",
        "femaleMedian": "417"
      }
    }
  },
  "Gaming services workers": {
    "ageData": {
      "2012": {
        "total": "106",
        "16to19": "2",
        "20to24": "8",
        "25to34": "25",
        "35to44": "28",
        "45to54": "22",
        "55to64": "15",
        "65+": "6",
        "medianAge": "15"
      }
    },
    "title": "Gaming services workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "106",
        "women": "51.0",
        "white": "9.4",
        "black": "24.3",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "74",
        "median": "604",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "38",
        "femaleMedian": "-"
      }
    }
  },
  "Motion picture projectionists": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Motion picture projectionists",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Ushers, lobby attendants, and ticket takers": {
    "ageData": {
      "2012": {
        "total": "43",
        "16to19": "14",
        "20to24": "17",
        "25to34": "5",
        "35to44": "2",
        "45to54": "1",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Ushers, lobby attendants, and ticket takers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "43",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous entertainment attendants and related workers": {
    "ageData": {
      "2012": {
        "total": "180",
        "16to19": "45",
        "20to24": "45",
        "25to34": "25",
        "35to44": "16",
        "45to54": "18",
        "55to64": "16",
        "65+": "14",
        "medianAge": "16"
      }
    },
    "title": "Miscellaneous entertainment attendants and related workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "180",
        "women": "45.4",
        "white": "14.0",
        "black": "5.1",
        "asian": "17.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "61",
        "median": "470",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Embalmers and funeral attendants": {
    "ageData": {
      "2012": {
        "total": "16",
        "16to19": "1",
        "20to24": "0",
        "25to34": "1",
        "35to44": "3",
        "45to54": "4",
        "55to64": "1",
        "65+": "6",
        "medianAge": "1"
      }
    },
    "title": "Embalmers and funeral attendants",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Morticians, undertakers, and funeral directors": {
    "ageData": {
      "2012": {
        "total": "38",
        "16to19": "0",
        "20to24": "2",
        "25to34": "11",
        "35to44": "4",
        "45to54": "7",
        "55to64": "10",
        "65+": "4",
        "medianAge": "10"
      }
    },
    "title": "Morticians, undertakers, and funeral directors",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Barbers": {
    "ageData": {
      "2012": {
        "total": "109",
        "16to19": "2",
        "20to24": "6",
        "25to34": "34",
        "35to44": "22",
        "45to54": "17",
        "55to64": "14",
        "65+": "14",
        "medianAge": "14"
      }
    },
    "title": "Barbers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "109",
        "women": "21.9",
        "white": "38.2",
        "black": "2.5",
        "asian": "24.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "57",
        "median": "466",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Hairdressers, hairstylists, and cosmetologists": {
    "ageData": {
      "2012": {
        "total": "785",
        "16to19": "12",
        "20to24": "79",
        "25to34": "209",
        "35to44": "170",
        "45to54": "159",
        "55to64": "111",
        "65+": "46",
        "medianAge": "111"
      }
    },
    "title": "Hairdressers, hairstylists, and cosmetologists",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "785",
        "women": "92.8",
        "white": "13.2",
        "black": "6.5",
        "asian": "15.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "294",
        "median": "473",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "272",
        "femaleMedian": "468"
      }
    }
  },
  "Miscellaneous personal appearance workers": {
    "ageData": {
      "2012": {
        "total": "300",
        "16to19": "4",
        "20to24": "17",
        "25to34": "80",
        "35to44": "96",
        "45to54": "61",
        "55to64": "35",
        "65+": "8",
        "medianAge": "35"
      }
    },
    "title": "Miscellaneous personal appearance workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "300",
        "women": "81.5",
        "white": "5.3",
        "black": "59.6",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "154",
        "median": "427",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "123",
        "femaleMedian": "430"
      }
    }
  },
  "Baggage porters, bellhops, and concierges": {
    "ageData": {
      "2012": {
        "total": "68",
        "16to19": "1",
        "20to24": "7",
        "25to34": "15",
        "35to44": "10",
        "45to54": "19",
        "55to64": "8",
        "65+": "7",
        "medianAge": "8"
      }
    },
    "title": "Baggage porters, bellhops, and concierges",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "68",
        "women": "25.0",
        "white": "20.8",
        "black": "13.1",
        "asian": "18.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Tour and travel guides": {
    "ageData": {
      "2012": {
        "total": "51",
        "16to19": "3",
        "20to24": "14",
        "25to34": "9",
        "35to44": "6",
        "45to54": "6",
        "55to64": "6",
        "65+": "8",
        "medianAge": "6"
      }
    },
    "title": "Tour and travel guides",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "51",
        "women": "36.9",
        "white": "3.6",
        "black": "7.1",
        "asian": "15.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Childcare workers": {
    "ageData": {
      "2012": {
        "total": "1,314",
        "16to19": "139",
        "20to24": "221",
        "25to34": "242",
        "35to44": "214",
        "45to54": "258",
        "55to64": "166",
        "65+": "74",
        "medianAge": "166"
      }
    },
    "title": "Childcare workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,314",
        "women": "94.1",
        "white": "15.3",
        "black": "3.3",
        "asian": "20.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "425",
        "median": "390",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "395",
        "femaleMedian": "386"
      }
    }
  },
  "Personal care aides": {
    "ageData": {
      "2012": {
        "total": "1,071",
        "16to19": "29",
        "20to24": "129",
        "25to34": "200",
        "35to44": "185",
        "45to54": "253",
        "55to64": "192",
        "65+": "84",
        "medianAge": "192"
      }
    },
    "title": "Personal care aides",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,071",
        "women": "84.7",
        "white": "21.8",
        "black": "7.9",
        "asian": "21.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "549",
        "median": "422",
        "maleWorkers": "99",
        "maleMedian": "465",
        "femaleWorkers": "450",
        "femaleMedian": "412"
      }
    }
  },
  "Recreation and fitness workers": {
    "ageData": {
      "2012": {
        "total": "406",
        "16to19": "33",
        "20to24": "69",
        "25to34": "100",
        "35to44": "75",
        "45to54": "57",
        "55to64": "56",
        "65+": "15",
        "medianAge": "56"
      }
    },
    "title": "Recreation and fitness workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "406",
        "women": "66.5",
        "white": "10.0",
        "black": "4.5",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "174",
        "median": "575",
        "maleWorkers": "71",
        "maleMedian": "675",
        "femaleWorkers": "102",
        "femaleMedian": "542"
      }
    }
  },
  "Residential advisors": {
    "ageData": {
      "2012": {
        "total": "58",
        "16to19": "1",
        "20to24": "14",
        "25to34": "11",
        "35to44": "9",
        "45to54": "15",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Residential advisors",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "58",
        "women": "61.4",
        "white": "29.1",
        "black": "1.4",
        "asian": "5.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "48",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Personal care and service workers, all other": {
    "ageData": {
      "2012": {
        "total": "95",
        "16to19": "8",
        "20to24": "21",
        "25to34": "22",
        "35to44": "19",
        "45to54": "8",
        "55to64": "12",
        "65+": "6",
        "medianAge": "12"
      }
    },
    "title": "Personal care and service workers, all other",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "95",
        "women": "45.7",
        "white": "5.5",
        "black": "3.3",
        "asian": "17.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Sales and office occupations": {
    "ageData": {
      "2012": {
        "total": "33,152",
        "16to19": "1,534",
        "20to24": "4,157",
        "25to34": "6,712",
        "35to44": "6,318",
        "45to54": "7,207",
        "55to64": "5,398",
        "65+": "1,826",
        "medianAge": "5,398"
      }
    },
    "title": "Sales and office occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33,152",
        "women": "61.8",
        "white": "11.8",
        "black": "4.7",
        "asian": "14.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23,115",
        "median": "655",
        "maleWorkers": "9,202",
        "maleMedian": "768",
        "femaleWorkers": "13,914",
        "femaleMedian": "610"
      }
    }
  },
  "Sales and related occupations": {
    "ageData": {
      "2012": {
        "total": "15,457",
        "16to19": "1,051",
        "20to24": "2,226",
        "25to34": "3,065",
        "35to44": "2,870",
        "45to54": "3,098",
        "55to64": "2,234",
        "65+": "914",
        "medianAge": "2,234"
      }
    },
    "title": "Sales and related occupations",
    "depth": 2,
    "parent": "Sales and office occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "15,457",
        "women": "48.7",
        "white": "10.5",
        "black": "5.3",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9,433",
        "median": "689",
        "maleWorkers": "5,428",
        "maleMedian": "838",
        "femaleWorkers": "4,005",
        "femaleMedian": "521"
      }
    }
  },
  "First-line supervisors of retail sales workers": {
    "ageData": {
      "2012": {
        "total": "3,237",
        "16to19": "23",
        "20to24": "259",
        "25to34": "773",
        "35to44": "732",
        "45to54": "791",
        "55to64": "485",
        "65+": "174",
        "medianAge": "485"
      }
    },
    "title": "First-line supervisors of retail sales workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,237",
        "women": "43.4",
        "white": "8.6",
        "black": "5.9",
        "asian": "11.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,295",
        "median": "711",
        "maleWorkers": "1,317",
        "maleMedian": "792",
        "femaleWorkers": "977",
        "femaleMedian": "598"
      }
    }
  },
  "First-line supervisors of non-retail sales workers": {
    "ageData": {
      "2012": {
        "total": "1,151",
        "16to19": "0",
        "20to24": "25",
        "25to34": "186",
        "35to44": "319",
        "45to54": "326",
        "55to64": "223",
        "65+": "72",
        "medianAge": "223"
      }
    },
    "title": "First-line supervisors of non-retail sales workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,151",
        "women": "24.7",
        "white": "7.2",
        "black": "5.0",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "791",
        "median": "1,045",
        "maleWorkers": "571",
        "maleMedian": "1,130",
        "femaleWorkers": "220",
        "femaleMedian": "847"
      }
    }
  },
  "Cashiers": {
    "ageData": {
      "2012": {
        "total": "3,275",
        "16to19": "677",
        "20to24": "913",
        "25to34": "559",
        "35to44": "371",
        "45to54": "354",
        "55to64": "288",
        "65+": "113",
        "medianAge": "288"
      }
    },
    "title": "Cashiers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,275",
        "women": "71.8",
        "white": "17.2",
        "black": "7.3",
        "asian": "19.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,348",
        "median": "376",
        "maleWorkers": "407",
        "maleMedian": "400",
        "femaleWorkers": "941",
        "femaleMedian": "368"
      }
    }
  },
  "Counter and rental clerks": {
    "ageData": {
      "2012": {
        "total": "139",
        "16to19": "10",
        "20to24": "28",
        "25to34": "32",
        "35to44": "24",
        "45to54": "22",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Counter and rental clerks",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "139",
        "women": "53.4",
        "white": "8.9",
        "black": "5.2",
        "asian": "19.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "96",
        "median": "495",
        "maleWorkers": "54",
        "maleMedian": "591",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Parts salespersons": {
    "ageData": {
      "2012": {
        "total": "106",
        "16to19": "3",
        "20to24": "15",
        "25to34": "21",
        "35to44": "22",
        "45to54": "26",
        "55to64": "17",
        "65+": "2",
        "medianAge": "17"
      }
    },
    "title": "Parts salespersons",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "106",
        "women": "13.3",
        "white": "8.3",
        "black": "4.1",
        "asian": "12.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "88",
        "median": "643",
        "maleWorkers": "79",
        "maleMedian": "661",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Retail salespersons": {
    "ageData": {
      "2012": {
        "total": "3,341",
        "16to19": "294",
        "20to24": "708",
        "25to34": "658",
        "35to44": "486",
        "45to54": "543",
        "55to64": "450",
        "65+": "201",
        "medianAge": "450"
      }
    },
    "title": "Retail salespersons",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,341",
        "women": "50.2",
        "white": "12.5",
        "black": "4.4",
        "asian": "15.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,842",
        "median": "576",
        "maleWorkers": "1,135",
        "maleMedian": "678",
        "femaleWorkers": "707",
        "femaleMedian": "436"
      }
    }
  },
  "Advertising sales agents": {
    "ageData": {
      "2012": {
        "total": "230",
        "16to19": "2",
        "20to24": "23",
        "25to34": "73",
        "35to44": "50",
        "45to54": "49",
        "55to64": "24",
        "65+": "9",
        "medianAge": "24"
      }
    },
    "title": "Advertising sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "230",
        "women": "47.4",
        "white": "9.9",
        "black": "2.3",
        "asian": "7.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "191",
        "median": "909",
        "maleWorkers": "100",
        "maleMedian": "945",
        "femaleWorkers": "91",
        "femaleMedian": "842"
      }
    }
  },
  "Insurance sales agents": {
    "ageData": {
      "2012": {
        "total": "540",
        "16to19": "4",
        "20to24": "27",
        "25to34": "118",
        "35to44": "111",
        "45to54": "134",
        "55to64": "101",
        "65+": "45",
        "medianAge": "101"
      }
    },
    "title": "Insurance sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "540",
        "women": "44.1",
        "white": "8.1",
        "black": "1.8",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "389",
        "median": "827",
        "maleWorkers": "197",
        "maleMedian": "1,026",
        "femaleWorkers": "191",
        "femaleMedian": "641"
      }
    }
  },
  "Securities, commodities, and financial services sales agents": {
    "ageData": {
      "2012": {
        "total": "280",
        "16to19": "1",
        "20to24": "21",
        "25to34": "75",
        "35to44": "65",
        "45to54": "66",
        "55to64": "35",
        "65+": "17",
        "medianAge": "35"
      }
    },
    "title": "Securities, commodities, and financial services sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "280",
        "women": "27.9",
        "white": "3.4",
        "black": "8.3",
        "asian": "8.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "220",
        "median": "1,131",
        "maleWorkers": "156",
        "maleMedian": "1,247",
        "femaleWorkers": "64",
        "femaleMedian": "862"
      }
    }
  },
  "Travel agents": {
    "ageData": {
      "2012": {
        "total": "73",
        "16to19": "0",
        "20to24": "3",
        "25to34": "10",
        "35to44": "14",
        "45to54": "15",
        "55to64": "16",
        "65+": "16",
        "medianAge": "16"
      }
    },
    "title": "Travel agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "73",
        "women": "79.0",
        "white": "2.5",
        "black": "9.3",
        "asian": "4.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "33",
        "femaleMedian": "-"
      }
    }
  },
  "Sales representatives, services, all other": {
    "ageData": {
      "2012": {
        "total": "457",
        "16to19": "3",
        "20to24": "41",
        "25to34": "107",
        "35to44": "109",
        "45to54": "106",
        "55to64": "75",
        "65+": "16",
        "medianAge": "75"
      }
    },
    "title": "Sales representatives, services, all other",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "457",
        "women": "31.0",
        "white": "7.9",
        "black": "3.7",
        "asian": "10.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "415",
        "median": "935",
        "maleWorkers": "286",
        "maleMedian": "992",
        "femaleWorkers": "130",
        "femaleMedian": "825"
      }
    }
  },
  "Sales representatives, wholesale and manufacturing": {
    "ageData": {
      "2012": {
        "total": "1,277",
        "16to19": "8",
        "20to24": "62",
        "25to34": "241",
        "35to44": "319",
        "45to54": "366",
        "55to64": "217",
        "65+": "64",
        "medianAge": "217"
      }
    },
    "title": "Sales representatives, wholesale and manufacturing",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,277",
        "women": "27.0",
        "white": "3.7",
        "black": "3.7",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,091",
        "median": "1,064",
        "maleWorkers": "806",
        "maleMedian": "1,161",
        "femaleWorkers": "285",
        "femaleMedian": "822"
      }
    }
  },
  "Models, demonstrators, and product promoters": {
    "ageData": {
      "2012": {
        "total": "65",
        "16to19": "5",
        "20to24": "8",
        "25to34": "12",
        "35to44": "3",
        "45to54": "11",
        "55to64": "18",
        "65+": "9",
        "medianAge": "18"
      }
    },
    "title": "Models, demonstrators, and product promoters",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "65",
        "women": "83.4",
        "white": "19.4",
        "black": "4.0",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Real estate brokers and sales agents": {
    "ageData": {
      "2012": {
        "total": "761",
        "16to19": "1",
        "20to24": "24",
        "25to34": "89",
        "35to44": "153",
        "45to54": "185",
        "55to64": "191",
        "65+": "116",
        "medianAge": "191"
      }
    },
    "title": "Real estate brokers and sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "761",
        "women": "57.1",
        "white": "4.0",
        "black": "4.7",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "328",
        "median": "789",
        "maleWorkers": "134",
        "maleMedian": "1,031",
        "femaleWorkers": "194",
        "femaleMedian": "680"
      }
    }
  },
  "Sales engineers": {
    "ageData": {
      "2012": {
        "total": "27",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "6",
        "45to54": "9",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Sales engineers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Telemarketers": {
    "ageData": {
      "2012": {
        "total": "97",
        "16to19": "8",
        "20to24": "30",
        "25to34": "24",
        "35to44": "12",
        "45to54": "8",
        "55to64": "11",
        "65+": "4",
        "medianAge": "11"
      }
    },
    "title": "Telemarketers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "97",
        "women": "50.3",
        "white": "23.0",
        "black": "1.1",
        "asian": "14.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "65",
        "median": "464",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Door-to-door sales workers, news and street vendors, and related workers": {
    "ageData": {
      "2012": {
        "total": "198",
        "16to19": "7",
        "20to24": "19",
        "25to34": "40",
        "35to44": "32",
        "45to54": "43",
        "55to64": "31",
        "65+": "26",
        "medianAge": "31"
      }
    },
    "title": "Door-to-door sales workers, news and street vendors, and related workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "198",
        "women": "62.2",
        "white": "10.2",
        "black": "3.8",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "43",
        "median": "-",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Sales and related workers, all other": {
    "ageData": {
      "2012": {
        "total": "204",
        "16to19": "4",
        "20to24": "18",
        "25to34": "40",
        "35to44": "41",
        "45to54": "44",
        "55to64": "30",
        "65+": "26",
        "medianAge": "30"
      }
    },
    "title": "Sales and related workers, all other",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "204",
        "women": "47.9",
        "white": "7.7",
        "black": "4.7",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "144",
        "median": "785",
        "maleWorkers": "81",
        "maleMedian": "996",
        "femaleWorkers": "62",
        "femaleMedian": "653"
      }
    }
  },
  "Office and administrative support occupations": {
    "ageData": {
      "2012": {
        "total": "17,695",
        "16to19": "483",
        "20to24": "1,931",
        "25to34": "3,647",
        "35to44": "3,448",
        "45to54": "4,110",
        "55to64": "3,164",
        "65+": "912",
        "medianAge": "3,164"
      }
    },
    "title": "Office and administrative support occupations",
    "depth": 2,
    "parent": "Sales and office occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "17,695",
        "women": "73.3",
        "white": "12.9",
        "black": "4.2",
        "asian": "14.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "13,683",
        "median": "643",
        "maleWorkers": "3,774",
        "maleMedian": "700",
        "femaleWorkers": "9,909",
        "femaleMedian": "629"
      }
    }
  },
  "First-line supervisors of office and administrative support workers": {
    "ageData": {
      "2012": {
        "total": "1,416",
        "16to19": "7",
        "20to24": "41",
        "25to34": "287",
        "35to44": "347",
        "45to54": "392",
        "55to64": "291",
        "65+": "50",
        "medianAge": "291"
      }
    },
    "title": "First-line supervisors of office and administrative support workers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,416",
        "women": "68.5",
        "white": "11.3",
        "black": "3.5",
        "asian": "11.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,274",
        "median": "795",
        "maleWorkers": "416",
        "maleMedian": "895",
        "femaleWorkers": "858",
        "femaleMedian": "760"
      }
    }
  },
  "Switchboard operators, including answering service": {
    "ageData": {
      "2012": {
        "total": "35",
        "16to19": "1",
        "20to24": "5",
        "25to34": "9",
        "35to44": "3",
        "45to54": "7",
        "55to64": "6",
        "65+": "4",
        "medianAge": "6"
      }
    },
    "title": "Switchboard operators, including answering service",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Telephone operators": {
    "ageData": {
      "2012": {
        "total": "42",
        "16to19": "1",
        "20to24": "8",
        "25to34": "12",
        "35to44": "4",
        "45to54": "10",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Telephone operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Communications equipment operators, all other": {
    "ageData": {
      "2012": {
        "total": "9",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Communications equipment operators, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Bill and account collectors": {
    "ageData": {
      "2012": {
        "total": "206",
        "16to19": "2",
        "20to24": "25",
        "25to34": "63",
        "35to44": "46",
        "45to54": "35",
        "55to64": "29",
        "65+": "6",
        "medianAge": "29"
      }
    },
    "title": "Bill and account collectors",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "206",
        "women": "69.1",
        "white": "15.3",
        "black": "3.6",
        "asian": "17.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "183",
        "median": "640",
        "maleWorkers": "61",
        "maleMedian": "681",
        "femaleWorkers": "122",
        "femaleMedian": "633"
      }
    }
  },
  "Billing and posting clerks": {
    "ageData": {
      "2012": {
        "total": "475",
        "16to19": "4",
        "20to24": "27",
        "25to34": "110",
        "35to44": "109",
        "45to54": "118",
        "55to64": "93",
        "65+": "14",
        "medianAge": "93"
      }
    },
    "title": "Billing and posting clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "475",
        "women": "90.1",
        "white": "11.8",
        "black": "4.0",
        "asian": "16.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "394",
        "median": "627",
        "maleWorkers": "47",
        "maleMedian": "-",
        "femaleWorkers": "347",
        "femaleMedian": "615"
      }
    }
  },
  "Bookkeeping, accounting, and auditing clerks": {
    "ageData": {
      "2012": {
        "total": "1,268",
        "16to19": "7",
        "20to24": "63",
        "25to34": "164",
        "35to44": "249",
        "45to54": "351",
        "55to64": "310",
        "65+": "124",
        "medianAge": "310"
      }
    },
    "title": "Bookkeeping, accounting, and auditing clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,268",
        "women": "89.1",
        "white": "7.6",
        "black": "5.0",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "857",
        "median": "677",
        "maleWorkers": "102",
        "maleMedian": "740",
        "femaleWorkers": "755",
        "femaleMedian": "672"
      }
    }
  },
  "Gaming cage workers": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Gaming cage workers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Payroll and timekeeping clerks": {
    "ageData": {
      "2012": {
        "total": "155",
        "16to19": "0",
        "20to24": "4",
        "25to34": "20",
        "35to44": "35",
        "45to54": "58",
        "55to64": "31",
        "65+": "5",
        "medianAge": "31"
      }
    },
    "title": "Payroll and timekeeping clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "155",
        "women": "92.6",
        "white": "9.5",
        "black": "4.6",
        "asian": "15.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "126",
        "median": "702",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "116",
        "femaleMedian": "707"
      }
    }
  },
  "Procurement clerks": {
    "ageData": {
      "2012": {
        "total": "27",
        "16to19": "0",
        "20to24": "0",
        "25to34": "7",
        "35to44": "7",
        "45to54": "5",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Procurement clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Tellers": {
    "ageData": {
      "2012": {
        "total": "380",
        "16to19": "13",
        "20to24": "107",
        "25to34": "85",
        "35to44": "68",
        "45to54": "57",
        "55to64": "36",
        "65+": "15",
        "medianAge": "36"
      }
    },
    "title": "Tellers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "380",
        "women": "87.3",
        "white": "11.6",
        "black": "5.7",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "268",
        "median": "497",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "238",
        "femaleMedian": "499"
      }
    }
  },
  "Financial clerks, all other": {
    "ageData": {
      "2012": {
        "total": "52",
        "16to19": "2",
        "20to24": "5",
        "25to34": "11",
        "35to44": "8",
        "45to54": "13",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Financial clerks, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "52",
        "women": "68.4",
        "white": "17.1",
        "black": "4.1",
        "asian": "16.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Brokerage clerks": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "3",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Brokerage clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Correspondence clerks": {
    "ageData": {
      "2012": {
        "total": "6",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Correspondence clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Court, municipal, and license clerks": {
    "ageData": {
      "2012": {
        "total": "85",
        "16to19": "0",
        "20to24": "3",
        "25to34": "16",
        "35to44": "15",
        "45to54": "28",
        "55to64": "19",
        "65+": "4",
        "medianAge": "19"
      }
    },
    "title": "Court, municipal, and license clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "85",
        "women": "77.2",
        "white": "23.0",
        "black": "1.2",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "77",
        "median": "699",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "63",
        "femaleMedian": "693"
      }
    }
  },
  "Credit authorizers, checkers, and clerks": {
    "ageData": {
      "2012": {
        "total": "43",
        "16to19": "0",
        "20to24": "4",
        "25to34": "9",
        "35to44": "11",
        "45to54": "13",
        "55to64": "6",
        "65+": "0",
        "medianAge": "6"
      }
    },
    "title": "Credit authorizers, checkers, and clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "43",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "31",
        "femaleMedian": "-"
      }
    }
  },
  "Customer service representatives": {
    "ageData": {
      "2012": {
        "total": "1,956",
        "16to19": "92",
        "20to24": "333",
        "25to34": "508",
        "35to44": "381",
        "45to54": "348",
        "55to64": "237",
        "65+": "58",
        "medianAge": "237"
      }
    },
    "title": "Customer service representatives",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,956",
        "women": "67.8",
        "white": "16.2",
        "black": "4.2",
        "asian": "18.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,535",
        "median": "608",
        "maleWorkers": "502",
        "maleMedian": "684",
        "femaleWorkers": "1,033",
        "femaleMedian": "585"
      }
    }
  },
  "Eligibility interviewers, government programs": {
    "ageData": {
      "2012": {
        "total": "92",
        "16to19": "0",
        "20to24": "2",
        "25to34": "23",
        "35to44": "20",
        "45to54": "20",
        "55to64": "21",
        "65+": "6",
        "medianAge": "21"
      }
    },
    "title": "Eligibility interviewers, government programs",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "92",
        "women": "81.4",
        "white": "19.8",
        "black": "2.1",
        "asian": "23.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "78",
        "median": "769",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "61",
        "femaleMedian": "730"
      }
    }
  },
  "File clerks": {
    "ageData": {
      "2012": {
        "total": "292",
        "16to19": "27",
        "20to24": "34",
        "25to34": "51",
        "35to44": "45",
        "45to54": "69",
        "55to64": "49",
        "65+": "17",
        "medianAge": "49"
      }
    },
    "title": "File clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "292",
        "women": "81.3",
        "white": "14.1",
        "black": "4.6",
        "asian": "16.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "204",
        "median": "645",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "159",
        "femaleMedian": "635"
      }
    }
  },
  "Hotel, motel, and resort desk clerks": {
    "ageData": {
      "2012": {
        "total": "110",
        "16to19": "8",
        "20to24": "34",
        "25to34": "32",
        "35to44": "16",
        "45to54": "10",
        "55to64": "7",
        "65+": "3",
        "medianAge": "7"
      }
    },
    "title": "Hotel, motel, and resort desk clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "110",
        "women": "64.6",
        "white": "18.4",
        "black": "6.3",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "73",
        "median": "522",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "44",
        "femaleMedian": "-"
      }
    }
  },
  "Interviewers, except eligibility and loan": {
    "ageData": {
      "2012": {
        "total": "135",
        "16to19": "3",
        "20to24": "16",
        "25to34": "35",
        "35to44": "25",
        "45to54": "27",
        "55to64": "27",
        "65+": "3",
        "medianAge": "27"
      }
    },
    "title": "Interviewers, except eligibility and loan",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "135",
        "women": "83.7",
        "white": "20.0",
        "black": "6.0",
        "asian": "12.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "104",
        "median": "593",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "91",
        "femaleMedian": "581"
      }
    }
  },
  "Library assistants, clerical": {
    "ageData": {
      "2012": {
        "total": "97",
        "16to19": "3",
        "20to24": "16",
        "25to34": "11",
        "35to44": "11",
        "45to54": "22",
        "55to64": "22",
        "65+": "12",
        "medianAge": "22"
      }
    },
    "title": "Library assistants, clerical",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "97",
        "women": "84.0",
        "white": "7.0",
        "black": "3.2",
        "asian": "5.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "34",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Loan interviewers and clerks": {
    "ageData": {
      "2012": {
        "total": "144",
        "16to19": "0",
        "20to24": "7",
        "25to34": "50",
        "35to44": "34",
        "45to54": "33",
        "55to64": "16",
        "65+": "3",
        "medianAge": "16"
      }
    },
    "title": "Loan interviewers and clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "144",
        "women": "81.2",
        "white": "10.9",
        "black": "4.0",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "133",
        "median": "692",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "107",
        "femaleMedian": "682"
      }
    }
  },
  "New accounts clerks": {
    "ageData": {
      "2012": {
        "total": "26",
        "16to19": "0",
        "20to24": "5",
        "25to34": "6",
        "35to44": "6",
        "45to54": "6",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "New accounts clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "26",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Order clerks": {
    "ageData": {
      "2012": {
        "total": "104",
        "16to19": "5",
        "20to24": "14",
        "25to34": "25",
        "35to44": "19",
        "45to54": "20",
        "55to64": "15",
        "65+": "5",
        "medianAge": "15"
      }
    },
    "title": "Order clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "104",
        "women": "58.2",
        "white": "5.8",
        "black": "4.1",
        "asian": "21.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "90",
        "median": "561",
        "maleWorkers": "37",
        "maleMedian": "-",
        "femaleWorkers": "53",
        "femaleMedian": "595"
      }
    }
  },
  "Human resources assistants, except payroll and timekeeping": {
    "ageData": {
      "2012": {
        "total": "132",
        "16to19": "0",
        "20to24": "13",
        "25to34": "37",
        "35to44": "34",
        "45to54": "20",
        "55to64": "25",
        "65+": "3",
        "medianAge": "25"
      }
    },
    "title": "Human resources assistants, except payroll and timekeeping",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "132",
        "women": "82.7",
        "white": "18.3",
        "black": "1.9",
        "asian": "7.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "105",
        "median": "759",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "88",
        "femaleMedian": "724"
      }
    }
  },
  "Receptionists and information clerks": {
    "ageData": {
      "2012": {
        "total": "1,237",
        "16to19": "56",
        "20to24": "234",
        "25to34": "276",
        "35to44": "215",
        "45to54": "211",
        "55to64": "179",
        "65+": "65",
        "medianAge": "179"
      }
    },
    "title": "Receptionists and information clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,237",
        "women": "91.5",
        "white": "12.1",
        "black": "4.3",
        "asian": "17.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "831",
        "median": "531",
        "maleWorkers": "73",
        "maleMedian": "604",
        "femaleWorkers": "758",
        "femaleMedian": "524"
      }
    }
  },
  "Reservation and transportation ticket agents and travel clerks": {
    "ageData": {
      "2012": {
        "total": "117",
        "16to19": "3",
        "20to24": "11",
        "25to34": "26",
        "35to44": "29",
        "45to54": "29",
        "55to64": "16",
        "65+": "2",
        "medianAge": "16"
      }
    },
    "title": "Reservation and transportation ticket agents and travel clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "117",
        "women": "58.6",
        "white": "21.8",
        "black": "10.9",
        "asian": "21.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "99",
        "median": "738",
        "maleWorkers": "45",
        "maleMedian": "-",
        "femaleWorkers": "54",
        "femaleMedian": "634"
      }
    }
  },
  "Information and record clerks, all other": {
    "ageData": {
      "2012": {
        "total": "104",
        "16to19": "2",
        "20to24": "5",
        "25to34": "21",
        "35to44": "24",
        "45to54": "23",
        "55to64": "23",
        "65+": "7",
        "medianAge": "23"
      }
    },
    "title": "Information and record clerks, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "104",
        "women": "80.2",
        "white": "17.0",
        "black": "2.5",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "87",
        "median": "661",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "73",
        "femaleMedian": "677"
      }
    }
  },
  "Cargo and freight agents": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "4",
        "45to54": "12",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Cargo and freight agents",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Couriers and messengers": {
    "ageData": {
      "2012": {
        "total": "213",
        "16to19": "3",
        "20to24": "16",
        "25to34": "40",
        "35to44": "49",
        "45to54": "45",
        "55to64": "38",
        "65+": "22",
        "medianAge": "38"
      }
    },
    "title": "Couriers and messengers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "213",
        "women": "15.5",
        "white": "13.0",
        "black": "2.4",
        "asian": "16.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "139",
        "median": "737",
        "maleWorkers": "120",
        "maleMedian": "744",
        "femaleWorkers": "19",
        "femaleMedian": "-"
      }
    }
  },
  "Dispatchers": {
    "ageData": {
      "2012": {
        "total": "277",
        "16to19": "3",
        "20to24": "19",
        "25to34": "85",
        "35to44": "64",
        "45to54": "61",
        "55to64": "38",
        "65+": "6",
        "medianAge": "38"
      }
    },
    "title": "Dispatchers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "277",
        "women": "61.5",
        "white": "13.5",
        "black": "2.3",
        "asian": "16.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "252",
        "median": "648",
        "maleWorkers": "94",
        "maleMedian": "796",
        "femaleWorkers": "159",
        "femaleMedian": "605"
      }
    }
  },
  "Meter readers, utilities": {
    "ageData": {
      "2012": {
        "total": "29",
        "16to19": "0",
        "20to24": "4",
        "25to34": "8",
        "35to44": "6",
        "45to54": "8",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Meter readers, utilities",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Postal service clerks": {
    "ageData": {
      "2012": {
        "total": "148",
        "16to19": "1",
        "20to24": "1",
        "25to34": "8",
        "35to44": "20",
        "45to54": "47",
        "55to64": "65",
        "65+": "5",
        "medianAge": "65"
      }
    },
    "title": "Postal service clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "148",
        "women": "50.0",
        "white": "21.3",
        "black": "9.5",
        "asian": "12.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "137",
        "median": "980",
        "maleWorkers": "64",
        "maleMedian": "1,000",
        "femaleWorkers": "73",
        "femaleMedian": "910"
      }
    }
  },
  "Postal service mail carriers": {
    "ageData": {
      "2012": {
        "total": "318",
        "16to19": "0",
        "20to24": "1",
        "25to34": "31",
        "35to44": "65",
        "45to54": "126",
        "55to64": "83",
        "65+": "10",
        "medianAge": "83"
      }
    },
    "title": "Postal service mail carriers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "318",
        "women": "37.7",
        "white": "16.5",
        "black": "6.7",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "279",
        "median": "990",
        "maleWorkers": "186",
        "maleMedian": "1,026",
        "femaleWorkers": "93",
        "femaleMedian": "907"
      }
    }
  },
  "Postal service mail sorters, processors, and processing machine operators": {
    "ageData": {
      "2012": {
        "total": "66",
        "16to19": "1",
        "20to24": "5",
        "25to34": "6",
        "35to44": "10",
        "45to54": "21",
        "55to64": "19",
        "65+": "3",
        "medianAge": "19"
      }
    },
    "title": "Postal service mail sorters, processors, and processing machine operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "66",
        "women": "47.6",
        "white": "28.6",
        "black": "12.7",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "56",
        "median": "891",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Production, planning, and expediting clerks": {
    "ageData": {
      "2012": {
        "total": "272",
        "16to19": "2",
        "20to24": "15",
        "25to34": "69",
        "35to44": "59",
        "45to54": "62",
        "55to64": "55",
        "65+": "10",
        "medianAge": "55"
      }
    },
    "title": "Production, planning, and expediting clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "272",
        "women": "55.0",
        "white": "11.0",
        "black": "3.2",
        "asian": "12.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "242",
        "median": "858",
        "maleWorkers": "111",
        "maleMedian": "946",
        "femaleWorkers": "131",
        "femaleMedian": "765"
      }
    }
  },
  "Shipping, receiving, and traffic clerks": {
    "ageData": {
      "2012": {
        "total": "527",
        "16to19": "11",
        "20to24": "74",
        "25to34": "126",
        "35to44": "112",
        "45to54": "116",
        "55to64": "71",
        "65+": "16",
        "medianAge": "71"
      }
    },
    "title": "Shipping, receiving, and traffic clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "527",
        "women": "27.8",
        "white": "15.6",
        "black": "3.6",
        "asian": "23.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "458",
        "median": "556",
        "maleWorkers": "333",
        "maleMedian": "577",
        "femaleWorkers": "125",
        "femaleMedian": "522"
      }
    }
  },
  "Stock clerks and order fillers": {
    "ageData": {
      "2012": {
        "total": "1,453",
        "16to19": "124",
        "20to24": "308",
        "25to34": "315",
        "35to44": "217",
        "45to54": "244",
        "55to64": "172",
        "65+": "73",
        "medianAge": "172"
      }
    },
    "title": "Stock clerks and order fillers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,453",
        "women": "35.5",
        "white": "16.7",
        "black": "4.5",
        "asian": "18.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "936",
        "median": "505",
        "maleWorkers": "625",
        "maleMedian": "516",
        "femaleWorkers": "310",
        "femaleMedian": "484"
      }
    }
  },
  "Weighers, measurers, checkers, and samplers, recordkeeping": {
    "ageData": {
      "2012": {
        "total": "74",
        "16to19": "1",
        "20to24": "8",
        "25to34": "22",
        "35to44": "20",
        "45to54": "11",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Weighers, measurers, checkers, and samplers, recordkeeping",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "74",
        "women": "49.1",
        "white": "19.9",
        "black": "2.8",
        "asian": "21.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "64",
        "median": "638",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Secretaries and administrative assistants": {
    "ageData": {
      "2012": {
        "total": "2,904",
        "16to19": "28",
        "20to24": "163",
        "25to34": "465",
        "35to44": "559",
        "45to54": "792",
        "55to64": "685",
        "65+": "212",
        "medianAge": "685"
      }
    },
    "title": "Secretaries and administrative assistants",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2,904",
        "women": "95.3",
        "white": "8.6",
        "black": "3.2",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,251",
        "median": "669",
        "maleWorkers": "105",
        "maleMedian": "803",
        "femaleWorkers": "2,146",
        "femaleMedian": "665"
      }
    }
  },
  "Computer operators": {
    "ageData": {
      "2012": {
        "total": "102",
        "16to19": "2",
        "20to24": "9",
        "25to34": "15",
        "35to44": "23",
        "45to54": "31",
        "55to64": "17",
        "65+": "5",
        "medianAge": "17"
      }
    },
    "title": "Computer operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "102",
        "women": "50.7",
        "white": "12.2",
        "black": "6.5",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "87",
        "median": "785",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "45",
        "femaleMedian": "-"
      }
    }
  },
  "Data entry keyers": {
    "ageData": {
      "2012": {
        "total": "337",
        "16to19": "9",
        "20to24": "40",
        "25to34": "88",
        "35to44": "58",
        "45to54": "80",
        "55to64": "54",
        "65+": "9",
        "medianAge": "54"
      }
    },
    "title": "Data entry keyers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "337",
        "women": "77.0",
        "white": "14.0",
        "black": "5.1",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "259",
        "median": "591",
        "maleWorkers": "57",
        "maleMedian": "611",
        "femaleWorkers": "202",
        "femaleMedian": "586"
      }
    }
  },
  "Word processors and typists": {
    "ageData": {
      "2012": {
        "total": "119",
        "16to19": "1",
        "20to24": "7",
        "25to34": "24",
        "35to44": "23",
        "45to54": "34",
        "55to64": "23",
        "65+": "7",
        "medianAge": "23"
      }
    },
    "title": "Word processors and typists",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "119",
        "women": "88.7",
        "white": "12.4",
        "black": "2.8",
        "asian": "12.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "90",
        "median": "624",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "82",
        "femaleMedian": "622"
      }
    }
  },
  "Desktop publishers": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Desktop publishers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Insurance claims and policy processing clerks": {
    "ageData": {
      "2012": {
        "total": "230",
        "16to19": "0",
        "20to24": "17",
        "25to34": "70",
        "35to44": "41",
        "45to54": "60",
        "55to64": "34",
        "65+": "7",
        "medianAge": "34"
      }
    },
    "title": "Insurance claims and policy processing clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "230",
        "women": "81.9",
        "white": "12.7",
        "black": "3.6",
        "asian": "13.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "226",
        "median": "643",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "182",
        "femaleMedian": "631"
      }
    }
  },
  "Mail clerks and mail machine operators, except postal service": {
    "ageData": {
      "2012": {
        "total": "81",
        "16to19": "2",
        "20to24": "11",
        "25to34": "9",
        "35to44": "12",
        "45to54": "18",
        "55to64": "21",
        "65+": "9",
        "medianAge": "21"
      }
    },
    "title": "Mail clerks and mail machine operators, except postal service",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "81",
        "women": "41.2",
        "white": "18.1",
        "black": "10.6",
        "asian": "10.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "72",
        "median": "580",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Office clerks, general": {
    "ageData": {
      "2012": {
        "total": "1,103",
        "16to19": "45",
        "20to24": "147",
        "25to34": "220",
        "35to44": "192",
        "45to54": "261",
        "55to64": "172",
        "65+": "66",
        "medianAge": "172"
      }
    },
    "title": "Office clerks, general",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,103",
        "women": "83.4",
        "white": "12.4",
        "black": "5.0",
        "asian": "16.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "798",
        "median": "601",
        "maleWorkers": "131",
        "maleMedian": "607",
        "femaleWorkers": "667",
        "femaleMedian": "600"
      }
    }
  },
  "Office machine operators, except computer": {
    "ageData": {
      "2012": {
        "total": "46",
        "16to19": "2",
        "20to24": "8",
        "25to34": "10",
        "35to44": "6",
        "45to54": "9",
        "55to64": "9",
        "65+": "2",
        "medianAge": "9"
      }
    },
    "title": "Office machine operators, except computer",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "34",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Proofreaders and copy markers": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "0",
        "45to54": "2",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Proofreaders and copy markers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Statistical assistants": {
    "ageData": {
      "2012": {
        "total": "32",
        "16to19": "0",
        "20to24": "4",
        "25to34": "9",
        "35to44": "6",
        "45to54": "7",
        "55to64": "3",
        "65+": "3",
        "medianAge": "3"
      }
    },
    "title": "Statistical assistants",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Office and administrative support workers, all other": {
    "ageData": {
      "2012": {
        "total": "570",
        "16to19": "9",
        "20to24": "54",
        "25to34": "121",
        "35to44": "126",
        "45to54": "131",
        "55to64": "99",
        "65+": "29",
        "medianAge": "99"
      }
    },
    "title": "Office and administrative support workers, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "570",
        "women": "77.3",
        "white": "14.1",
        "black": "3.9",
        "asian": "11.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "452",
        "median": "707",
        "maleWorkers": "103",
        "maleMedian": "788",
        "femaleWorkers": "349",
        "femaleMedian": "686"
      }
    }
  },
  "Natural resources, construction, and maintenance occupations": {
    "ageData": {
      "2012": {
        "total": "12,821",
        "16to19": "295",
        "20to24": "1,067",
        "25to34": "3,077",
        "35to44": "3,045",
        "45to54": "3,092",
        "55to64": "1,840",
        "65+": "404",
        "medianAge": "1,840"
      }
    },
    "title": "Natural resources, construction, and maintenance occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "12,821",
        "women": "4.3",
        "white": "7.0",
        "black": "2.1",
        "asian": "25.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9,968",
        "median": "740",
        "maleWorkers": "9,579",
        "maleMedian": "749",
        "femaleWorkers": "389",
        "femaleMedian": "550"
      }
    }
  },
  "Farming, fishing, and forestry occupations": {
    "ageData": {
      "2012": {
        "total": "994",
        "16to19": "88",
        "20to24": "134",
        "25to34": "232",
        "35to44": "191",
        "45to54": "185",
        "55to64": "117",
        "65+": "47",
        "medianAge": "117"
      }
    },
    "title": "Farming, fishing, and forestry occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "994",
        "women": "22.7",
        "white": "5.3",
        "black": "1.8",
        "asian": "44.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "777",
        "median": "435",
        "maleWorkers": "611",
        "maleMedian": "457",
        "femaleWorkers": "166",
        "femaleMedian": "377"
      }
    }
  },
  "First-line supervisors of farming, fishing, and forestry workers": {
    "ageData": {
      "2012": {
        "total": "50",
        "16to19": "0",
        "20to24": "2",
        "25to34": "9",
        "35to44": "11",
        "45to54": "15",
        "55to64": "8",
        "65+": "5",
        "medianAge": "8"
      }
    },
    "title": "First-line supervisors of farming, fishing, and forestry workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "50",
        "women": "14.1",
        "white": "7.8",
        "black": "4.2",
        "asian": "23.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural inspectors": {
    "ageData": {
      "2012": {
        "total": "16",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "6",
        "45to54": "4",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Agricultural inspectors",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Animal breeders": {
    "ageData": {
      "2012": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Animal breeders",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Graders and sorters, agricultural products": {
    "ageData": {
      "2012": {
        "total": "118",
        "16to19": "4",
        "20to24": "8",
        "25to34": "30",
        "35to44": "24",
        "45to54": "30",
        "55to64": "19",
        "65+": "3",
        "medianAge": "19"
      }
    },
    "title": "Graders and sorters, agricultural products",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "118",
        "women": "59.8",
        "white": "16.6",
        "black": "2.1",
        "asian": "58.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "108",
        "median": "410",
        "maleWorkers": "37",
        "maleMedian": "-",
        "femaleWorkers": "70",
        "femaleMedian": "396"
      }
    }
  },
  "Miscellaneous agricultural workers": {
    "ageData": {
      "2012": {
        "total": "711",
        "16to19": "79",
        "20to24": "119",
        "25to34": "172",
        "35to44": "135",
        "45to54": "108",
        "55to64": "68",
        "65+": "31",
        "medianAge": "68"
      }
    },
    "title": "Miscellaneous agricultural workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "711",
        "women": "18.9",
        "white": "3.2",
        "black": "1.5",
        "asian": "48.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "560",
        "median": "426",
        "maleWorkers": "478",
        "maleMedian": "444",
        "femaleWorkers": "81",
        "femaleMedian": "350"
      }
    }
  },
  "Fishers and related fishing workers": {
    "ageData": {
      "2012": {
        "total": "33",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "5",
        "45to54": "10",
        "55to64": "6",
        "65+": "5",
        "medianAge": "6"
      }
    },
    "title": "Fishers and related fishing workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Hunters and trappers": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Hunters and trappers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Forest and conservation workers": {
    "ageData": {
      "2012": {
        "total": "9",
        "16to19": "2",
        "20to24": "1",
        "25to34": "1",
        "35to44": "1",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Forest and conservation workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Logging workers": {
    "ageData": {
      "2012": {
        "total": "49",
        "16to19": "2",
        "20to24": "3",
        "25to34": "11",
        "35to44": "8",
        "45to54": "15",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Logging workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "49",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Construction and extraction occupations": {
    "ageData": {
      "2012": {
        "total": "7,005",
        "16to19": "132",
        "20to24": "544",
        "25to34": "1,773",
        "35to44": "1,701",
        "45to54": "1,706",
        "55to64": "957",
        "65+": "192",
        "medianAge": "957"
      }
    },
    "title": "Construction and extraction occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7,005",
        "women": "2.5",
        "white": "6.2",
        "black": "1.6",
        "asian": "28.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5,102",
        "median": "740",
        "maleWorkers": "5,004",
        "maleMedian": "741",
        "femaleWorkers": "98",
        "femaleMedian": "723"
      }
    }
  },
  "First-line supervisors of construction trades and extraction workers": {
    "ageData": {
      "2012": {
        "total": "634",
        "16to19": "0",
        "20to24": "14",
        "25to34": "131",
        "35to44": "152",
        "45to54": "188",
        "55to64": "115",
        "65+": "34",
        "medianAge": "115"
      }
    },
    "title": "First-line supervisors of construction trades and extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "634",
        "women": "2.8",
        "white": "4.5",
        "black": "1.3",
        "asian": "14.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "488",
        "median": "1,019",
        "maleWorkers": "475",
        "maleMedian": "1,018",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Boilermakers": {
    "ageData": {
      "2012": {
        "total": "23",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "4",
        "45to54": "6",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Boilermakers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Brickmasons, blockmasons, and stonemasons": {
    "ageData": {
      "2012": {
        "total": "122",
        "16to19": "5",
        "20to24": "8",
        "25to34": "27",
        "35to44": "40",
        "45to54": "28",
        "55to64": "12",
        "65+": "2",
        "medianAge": "12"
      }
    },
    "title": "Brickmasons, blockmasons, and stonemasons",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "122",
        "women": "0.1",
        "white": "5.8",
        "black": "0.3",
        "asian": "43.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "94",
        "median": "641",
        "maleWorkers": "94",
        "maleMedian": "641",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Carpenters": {
    "ageData": {
      "2012": {
        "total": "1,223",
        "16to19": "22",
        "20to24": "81",
        "25to34": "308",
        "35to44": "308",
        "45to54": "295",
        "55to64": "175",
        "65+": "34",
        "medianAge": "175"
      }
    },
    "title": "Carpenters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,223",
        "women": "1.6",
        "white": "4.2",
        "black": "1.9",
        "asian": "29.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "750",
        "median": "675",
        "maleWorkers": "743",
        "maleMedian": "673",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Carpet, floor, and tile installers and finishers": {
    "ageData": {
      "2012": {
        "total": "150",
        "16to19": "2",
        "20to24": "18",
        "25to34": "38",
        "35to44": "36",
        "45to54": "36",
        "55to64": "19",
        "65+": "1",
        "medianAge": "19"
      }
    },
    "title": "Carpet, floor, and tile installers and finishers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "150",
        "women": "2.2",
        "white": "8.8",
        "black": "0.4",
        "asian": "37.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "84",
        "median": "599",
        "maleWorkers": "83",
        "maleMedian": "603",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Cement masons, concrete finishers, and terrazzo workers": {
    "ageData": {
      "2012": {
        "total": "68",
        "16to19": "0",
        "20to24": "6",
        "25to34": "20",
        "35to44": "18",
        "45to54": "19",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Cement masons, concrete finishers, and terrazzo workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "68",
        "women": "2.7",
        "white": "5.8",
        "black": "3.1",
        "asian": "53.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "53",
        "median": "601",
        "maleWorkers": "53",
        "maleMedian": "601",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Construction laborers": {
    "ageData": {
      "2012": {
        "total": "1,387",
        "16to19": "45",
        "20to24": "161",
        "25to34": "412",
        "35to44": "313",
        "45to54": "282",
        "55to64": "140",
        "65+": "33",
        "medianAge": "140"
      }
    },
    "title": "Construction laborers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,387",
        "women": "2.9",
        "white": "8.4",
        "black": "2.0",
        "asian": "41.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "937",
        "median": "607",
        "maleWorkers": "913",
        "maleMedian": "609",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Paving, surfacing, and tamping equipment operators": {
    "ageData": {
      "2012": {
        "total": "23",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "6",
        "45to54": "4",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Paving, surfacing, and tamping equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Pile-driver operators": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Pile-driver operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Operating engineers and other construction equipment operators": {
    "ageData": {
      "2012": {
        "total": "348",
        "16to19": "5",
        "20to24": "22",
        "25to34": "69",
        "35to44": "74",
        "45to54": "94",
        "55to64": "75",
        "65+": "10",
        "medianAge": "75"
      }
    },
    "title": "Operating engineers and other construction equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "348",
        "women": "1.3",
        "white": "6.0",
        "black": "0.2",
        "asian": "17.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "321",
        "median": "805",
        "maleWorkers": "316",
        "maleMedian": "805",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Drywall installers, ceiling tile installers, and tapers": {
    "ageData": {
      "2012": {
        "total": "129",
        "16to19": "2",
        "20to24": "10",
        "25to34": "42",
        "35to44": "39",
        "45to54": "24",
        "55to64": "11",
        "65+": "1",
        "medianAge": "11"
      }
    },
    "title": "Drywall installers, ceiling tile installers, and tapers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "129",
        "women": "0.3",
        "white": "2.7",
        "black": "0.0",
        "asian": "62.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "94",
        "median": "568",
        "maleWorkers": "94",
        "maleMedian": "567",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electricians": {
    "ageData": {
      "2012": {
        "total": "692",
        "16to19": "6",
        "20to24": "42",
        "25to34": "150",
        "35to44": "172",
        "45to54": "196",
        "55to64": "111",
        "65+": "15",
        "medianAge": "111"
      }
    },
    "title": "Electricians",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "692",
        "women": "1.8",
        "white": "6.0",
        "black": "2.3",
        "asian": "14.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "574",
        "median": "932",
        "maleWorkers": "563",
        "maleMedian": "929",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Glaziers": {
    "ageData": {
      "2012": {
        "total": "46",
        "16to19": "0",
        "20to24": "2",
        "25to34": "18",
        "35to44": "12",
        "45to54": "6",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Glaziers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "38",
        "median": "-",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Insulation workers": {
    "ageData": {
      "2012": {
        "total": "44",
        "16to19": "1",
        "20to24": "4",
        "25to34": "11",
        "35to44": "17",
        "45to54": "8",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Insulation workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Painters, construction and maintenance": {
    "ageData": {
      "2012": {
        "total": "485",
        "16to19": "12",
        "20to24": "38",
        "25to34": "124",
        "35to44": "113",
        "45to54": "117",
        "55to64": "66",
        "65+": "15",
        "medianAge": "66"
      }
    },
    "title": "Painters, construction and maintenance",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "485",
        "women": "5.5",
        "white": "5.5",
        "black": "2.0",
        "asian": "42.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "261",
        "median": "568",
        "maleWorkers": "252",
        "maleMedian": "559",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Paperhangers": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "0",
        "45to54": "2",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Paperhangers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Pipelayers, plumbers, pipefitters, and steamfitters": {
    "ageData": {
      "2012": {
        "total": "534",
        "16to19": "7",
        "20to24": "36",
        "25to34": "129",
        "35to44": "135",
        "45to54": "150",
        "55to64": "62",
        "65+": "15",
        "medianAge": "62"
      }
    },
    "title": "Pipelayers, plumbers, pipefitters, and steamfitters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "534",
        "women": "1.3",
        "white": "6.6",
        "black": "1.5",
        "asian": "20.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "436",
        "median": "878",
        "maleWorkers": "430",
        "maleMedian": "876",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Plasterers and stucco masons": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "1",
        "20to24": "2",
        "25to34": "3",
        "35to44": "7",
        "45to54": "4",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Plasterers and stucco masons",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Reinforcing iron and rebar workers": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Reinforcing iron and rebar workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Roofers": {
    "ageData": {
      "2012": {
        "total": "196",
        "16to19": "3",
        "20to24": "15",
        "25to34": "70",
        "35to44": "47",
        "45to54": "41",
        "55to64": "17",
        "65+": "4",
        "medianAge": "17"
      }
    },
    "title": "Roofers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "196",
        "women": "1.5",
        "white": "7.0",
        "black": "0.5",
        "asian": "45.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "123",
        "median": "533",
        "maleWorkers": "121",
        "maleMedian": "524",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Sheet metal workers": {
    "ageData": {
      "2012": {
        "total": "123",
        "16to19": "2",
        "20to24": "8",
        "25to34": "26",
        "35to44": "29",
        "45to54": "32",
        "55to64": "23",
        "65+": "3",
        "medianAge": "23"
      }
    },
    "title": "Sheet metal workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "123",
        "women": "4.6",
        "white": "3.2",
        "black": "1.7",
        "asian": "12.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "103",
        "median": "885",
        "maleWorkers": "100",
        "maleMedian": "880",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Structural iron and steel workers": {
    "ageData": {
      "2012": {
        "total": "65",
        "16to19": "1",
        "20to24": "5",
        "25to34": "17",
        "35to44": "28",
        "45to54": "10",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Structural iron and steel workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "65",
        "women": "2.8",
        "white": "6.5",
        "black": "0.0",
        "asian": "15.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "60",
        "median": "759",
        "maleWorkers": "59",
        "maleMedian": "767",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Solar photovoltaic installers": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "4",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Solar photovoltaic installers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers, construction trades": {
    "ageData": {
      "2012": {
        "total": "53",
        "16to19": "4",
        "20to24": "8",
        "25to34": "20",
        "35to44": "12",
        "45to54": "5",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Helpers, construction trades",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "53",
        "women": "4.5",
        "white": "12.1",
        "black": "1.3",
        "asian": "38.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "40",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Construction and building inspectors": {
    "ageData": {
      "2012": {
        "total": "118",
        "16to19": "1",
        "20to24": "4",
        "25to34": "12",
        "35to44": "20",
        "45to54": "32",
        "55to64": "40",
        "65+": "9",
        "medianAge": "40"
      }
    },
    "title": "Construction and building inspectors",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "118",
        "women": "7.8",
        "white": "5.5",
        "black": "2.1",
        "asian": "7.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "87",
        "median": "932",
        "maleWorkers": "83",
        "maleMedian": "940",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Elevator installers and repairers": {
    "ageData": {
      "2012": {
        "total": "29",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "7",
        "45to54": "13",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Elevator installers and repairers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Fence erectors": {
    "ageData": {
      "2012": {
        "total": "33",
        "16to19": "3",
        "20to24": "6",
        "25to34": "6",
        "35to44": "6",
        "45to54": "11",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Fence erectors",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Hazardous materials removal workers": {
    "ageData": {
      "2012": {
        "total": "38",
        "16to19": "1",
        "20to24": "5",
        "25to34": "8",
        "35to44": "10",
        "45to54": "10",
        "55to64": "1",
        "65+": "2",
        "medianAge": "1"
      }
    },
    "title": "Hazardous materials removal workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Highway maintenance workers": {
    "ageData": {
      "2012": {
        "total": "108",
        "16to19": "3",
        "20to24": "4",
        "25to34": "17",
        "35to44": "25",
        "45to54": "31",
        "55to64": "24",
        "65+": "5",
        "medianAge": "24"
      }
    },
    "title": "Highway maintenance workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "108",
        "women": "1.5",
        "white": "11.0",
        "black": "0.1",
        "asian": "12.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "98",
        "median": "683",
        "maleWorkers": "97",
        "maleMedian": "683",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Rail-track laying and maintenance equipment operators": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "1",
        "45to54": "5",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Rail-track laying and maintenance equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Septic tank servicers and sewer pipe cleaners": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "5",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Septic tank servicers and sewer pipe cleaners",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous construction and related workers": {
    "ageData": {
      "2012": {
        "total": "32",
        "16to19": "0",
        "20to24": "1",
        "25to34": "12",
        "35to44": "5",
        "45to54": "7",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Miscellaneous construction and related workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Derrick, rotary drill, and service unit operators, oil, gas, and mining": {
    "ageData": {
      "2012": {
        "total": "37",
        "16to19": "1",
        "20to24": "6",
        "25to34": "13",
        "35to44": "10",
        "45to54": "6",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Derrick, rotary drill, and service unit operators, oil, gas, and mining",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Earth drillers, except oil and gas": {
    "ageData": {
      "2012": {
        "total": "35",
        "16to19": "0",
        "20to24": "6",
        "25to34": "7",
        "35to44": "10",
        "45to54": "7",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Earth drillers, except oil and gas",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Explosives workers, ordnance handling experts, and blasters": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "1",
        "45to54": "3",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Explosives workers, ordnance handling experts, and blasters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Mining machine operators": {
    "ageData": {
      "2012": {
        "total": "65",
        "16to19": "1",
        "20to24": "8",
        "25to34": "20",
        "35to44": "16",
        "45to54": "14",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Mining machine operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "65",
        "women": "0.3",
        "white": "3.8",
        "black": "0.0",
        "asian": "17.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "65",
        "median": "997",
        "maleWorkers": "65",
        "maleMedian": "996",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Roof bolters, mining": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Roof bolters, mining",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Roustabouts, oil and gas": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "2",
        "20to24": "3",
        "25to34": "4",
        "35to44": "1",
        "45to54": "3",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Roustabouts, oil and gas",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--extraction workers": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Helpers--extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Other extraction workers": {
    "ageData": {
      "2012": {
        "total": "75",
        "16to19": "3",
        "20to24": "10",
        "25to34": "26",
        "35to44": "16",
        "45to54": "14",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Other extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "75",
        "women": "4.5",
        "white": "5.6",
        "black": "1.0",
        "asian": "26.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "84",
        "median": "985",
        "maleWorkers": "83",
        "maleMedian": "981",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Installation, maintenance, and repair occupations": {
    "ageData": {
      "2012": {
        "total": "4,821",
        "16to19": "75",
        "20to24": "390",
        "25to34": "1,071",
        "35to44": "1,153",
        "45to54": "1,201",
        "55to64": "766",
        "65+": "165",
        "medianAge": "766"
      }
    },
    "title": "Installation, maintenance, and repair occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4,821",
        "women": "3.2",
        "white": "8.4",
        "black": "3.0",
        "asian": "16.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4,088",
        "median": "808",
        "maleWorkers": "3,963",
        "maleMedian": "809",
        "femaleWorkers": "125",
        "femaleMedian": "757"
      }
    }
  },
  "First-line supervisors of mechanics, installers, and repairers": {
    "ageData": {
      "2012": {
        "total": "292",
        "16to19": "1",
        "20to24": "6",
        "25to34": "47",
        "35to44": "72",
        "45to54": "84",
        "55to64": "73",
        "65+": "10",
        "medianAge": "73"
      }
    },
    "title": "First-line supervisors of mechanics, installers, and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "292",
        "women": "5.9",
        "white": "11.3",
        "black": "1.0",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "280",
        "median": "936",
        "maleWorkers": "262",
        "maleMedian": "934",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Computer, automated teller, and office machine repairers": {
    "ageData": {
      "2012": {
        "total": "296",
        "16to19": "2",
        "20to24": "29",
        "25to34": "73",
        "35to44": "73",
        "45to54": "67",
        "55to64": "40",
        "65+": "13",
        "medianAge": "40"
      }
    },
    "title": "Computer, automated teller, and office machine repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "296",
        "women": "10.7",
        "white": "10.8",
        "black": "7.2",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "218",
        "median": "854",
        "maleWorkers": "193",
        "maleMedian": "880",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Radio and telecommunications equipment installers and repairers": {
    "ageData": {
      "2012": {
        "total": "158",
        "16to19": "1",
        "20to24": "10",
        "25to34": "39",
        "35to44": "47",
        "45to54": "31",
        "55to64": "25",
        "65+": "5",
        "medianAge": "25"
      }
    },
    "title": "Radio and telecommunications equipment installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "158",
        "women": "5.8",
        "white": "11.2",
        "black": "3.2",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "142",
        "median": "885",
        "maleWorkers": "132",
        "maleMedian": "898",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Avionics technicians": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "3",
        "45to54": "6",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Avionics technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Electric motor, power tool, and related repairers": {
    "ageData": {
      "2012": {
        "total": "37",
        "16to19": "1",
        "20to24": "5",
        "25to34": "11",
        "35to44": "8",
        "45to54": "7",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Electric motor, power tool, and related repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "37",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics installers and repairers, transportation equipment": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Electrical and electronics installers and repairers, transportation equipment",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics repairers, industrial and utility": {
    "ageData": {
      "2012": {
        "total": "12",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "2",
        "45to54": "4",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Electrical and electronics repairers, industrial and utility",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "12",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electronic equipment installers and repairers, motor vehicles": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "4",
        "45to54": "4",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Electronic equipment installers and repairers, motor vehicles",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Electronic home entertainment equipment installers and repairers": {
    "ageData": {
      "2012": {
        "total": "50",
        "16to19": "1",
        "20to24": "5",
        "25to34": "14",
        "35to44": "12",
        "45to54": "13",
        "55to64": "2",
        "65+": "2",
        "medianAge": "2"
      }
    },
    "title": "Electronic home entertainment equipment installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "50",
        "women": "0.5",
        "white": "11.6",
        "black": "4.3",
        "asian": "13.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Security and fire alarm systems installers": {
    "ageData": {
      "2012": {
        "total": "41",
        "16to19": "0",
        "20to24": "4",
        "25to34": "11",
        "35to44": "11",
        "45to54": "10",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Security and fire alarm systems installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "34",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Aircraft mechanics and service technicians": {
    "ageData": {
      "2012": {
        "total": "153",
        "16to19": "0",
        "20to24": "11",
        "25to34": "33",
        "35to44": "28",
        "45to54": "49",
        "55to64": "26",
        "65+": "5",
        "medianAge": "26"
      }
    },
    "title": "Aircraft mechanics and service technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "153",
        "women": "1.6",
        "white": "7.5",
        "black": "5.4",
        "asian": "14.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "144",
        "median": "993",
        "maleWorkers": "142",
        "maleMedian": "986",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive body and related repairers": {
    "ageData": {
      "2012": {
        "total": "140",
        "16to19": "4",
        "20to24": "12",
        "25to34": "36",
        "35to44": "37",
        "45to54": "27",
        "55to64": "18",
        "65+": "5",
        "medianAge": "18"
      }
    },
    "title": "Automotive body and related repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "140",
        "women": "1.8",
        "white": "5.7",
        "black": "2.3",
        "asian": "25.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "120",
        "median": "619",
        "maleWorkers": "119",
        "maleMedian": "618",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive glass installers and repairers": {
    "ageData": {
      "2012": {
        "total": "22",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "9",
        "45to54": "3",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Automotive glass installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "22",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive service technicians and mechanics": {
    "ageData": {
      "2012": {
        "total": "867",
        "16to19": "19",
        "20to24": "107",
        "25to34": "202",
        "35to44": "203",
        "45to54": "194",
        "55to64": "121",
        "65+": "23",
        "medianAge": "121"
      }
    },
    "title": "Automotive service technicians and mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "867",
        "women": "1.2",
        "white": "9.6",
        "black": "4.7",
        "asian": "21.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "691",
        "median": "702",
        "maleWorkers": "684",
        "maleMedian": "704",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Bus and truck mechanics and diesel engine specialists": {
    "ageData": {
      "2012": {
        "total": "316",
        "16to19": "6",
        "20to24": "25",
        "25to34": "75",
        "35to44": "64",
        "45to54": "77",
        "55to64": "56",
        "65+": "14",
        "medianAge": "56"
      }
    },
    "title": "Bus and truck mechanics and diesel engine specialists",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "316",
        "women": "0.5",
        "white": "8.6",
        "black": "1.3",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "271",
        "median": "843",
        "maleWorkers": "271",
        "maleMedian": "844",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Heavy vehicle and mobile equipment service technicians and mechanics": {
    "ageData": {
      "2012": {
        "total": "194",
        "16to19": "1",
        "20to24": "10",
        "25to34": "39",
        "35to44": "44",
        "45to54": "61",
        "55to64": "32",
        "65+": "6",
        "medianAge": "32"
      }
    },
    "title": "Heavy vehicle and mobile equipment service technicians and mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "194",
        "women": "1.0",
        "white": "5.4",
        "black": "2.0",
        "asian": "17.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "174",
        "median": "941",
        "maleWorkers": "171",
        "maleMedian": "942",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Small engine mechanics": {
    "ageData": {
      "2012": {
        "total": "56",
        "16to19": "1",
        "20to24": "5",
        "25to34": "18",
        "35to44": "13",
        "45to54": "9",
        "55to64": "7",
        "65+": "3",
        "medianAge": "7"
      }
    },
    "title": "Small engine mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "56",
        "women": "1.4",
        "white": "4.9",
        "black": "0.2",
        "asian": "12.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers": {
    "ageData": {
      "2012": {
        "total": "87",
        "16to19": "7",
        "20to24": "23",
        "25to34": "24",
        "35to44": "17",
        "45to54": "13",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "87",
        "women": "1.8",
        "white": "8.0",
        "black": "0.0",
        "asian": "31.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "67",
        "median": "493",
        "maleWorkers": "66",
        "maleMedian": "496",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Control and valve installers and repairers": {
    "ageData": {
      "2012": {
        "total": "27",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "7",
        "45to54": "10",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Control and valve installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Heating, air conditioning, and refrigeration mechanics and installers": {
    "ageData": {
      "2012": {
        "total": "340",
        "16to19": "5",
        "20to24": "27",
        "25to34": "96",
        "35to44": "81",
        "45to54": "87",
        "55to64": "37",
        "65+": "6",
        "medianAge": "37"
      }
    },
    "title": "Heating, air conditioning, and refrigeration mechanics and installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "340",
        "women": "1.6",
        "white": "7.1",
        "black": "3.2",
        "asian": "16.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "280",
        "median": "827",
        "maleWorkers": "276",
        "maleMedian": "829",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Home appliance repairers": {
    "ageData": {
      "2012": {
        "total": "47",
        "16to19": "0",
        "20to24": "4",
        "25to34": "13",
        "35to44": "8",
        "45to54": "9",
        "55to64": "9",
        "65+": "5",
        "medianAge": "9"
      }
    },
    "title": "Home appliance repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial and refractory machinery mechanics": {
    "ageData": {
      "2012": {
        "total": "454",
        "16to19": "4",
        "20to24": "18",
        "25to34": "71",
        "35to44": "105",
        "45to54": "138",
        "55to64": "102",
        "65+": "15",
        "medianAge": "102"
      }
    },
    "title": "Industrial and refractory machinery mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "454",
        "women": "1.9",
        "white": "4.5",
        "black": "2.9",
        "asian": "13.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "424",
        "median": "867",
        "maleWorkers": "415",
        "maleMedian": "871",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Maintenance and repair workers, general": {
    "ageData": {
      "2012": {
        "total": "442",
        "16to19": "7",
        "20to24": "18",
        "25to34": "76",
        "35to44": "110",
        "45to54": "121",
        "55to64": "90",
        "65+": "19",
        "medianAge": "90"
      }
    },
    "title": "Maintenance and repair workers, general",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "442",
        "women": "2.2",
        "white": "8.4",
        "black": "3.2",
        "asian": "19.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "371",
        "median": "731",
        "maleWorkers": "364",
        "maleMedian": "732",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Maintenance workers, machinery": {
    "ageData": {
      "2012": {
        "total": "28",
        "16to19": "1",
        "20to24": "6",
        "25to34": "8",
        "35to44": "5",
        "45to54": "4",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Maintenance workers, machinery",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "28",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Millwrights": {
    "ageData": {
      "2012": {
        "total": "53",
        "16to19": "1",
        "20to24": "1",
        "25to34": "14",
        "35to44": "11",
        "45to54": "14",
        "55to64": "12",
        "65+": "0",
        "medianAge": "12"
      }
    },
    "title": "Millwrights",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "53",
        "women": "6.4",
        "white": "2.1",
        "black": "1.4",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "50",
        "median": "938",
        "maleWorkers": "46",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical power-line installers and repairers": {
    "ageData": {
      "2012": {
        "total": "110",
        "16to19": "0",
        "20to24": "17",
        "25to34": "31",
        "35to44": "25",
        "45to54": "24",
        "55to64": "12",
        "65+": "0",
        "medianAge": "12"
      }
    },
    "title": "Electrical power-line installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "110",
        "women": "2.4",
        "white": "7.8",
        "black": "0.3",
        "asian": "7.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "117",
        "median": "988",
        "maleWorkers": "115",
        "maleMedian": "990",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Telecommunications line installers and repairers": {
    "ageData": {
      "2012": {
        "total": "177",
        "16to19": "1",
        "20to24": "10",
        "25to34": "50",
        "35to44": "58",
        "45to54": "36",
        "55to64": "19",
        "65+": "2",
        "medianAge": "19"
      }
    },
    "title": "Telecommunications line installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "177",
        "women": "4.8",
        "white": "11.2",
        "black": "1.9",
        "asian": "15.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "171",
        "median": "915",
        "maleWorkers": "164",
        "maleMedian": "910",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Precision instrument and equipment repairers": {
    "ageData": {
      "2012": {
        "total": "60",
        "16to19": "0",
        "20to24": "1",
        "25to34": "10",
        "35to44": "13",
        "45to54": "16",
        "55to64": "13",
        "65+": "6",
        "medianAge": "13"
      }
    },
    "title": "Precision instrument and equipment repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "60",
        "women": "16.0",
        "white": "9.1",
        "black": "1.1",
        "asian": "13.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Wind turbine service technicians": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Wind turbine service technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Coin, vending, and amusement machine servicers and repairers": {
    "ageData": {
      "2012": {
        "total": "33",
        "16to19": "0",
        "20to24": "3",
        "25to34": "6",
        "35to44": "8",
        "45to54": "7",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Coin, vending, and amusement machine servicers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Commercial divers": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Commercial divers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Locksmiths and safe repairers": {
    "ageData": {
      "2012": {
        "total": "31",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "7",
        "45to54": "12",
        "55to64": "6",
        "65+": "3",
        "medianAge": "6"
      }
    },
    "title": "Locksmiths and safe repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "31",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Manufactured building and mobile home installers": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Manufactured building and mobile home installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Riggers": {
    "ageData": {
      "2012": {
        "total": "13",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "3",
        "45to54": "4",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Riggers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Signal and track switch repairers": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "3",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Signal and track switch repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--installation, maintenance, and repair workers": {
    "ageData": {
      "2012": {
        "total": "30",
        "16to19": "4",
        "20to24": "5",
        "25to34": "8",
        "35to44": "7",
        "45to54": "4",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Helpers--installation, maintenance, and repair workers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Other installation, maintenance, and repair workers": {
    "ageData": {
      "2012": {
        "total": "205",
        "16to19": "7",
        "20to24": "18",
        "25to34": "37",
        "35to44": "51",
        "45to54": "54",
        "55to64": "25",
        "65+": "15",
        "medianAge": "25"
      }
    },
    "title": "Other installation, maintenance, and repair workers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "205",
        "women": "3.6",
        "white": "5.9",
        "black": "1.4",
        "asian": "21.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "147",
        "median": "677",
        "maleWorkers": "142",
        "maleMedian": "671",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Production, transportation, and material moving occupations": {
    "ageData": {
      "2012": {
        "total": "16,994",
        "16to19": "447",
        "20to24": "1,576",
        "25to34": "3,360",
        "35to44": "3,603",
        "45to54": "4,296",
        "55to64": "2,904",
        "65+": "809",
        "medianAge": "2,904"
      }
    },
    "title": "Production, transportation, and material moving occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16,994",
        "women": "21.8",
        "white": "13.8",
        "black": "4.2",
        "asian": "21.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "13,842",
        "median": "624",
        "maleWorkers": "11,069",
        "maleMedian": "675",
        "femaleWorkers": "2,773",
        "femaleMedian": "493"
      }
    }
  },
  "Production occupations": {
    "ageData": {
      "2012": {
        "total": "8,455",
        "16to19": "147",
        "20to24": "748",
        "25to34": "1,697",
        "35to44": "1,885",
        "45to54": "2,178",
        "55to64": "1,481",
        "65+": "319",
        "medianAge": "1,481"
      }
    },
    "title": "Production occupations",
    "depth": 2,
    "parent": "Production, transportation, and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8,455",
        "women": "27.7",
        "white": "11.6",
        "black": "5.8",
        "asian": "21.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7,427",
        "median": "627",
        "maleWorkers": "5,497",
        "maleMedian": "695",
        "femaleWorkers": "1,930",
        "femaleMedian": "496"
      }
    }
  },
  "First-line supervisors of production and operating workers": {
    "ageData": {
      "2012": {
        "total": "808",
        "16to19": "1",
        "20to24": "24",
        "25to34": "115",
        "35to44": "194",
        "45to54": "265",
        "55to64": "174",
        "65+": "34",
        "medianAge": "174"
      }
    },
    "title": "First-line supervisors of production and operating workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "808",
        "women": "19.5",
        "white": "9.4",
        "black": "5.8",
        "asian": "13.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "734",
        "median": "917",
        "maleWorkers": "601",
        "maleMedian": "954",
        "femaleWorkers": "132",
        "femaleMedian": "674"
      }
    }
  },
  "Aircraft structure, surfaces, rigging, and systems assemblers": {
    "ageData": {
      "2012": {
        "total": "23",
        "16to19": "1",
        "20to24": "3",
        "25to34": "5",
        "35to44": "5",
        "45to54": "3",
        "55to64": "6",
        "65+": "0",
        "medianAge": "6"
      }
    },
    "title": "Aircraft structure, surfaces, rigging, and systems assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical, electronics, and electromechanical assemblers": {
    "ageData": {
      "2012": {
        "total": "166",
        "16to19": "2",
        "20to24": "17",
        "25to34": "25",
        "35to44": "42",
        "45to54": "42",
        "55to64": "34",
        "65+": "5",
        "medianAge": "34"
      }
    },
    "title": "Electrical, electronics, and electromechanical assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "166",
        "women": "52.8",
        "white": "13.4",
        "black": "16.3",
        "asian": "24.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "155",
        "median": "564",
        "maleWorkers": "77",
        "maleMedian": "620",
        "femaleWorkers": "78",
        "femaleMedian": "520"
      }
    }
  },
  "Engine and other machine assemblers": {
    "ageData": {
      "2012": {
        "total": "32",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "7",
        "45to54": "11",
        "55to64": "8",
        "65+": "0",
        "medianAge": "8"
      }
    },
    "title": "Engine and other machine assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Structural metal fabricators and fitters": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "8",
        "45to54": "7",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Structural metal fabricators and fitters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "19",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous assemblers and fabricators": {
    "ageData": {
      "2012": {
        "total": "919",
        "16to19": "25",
        "20to24": "96",
        "25to34": "189",
        "35to44": "202",
        "45to54": "225",
        "55to64": "145",
        "65+": "37",
        "medianAge": "145"
      }
    },
    "title": "Miscellaneous assemblers and fabricators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "919",
        "women": "38.4",
        "white": "15.8",
        "black": "6.9",
        "asian": "19.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "833",
        "median": "557",
        "maleWorkers": "513",
        "maleMedian": "606",
        "femaleWorkers": "320",
        "femaleMedian": "499"
      }
    }
  },
  "Bakers": {
    "ageData": {
      "2012": {
        "total": "199",
        "16to19": "7",
        "20to24": "36",
        "25to34": "41",
        "35to44": "31",
        "45to54": "40",
        "55to64": "34",
        "65+": "10",
        "medianAge": "34"
      }
    },
    "title": "Bakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "199",
        "women": "53.9",
        "white": "15.6",
        "black": "5.1",
        "asian": "28.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "121",
        "median": "474",
        "maleWorkers": "65",
        "maleMedian": "501",
        "femaleWorkers": "55",
        "femaleMedian": "450"
      }
    }
  },
  "Butchers and other meat, poultry, and fish processing workers": {
    "ageData": {
      "2012": {
        "total": "311",
        "16to19": "9",
        "20to24": "40",
        "25to34": "69",
        "35to44": "82",
        "45to54": "62",
        "55to64": "32",
        "65+": "17",
        "medianAge": "32"
      }
    },
    "title": "Butchers and other meat, poultry, and fish processing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "311",
        "women": "23.0",
        "white": "13.5",
        "black": "7.9",
        "asian": "41.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "273",
        "median": "507",
        "maleWorkers": "208",
        "maleMedian": "537",
        "femaleWorkers": "64",
        "femaleMedian": "417"
      }
    }
  },
  "Food and tobacco roasting, baking, and drying machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "2",
        "25to34": "2",
        "35to44": "3",
        "45to54": "1",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Food and tobacco roasting, baking, and drying machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Food batchmakers": {
    "ageData": {
      "2012": {
        "total": "84",
        "16to19": "5",
        "20to24": "11",
        "25to34": "19",
        "35to44": "21",
        "45to54": "13",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Food batchmakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "84",
        "women": "59.6",
        "white": "12.2",
        "black": "5.7",
        "asian": "33.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "59",
        "median": "512",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Food cooking machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "1",
        "20to24": "2",
        "25to34": "2",
        "35to44": "2",
        "45to54": "3",
        "55to64": "2",
        "65+": "2",
        "medianAge": "2"
      }
    },
    "title": "Food cooking machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "13",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Food processing workers, all other": {
    "ageData": {
      "2012": {
        "total": "117",
        "16to19": "1",
        "20to24": "23",
        "25to34": "27",
        "35to44": "24",
        "45to54": "26",
        "55to64": "13",
        "65+": "3",
        "medianAge": "13"
      }
    },
    "title": "Food processing workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "117",
        "women": "29.5",
        "white": "15.9",
        "black": "5.9",
        "asian": "34.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "90",
        "median": "529",
        "maleWorkers": "67",
        "maleMedian": "549",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Computer control programmers and operators": {
    "ageData": {
      "2012": {
        "total": "67",
        "16to19": "1",
        "20to24": "3",
        "25to34": "14",
        "35to44": "15",
        "45to54": "20",
        "55to64": "13",
        "65+": "2",
        "medianAge": "13"
      }
    },
    "title": "Computer control programmers and operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "67",
        "women": "8.4",
        "white": "6.4",
        "black": "3.3",
        "asian": "17.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "67",
        "median": "710",
        "maleWorkers": "62",
        "maleMedian": "728",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding and drawing machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "0",
        "45to54": "4",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Extruding and drawing machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Forging machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "3",
        "45to54": "4",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Forging machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Rolling machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "8",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "4",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Rolling machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Cutting, punching, and press machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "87",
        "16to19": "3",
        "20to24": "13",
        "25to34": "14",
        "35to44": "18",
        "45to54": "23",
        "55to64": "15",
        "65+": "1",
        "medianAge": "15"
      }
    },
    "title": "Cutting, punching, and press machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "87",
        "women": "18.9",
        "white": "8.4",
        "black": "3.3",
        "asian": "22.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "80",
        "median": "556",
        "maleWorkers": "65",
        "maleMedian": "575",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Drilling and boring machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Drilling and boring machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "54",
        "16to19": "4",
        "20to24": "7",
        "25to34": "15",
        "35to44": "8",
        "45to54": "8",
        "55to64": "10",
        "65+": "2",
        "medianAge": "10"
      }
    },
    "title": "Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "54",
        "women": "6.6",
        "white": "13.7",
        "black": "0.7",
        "asian": "21.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "53",
        "median": "588",
        "maleWorkers": "48",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Lathe and turning machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "17",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "4",
        "45to54": "7",
        "55to64": "2",
        "65+": "2",
        "medianAge": "2"
      }
    },
    "title": "Lathe and turning machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Milling and planing machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Milling and planing machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Machinists": {
    "ageData": {
      "2012": {
        "total": "397",
        "16to19": "3",
        "20to24": "28",
        "25to34": "75",
        "35to44": "90",
        "45to54": "104",
        "55to64": "80",
        "65+": "16",
        "medianAge": "80"
      }
    },
    "title": "Machinists",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "397",
        "women": "3.8",
        "white": "4.5",
        "black": "4.9",
        "asian": "11.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "381",
        "median": "760",
        "maleWorkers": "366",
        "maleMedian": "762",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Metal furnace operators, tenders, pourers, and casters": {
    "ageData": {
      "2012": {
        "total": "17",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "3",
        "45to54": "6",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Metal furnace operators, tenders, pourers, and casters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Model makers and patternmakers, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "4",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Model makers and patternmakers, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Molders and molding machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "37",
        "16to19": "1",
        "20to24": "4",
        "25to34": "8",
        "35to44": "7",
        "45to54": "7",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Molders and molding machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "38",
        "median": "-",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Multiple machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Multiple machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Tool and die makers": {
    "ageData": {
      "2012": {
        "total": "56",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "8",
        "45to54": "15",
        "55to64": "22",
        "65+": "5",
        "medianAge": "22"
      }
    },
    "title": "Tool and die makers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "56",
        "women": "0.8",
        "white": "3.1",
        "black": "5.6",
        "asian": "4.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "51",
        "median": "1,005",
        "maleWorkers": "51",
        "maleMedian": "1,005",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Welding, soldering, and brazing workers": {
    "ageData": {
      "2012": {
        "total": "593",
        "16to19": "6",
        "20to24": "60",
        "25to34": "175",
        "35to44": "143",
        "45to54": "123",
        "55to64": "74",
        "65+": "12",
        "medianAge": "74"
      }
    },
    "title": "Welding, soldering, and brazing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "593",
        "women": "4.8",
        "white": "8.7",
        "black": "2.6",
        "asian": "23.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "551",
        "median": "712",
        "maleWorkers": "525",
        "maleMedian": "722",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Heat treating equipment setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Heat treating equipment setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Layout workers, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Layout workers, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Plating and coating machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2012": {
        "total": "18",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "5",
        "45to54": "5",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Plating and coating machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Tool grinders, filers, and sharpeners": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Tool grinders, filers, and sharpeners",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Metal workers and plastic workers, all other": {
    "ageData": {
      "2012": {
        "total": "375",
        "16to19": "3",
        "20to24": "33",
        "25to34": "84",
        "35to44": "91",
        "45to54": "93",
        "55to64": "64",
        "65+": "7",
        "medianAge": "64"
      }
    },
    "title": "Metal workers and plastic workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "375",
        "women": "19.5",
        "white": "14.4",
        "black": "6.6",
        "asian": "26.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "374",
        "median": "618",
        "maleWorkers": "304",
        "maleMedian": "645",
        "femaleWorkers": "70",
        "femaleMedian": "544"
      }
    }
  },
  "Prepress technicians and workers": {
    "ageData": {
      "2012": {
        "total": "33",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "9",
        "45to54": "7",
        "55to64": "5",
        "65+": "4",
        "medianAge": "5"
      }
    },
    "title": "Prepress technicians and workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Printing press operators": {
    "ageData": {
      "2012": {
        "total": "201",
        "16to19": "3",
        "20to24": "13",
        "25to34": "33",
        "35to44": "43",
        "45to54": "66",
        "55to64": "36",
        "65+": "7",
        "medianAge": "36"
      }
    },
    "title": "Printing press operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "201",
        "women": "17.2",
        "white": "10.1",
        "black": "3.4",
        "asian": "15.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "167",
        "median": "628",
        "maleWorkers": "139",
        "maleMedian": "666",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Print binding and finishing workers": {
    "ageData": {
      "2012": {
        "total": "22",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "2",
        "45to54": "7",
        "55to64": "8",
        "65+": "3",
        "medianAge": "8"
      }
    },
    "title": "Print binding and finishing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "22",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Laundry and dry-cleaning workers": {
    "ageData": {
      "2012": {
        "total": "185",
        "16to19": "8",
        "20to24": "13",
        "25to34": "36",
        "35to44": "41",
        "45to54": "41",
        "55to64": "36",
        "65+": "10",
        "medianAge": "36"
      }
    },
    "title": "Laundry and dry-cleaning workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "185",
        "women": "53.3",
        "white": "20.8",
        "black": "10.3",
        "asian": "37.1"
      }
    },
    "wageData": {
      "2012": {
        "workers": "123",
        "median": "410",
        "maleWorkers": "57",
        "maleMedian": "462",
        "femaleWorkers": "66",
        "femaleMedian": "359"
      }
    }
  },
  "Pressers, textile, garment, and related materials": {
    "ageData": {
      "2012": {
        "total": "54",
        "16to19": "0",
        "20to24": "0",
        "25to34": "16",
        "35to44": "12",
        "45to54": "13",
        "55to64": "7",
        "65+": "5",
        "medianAge": "7"
      }
    },
    "title": "Pressers, textile, garment, and related materials",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "54",
        "women": "70.6",
        "white": "17.0",
        "black": "3.5",
        "asian": "47.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "41",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Sewing machine operators": {
    "ageData": {
      "2012": {
        "total": "166",
        "16to19": "1",
        "20to24": "8",
        "25to34": "28",
        "35to44": "31",
        "45to54": "44",
        "55to64": "39",
        "65+": "15",
        "medianAge": "39"
      }
    },
    "title": "Sewing machine operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "166",
        "women": "74.2",
        "white": "5.6",
        "black": "11.4",
        "asian": "43.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "127",
        "median": "385",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "86",
        "femaleMedian": "369"
      }
    }
  },
  "Shoe and leather workers and repairers": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "2",
        "45to54": "5",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Shoe and leather workers and repairers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Shoe machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "2",
        "25to34": "0",
        "35to44": "3",
        "45to54": "5",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Shoe machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Tailors, dressmakers, and sewers": {
    "ageData": {
      "2012": {
        "total": "86",
        "16to19": "1",
        "20to24": "1",
        "25to34": "6",
        "35to44": "16",
        "45to54": "29",
        "55to64": "18",
        "65+": "15",
        "medianAge": "18"
      }
    },
    "title": "Tailors, dressmakers, and sewers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "86",
        "women": "77.1",
        "white": "5.9",
        "black": "19.5",
        "asian": "24.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Textile bleaching and dyeing machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Textile bleaching and dyeing machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Textile cutting machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "12",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "5",
        "45to54": "3",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Textile cutting machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "12",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Textile knitting and weaving machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "5",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Textile knitting and weaving machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Textile winding, twisting, and drawing out machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "5",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Textile winding, twisting, and drawing out machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers": {
    "ageData": {
      "2012": {
        "total": "1",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Fabric and apparel patternmakers": {
    "ageData": {
      "2012": {
        "total": "3",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Fabric and apparel patternmakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Upholsterers": {
    "ageData": {
      "2012": {
        "total": "34",
        "16to19": "1",
        "20to24": "1",
        "25to34": "4",
        "35to44": "8",
        "45to54": "10",
        "55to64": "9",
        "65+": "2",
        "medianAge": "9"
      }
    },
    "title": "Upholsterers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Textile, apparel, and furnishings workers, all other": {
    "ageData": {
      "2012": {
        "total": "14",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "2",
        "45to54": "3",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Textile, apparel, and furnishings workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Cabinetmakers and bench carpenters": {
    "ageData": {
      "2012": {
        "total": "45",
        "16to19": "1",
        "20to24": "2",
        "25to34": "8",
        "35to44": "7",
        "45to54": "14",
        "55to64": "13",
        "65+": "0",
        "medianAge": "13"
      }
    },
    "title": "Cabinetmakers and bench carpenters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Furniture finishers": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "3",
        "45to54": "2",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Furniture finishers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Model makers and patternmakers, wood": {
    "ageData": {
      "2012": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Model makers and patternmakers, wood",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Sawing machine setters, operators, and tenders, wood": {
    "ageData": {
      "2012": {
        "total": "30",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "5",
        "45to54": "10",
        "55to64": "8",
        "65+": "1",
        "medianAge": "8"
      }
    },
    "title": "Sawing machine setters, operators, and tenders, wood",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Woodworking machine setters, operators, and tenders, except sawing": {
    "ageData": {
      "2012": {
        "total": "21",
        "16to19": "1",
        "20to24": "2",
        "25to34": "4",
        "35to44": "6",
        "45to54": "5",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Woodworking machine setters, operators, and tenders, except sawing",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Woodworkers, all other": {
    "ageData": {
      "2012": {
        "total": "21",
        "16to19": "2",
        "20to24": "2",
        "25to34": "5",
        "35to44": "1",
        "45to54": "4",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Woodworkers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Power plant operators, distributors, and dispatchers": {
    "ageData": {
      "2012": {
        "total": "44",
        "16to19": "0",
        "20to24": "2",
        "25to34": "7",
        "35to44": "12",
        "45to54": "12",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Power plant operators, distributors, and dispatchers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "43",
        "median": "-",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Stationary engineers and boiler operators": {
    "ageData": {
      "2012": {
        "total": "121",
        "16to19": "0",
        "20to24": "5",
        "25to34": "20",
        "35to44": "22",
        "45to54": "35",
        "55to64": "33",
        "65+": "5",
        "medianAge": "33"
      }
    },
    "title": "Stationary engineers and boiler operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "121",
        "women": "5.5",
        "white": "10.4",
        "black": "4.3",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "105",
        "median": "830",
        "maleWorkers": "99",
        "maleMedian": "831",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Water and wastewater treatment plant and system operators": {
    "ageData": {
      "2012": {
        "total": "72",
        "16to19": "0",
        "20to24": "0",
        "25to34": "14",
        "35to44": "13",
        "45to54": "31",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Water and wastewater treatment plant and system operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "72",
        "women": "4.5",
        "white": "8.4",
        "black": "1.7",
        "asian": "19.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "70",
        "median": "862",
        "maleWorkers": "67",
        "maleMedian": "870",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous plant and system operators": {
    "ageData": {
      "2012": {
        "total": "39",
        "16to19": "0",
        "20to24": "3",
        "25to34": "7",
        "35to44": "11",
        "45to54": "9",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Miscellaneous plant and system operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "39",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical processing machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "68",
        "16to19": "0",
        "20to24": "8",
        "25to34": "15",
        "35to44": "14",
        "45to54": "17",
        "55to64": "13",
        "65+": "0",
        "medianAge": "13"
      }
    },
    "title": "Chemical processing machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "68",
        "women": "16.2",
        "white": "4.5",
        "black": "0.8",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "72",
        "median": "851",
        "maleWorkers": "62",
        "maleMedian": "890",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Crushing, grinding, polishing, mixing, and blending workers": {
    "ageData": {
      "2012": {
        "total": "100",
        "16to19": "1",
        "20to24": "8",
        "25to34": "29",
        "35to44": "19",
        "45to54": "22",
        "55to64": "17",
        "65+": "4",
        "medianAge": "17"
      }
    },
    "title": "Crushing, grinding, polishing, mixing, and blending workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "100",
        "women": "15.0",
        "white": "14.5",
        "black": "6.8",
        "asian": "18.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "86",
        "median": "628",
        "maleWorkers": "74",
        "maleMedian": "651",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Cutting workers": {
    "ageData": {
      "2012": {
        "total": "67",
        "16to19": "2",
        "20to24": "7",
        "25to34": "13",
        "35to44": "15",
        "45to54": "19",
        "55to64": "10",
        "65+": "0",
        "medianAge": "10"
      }
    },
    "title": "Cutting workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "67",
        "women": "19.2",
        "white": "14.1",
        "black": "3.5",
        "asian": "15.8"
      }
    },
    "wageData": {
      "2012": {
        "workers": "60",
        "median": "524",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding, forming, pressing, and compacting machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "45",
        "16to19": "1",
        "20to24": "1",
        "25to34": "10",
        "35to44": "12",
        "45to54": "15",
        "55to64": "6",
        "65+": "0",
        "medianAge": "6"
      }
    },
    "title": "Extruding, forming, pressing, and compacting machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "38",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Furnace, kiln, oven, drier, and kettle operators and tenders": {
    "ageData": {
      "2012": {
        "total": "16",
        "16to19": "0",
        "20to24": "3",
        "25to34": "4",
        "35to44": "3",
        "45to54": "6",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Furnace, kiln, oven, drier, and kettle operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Inspectors, testers, sorters, samplers, and weighers": {
    "ageData": {
      "2012": {
        "total": "689",
        "16to19": "6",
        "20to24": "51",
        "25to34": "124",
        "35to44": "157",
        "45to54": "188",
        "55to64": "138",
        "65+": "25",
        "medianAge": "138"
      }
    },
    "title": "Inspectors, testers, sorters, samplers, and weighers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "689",
        "women": "33.4",
        "white": "11.5",
        "black": "6.7",
        "asian": "13.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "621",
        "median": "729",
        "maleWorkers": "416",
        "maleMedian": "824",
        "femaleWorkers": "206",
        "femaleMedian": "570"
      }
    }
  },
  "Jewelers and precious stone and metal workers": {
    "ageData": {
      "2012": {
        "total": "46",
        "16to19": "0",
        "20to24": "1",
        "25to34": "9",
        "35to44": "4",
        "45to54": "14",
        "55to64": "9",
        "65+": "8",
        "medianAge": "9"
      }
    },
    "title": "Jewelers and precious stone and metal workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Medical, dental, and ophthalmic laboratory technicians": {
    "ageData": {
      "2012": {
        "total": "95",
        "16to19": "2",
        "20to24": "15",
        "25to34": "15",
        "35to44": "24",
        "45to54": "17",
        "55to64": "18",
        "65+": "5",
        "medianAge": "18"
      }
    },
    "title": "Medical, dental, and ophthalmic laboratory technicians",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "95",
        "women": "50.7",
        "white": "1.6",
        "black": "8.9",
        "asian": "15.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "76",
        "median": "585",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Packaging and filling machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "261",
        "16to19": "7",
        "20to24": "22",
        "25to34": "55",
        "35to44": "57",
        "45to54": "75",
        "55to64": "40",
        "65+": "5",
        "medianAge": "40"
      }
    },
    "title": "Packaging and filling machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "261",
        "women": "52.3",
        "white": "14.1",
        "black": "8.8",
        "asian": "38.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "242",
        "median": "481",
        "maleWorkers": "111",
        "maleMedian": "553",
        "femaleWorkers": "131",
        "femaleMedian": "431"
      }
    }
  },
  "Painting workers": {
    "ageData": {
      "2012": {
        "total": "150",
        "16to19": "3",
        "20to24": "20",
        "25to34": "41",
        "35to44": "33",
        "45to54": "37",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Painting workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "150",
        "women": "15.1",
        "white": "5.7",
        "black": "4.3",
        "asian": "34.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "135",
        "median": "626",
        "maleWorkers": "111",
        "maleMedian": "654",
        "femaleWorkers": "24",
        "femaleMedian": "-"
      }
    }
  },
  "Photographic process workers and processing machine operators": {
    "ageData": {
      "2012": {
        "total": "55",
        "16to19": "1",
        "20to24": "10",
        "25to34": "20",
        "35to44": "10",
        "45to54": "8",
        "55to64": "6",
        "65+": "0",
        "medianAge": "6"
      }
    },
    "title": "Photographic process workers and processing machine operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "55",
        "women": "45.6",
        "white": "13.3",
        "black": "4.9",
        "asian": "18.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Semiconductor processors": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Semiconductor processors",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Adhesive bonding machine operators and tenders": {
    "ageData": {
      "2012": {
        "total": "9",
        "16to19": "0",
        "20to24": "3",
        "25to34": "2",
        "35to44": "3",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Adhesive bonding machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Cleaning, washing, and metal pickling equipment operators and tenders": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "3",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Cleaning, washing, and metal pickling equipment operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Cooling and freezing equipment operators and tenders": {
    "ageData": {
      "2012": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Cooling and freezing equipment operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Etchers and engravers": {
    "ageData": {
      "2012": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "3",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Etchers and engravers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Molders, shapers, and casters, except metal and plastic": {
    "ageData": {
      "2012": {
        "total": "41",
        "16to19": "0",
        "20to24": "4",
        "25to34": "8",
        "35to44": "8",
        "45to54": "10",
        "55to64": "8",
        "65+": "4",
        "medianAge": "8"
      }
    },
    "title": "Molders, shapers, and casters, except metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Paper goods machine setters, operators, and tenders": {
    "ageData": {
      "2012": {
        "total": "35",
        "16to19": "1",
        "20to24": "2",
        "25to34": "7",
        "35to44": "10",
        "45to54": "10",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Paper goods machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Tire builders": {
    "ageData": {
      "2012": {
        "total": "19",
        "16to19": "1",
        "20to24": "3",
        "25to34": "6",
        "35to44": "3",
        "45to54": "3",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Tire builders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--production workers": {
    "ageData": {
      "2012": {
        "total": "59",
        "16to19": "6",
        "20to24": "11",
        "25to34": "11",
        "35to44": "13",
        "45to54": "11",
        "55to64": "4",
        "65+": "3",
        "medianAge": "4"
      }
    },
    "title": "Helpers--production workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "59",
        "women": "34.8",
        "white": "19.8",
        "black": "2.9",
        "asian": "30.6"
      }
    },
    "wageData": {
      "2012": {
        "workers": "40",
        "median": "-",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Production workers, all other": {
    "ageData": {
      "2012": {
        "total": "933",
        "16to19": "24",
        "20to24": "99",
        "25to34": "206",
        "35to44": "213",
        "45to54": "226",
        "55to64": "148",
        "65+": "16",
        "medianAge": "148"
      }
    },
    "title": "Production workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "933",
        "women": "26.3",
        "white": "13.7",
        "black": "4.0",
        "asian": "21.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "849",
        "median": "584",
        "maleWorkers": "626",
        "maleMedian": "619",
        "femaleWorkers": "223",
        "femaleMedian": "504"
      }
    }
  },
  "Transportation and material moving occupations": {
    "ageData": {
      "2012": {
        "total": "8,540",
        "16to19": "299",
        "20to24": "828",
        "25to34": "1,663",
        "35to44": "1,718",
        "45to54": "2,118",
        "55to64": "1,424",
        "65+": "490",
        "medianAge": "1,424"
      }
    },
    "title": "Transportation and material moving occupations",
    "depth": 2,
    "parent": "Production, transportation, and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "8,540",
        "women": "15.9",
        "white": "15.9",
        "black": "2.7",
        "asian": "21.7"
      }
    },
    "wageData": {
      "2012": {
        "workers": "6,415",
        "median": "621",
        "maleWorkers": "5,572",
        "maleMedian": "650",
        "femaleWorkers": "843",
        "femaleMedian": "487"
      }
    }
  },
  "Supervisors of transportation and material moving workers": {
    "ageData": {
      "2012": {
        "total": "200",
        "16to19": "0",
        "20to24": "16",
        "25to34": "51",
        "35to44": "41",
        "45to54": "54",
        "55to64": "35",
        "65+": "3",
        "medianAge": "35"
      }
    },
    "title": "Supervisors of transportation and material moving workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "200",
        "women": "23.0",
        "white": "13.5",
        "black": "4.4",
        "asian": "18.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "189",
        "median": "812",
        "maleWorkers": "146",
        "maleMedian": "873",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Aircraft pilots and flight engineers": {
    "ageData": {
      "2012": {
        "total": "129",
        "16to19": "0",
        "20to24": "3",
        "25to34": "22",
        "35to44": "27",
        "45to54": "41",
        "55to64": "30",
        "65+": "6",
        "medianAge": "30"
      }
    },
    "title": "Aircraft pilots and flight engineers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "129",
        "women": "4.1",
        "white": "2.7",
        "black": "2.5",
        "asian": "5.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "90",
        "median": "1,440",
        "maleWorkers": "86",
        "maleMedian": "1,444",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Air traffic controllers and airfield operations specialists": {
    "ageData": {
      "2012": {
        "total": "44",
        "16to19": "0",
        "20to24": "0",
        "25to34": "14",
        "35to44": "10",
        "45to54": "11",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Air traffic controllers and airfield operations specialists",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "47",
        "median": "-",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Flight attendants": {
    "ageData": {
      "2012": {
        "total": "88",
        "16to19": "0",
        "20to24": "1",
        "25to34": "12",
        "35to44": "18",
        "45to54": "30",
        "55to64": "20",
        "65+": "6",
        "medianAge": "20"
      }
    },
    "title": "Flight attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "88",
        "women": "77.6",
        "white": "11.8",
        "black": "5.9",
        "asian": "10.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "59",
        "median": "775",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Ambulance drivers and attendants, except emergency medical technicians": {
    "ageData": {
      "2012": {
        "total": "20",
        "16to19": "0",
        "20to24": "1",
        "25to34": "6",
        "35to44": "4",
        "45to54": "4",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Ambulance drivers and attendants, except emergency medical technicians",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "20",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Bus drivers": {
    "ageData": {
      "2012": {
        "total": "558",
        "16to19": "1",
        "20to24": "7",
        "25to34": "45",
        "35to44": "83",
        "45to54": "167",
        "55to64": "167",
        "65+": "87",
        "medianAge": "167"
      }
    },
    "title": "Bus drivers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "558",
        "women": "45.5",
        "white": "25.3",
        "black": "2.3",
        "asian": "12.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "302",
        "median": "601",
        "maleWorkers": "177",
        "maleMedian": "652",
        "femaleWorkers": "126",
        "femaleMedian": "516"
      }
    }
  },
  "Driver/sales workers and truck drivers": {
    "ageData": {
      "2012": {
        "total": "3,201",
        "16to19": "37",
        "20to24": "171",
        "25to34": "569",
        "35to44": "714",
        "45to54": "911",
        "55to64": "602",
        "65+": "196",
        "medianAge": "602"
      }
    },
    "title": "Driver/sales workers and truck drivers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "3,201",
        "women": "5.4",
        "white": "14.0",
        "black": "1.6",
        "asian": "19.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "2,533",
        "median": "730",
        "maleWorkers": "2,433",
        "maleMedian": "736",
        "femaleWorkers": "101",
        "femaleMedian": "537"
      }
    }
  },
  "Taxi drivers and chauffeurs": {
    "ageData": {
      "2012": {
        "total": "336",
        "16to19": "2",
        "20to24": "15",
        "25to34": "42",
        "35to44": "63",
        "45to54": "93",
        "55to64": "80",
        "65+": "40",
        "medianAge": "80"
      }
    },
    "title": "Taxi drivers and chauffeurs",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "336",
        "women": "13.2",
        "white": "24.8",
        "black": "13.8",
        "asian": "16.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "183",
        "median": "554",
        "maleWorkers": "161",
        "maleMedian": "572",
        "femaleWorkers": "22",
        "femaleMedian": "-"
      }
    }
  },
  "Motor vehicle operators, all other": {
    "ageData": {
      "2012": {
        "total": "63",
        "16to19": "0",
        "20to24": "1",
        "25to34": "6",
        "35to44": "10",
        "45to54": "10",
        "55to64": "10",
        "65+": "25",
        "medianAge": "10"
      }
    },
    "title": "Motor vehicle operators, all other",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "63",
        "women": "13.3",
        "white": "14.4",
        "black": "1.4",
        "asian": "10.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Locomotive engineers and operators": {
    "ageData": {
      "2012": {
        "total": "41",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "12",
        "45to54": "13",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Locomotive engineers and operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Railroad brake, signal, and switch operators": {
    "ageData": {
      "2012": {
        "total": "10",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "2",
        "45to54": "3",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Railroad brake, signal, and switch operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Railroad conductors and yardmasters": {
    "ageData": {
      "2012": {
        "total": "52",
        "16to19": "1",
        "20to24": "6",
        "25to34": "15",
        "35to44": "13",
        "45to54": "9",
        "55to64": "8",
        "65+": "0",
        "medianAge": "8"
      }
    },
    "title": "Railroad conductors and yardmasters",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "52",
        "women": "5.6",
        "white": "16.2",
        "black": "0.7",
        "asian": "12.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "46",
        "median": "-",
        "maleWorkers": "45",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Subway, streetcar, and other rail transportation workers": {
    "ageData": {
      "2012": {
        "total": "11",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "2",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Subway, streetcar, and other rail transportation workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Sailors and marine oilers": {
    "ageData": {
      "2012": {
        "total": "16",
        "16to19": "2",
        "20to24": "1",
        "25to34": "7",
        "35to44": "2",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Sailors and marine oilers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Ship and boat captains and operators": {
    "ageData": {
      "2012": {
        "total": "37",
        "16to19": "0",
        "20to24": "2",
        "25to34": "6",
        "35to44": "8",
        "45to54": "10",
        "55to64": "8",
        "65+": "3",
        "medianAge": "8"
      }
    },
    "title": "Ship and boat captains and operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Ship engineers": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "3",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Ship engineers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Bridge and lock tenders": {
    "ageData": {
      "2012": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "2",
        "45to54": "2",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Bridge and lock tenders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Parking lot attendants": {
    "ageData": {
      "2012": {
        "total": "81",
        "16to19": "6",
        "20to24": "28",
        "25to34": "8",
        "35to44": "10",
        "45to54": "14",
        "55to64": "10",
        "65+": "5",
        "medianAge": "10"
      }
    },
    "title": "Parking lot attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "81",
        "women": "11.6",
        "white": "23.5",
        "black": "5.3",
        "asian": "35.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "50",
        "median": "404",
        "maleWorkers": "45",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive and watercraft service attendants": {
    "ageData": {
      "2012": {
        "total": "94",
        "16to19": "14",
        "20to24": "23",
        "25to34": "23",
        "35to44": "10",
        "45to54": "13",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Automotive and watercraft service attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "94",
        "women": "9.2",
        "white": "12.9",
        "black": "5.2",
        "asian": "12.5"
      }
    },
    "wageData": {
      "2012": {
        "workers": "67",
        "median": "428",
        "maleWorkers": "63",
        "maleMedian": "453",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation inspectors": {
    "ageData": {
      "2012": {
        "total": "36",
        "16to19": "0",
        "20to24": "2",
        "25to34": "8",
        "35to44": "6",
        "45to54": "8",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Transportation inspectors",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "36",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation attendants, except flight attendants": {
    "ageData": {
      "2012": {
        "total": "38",
        "16to19": "2",
        "20to24": "4",
        "25to34": "7",
        "35to44": "4",
        "45to54": "7",
        "55to64": "11",
        "65+": "4",
        "medianAge": "11"
      }
    },
    "title": "Transportation attendants, except flight attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Other transportation workers": {
    "ageData": {
      "2012": {
        "total": "17",
        "16to19": "1",
        "20to24": "5",
        "25to34": "1",
        "35to44": "3",
        "45to54": "4",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Other transportation workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Conveyor operators and tenders": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "3",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Conveyor operators and tenders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Crane and tower operators": {
    "ageData": {
      "2012": {
        "total": "62",
        "16to19": "1",
        "20to24": "5",
        "25to34": "11",
        "35to44": "14",
        "45to54": "18",
        "55to64": "11",
        "65+": "3",
        "medianAge": "11"
      }
    },
    "title": "Crane and tower operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "62",
        "women": "4.0",
        "white": "12.3",
        "black": "0.9",
        "asian": "12.2"
      }
    },
    "wageData": {
      "2012": {
        "workers": "61",
        "median": "753",
        "maleWorkers": "58",
        "maleMedian": "777",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Dredge, excavating, and loading machine operators": {
    "ageData": {
      "2012": {
        "total": "42",
        "16to19": "0",
        "20to24": "4",
        "25to34": "6",
        "35to44": "7",
        "45to54": "14",
        "55to64": "8",
        "65+": "4",
        "medianAge": "8"
      }
    },
    "title": "Dredge, excavating, and loading machine operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Hoist and winch operators": {
    "ageData": {
      "2012": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "1",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Hoist and winch operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial truck and tractor operators": {
    "ageData": {
      "2012": {
        "total": "537",
        "16to19": "6",
        "20to24": "50",
        "25to34": "162",
        "35to44": "122",
        "45to54": "132",
        "55to64": "59",
        "65+": "6",
        "medianAge": "59"
      }
    },
    "title": "Industrial truck and tractor operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "537",
        "women": "7.4",
        "white": "18.4",
        "black": "1.6",
        "asian": "31.3"
      }
    },
    "wageData": {
      "2012": {
        "workers": "498",
        "median": "562",
        "maleWorkers": "467",
        "maleMedian": "566",
        "femaleWorkers": "31",
        "femaleMedian": "-"
      }
    }
  },
  "Cleaners of vehicles and equipment": {
    "ageData": {
      "2012": {
        "total": "315",
        "16to19": "33",
        "20to24": "64",
        "25to34": "73",
        "35to44": "61",
        "45to54": "50",
        "55to64": "25",
        "65+": "9",
        "medianAge": "25"
      }
    },
    "title": "Cleaners of vehicles and equipment",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "315",
        "women": "15.2",
        "white": "16.8",
        "black": "2.7",
        "asian": "35.9"
      }
    },
    "wageData": {
      "2012": {
        "workers": "217",
        "median": "425",
        "maleWorkers": "187",
        "maleMedian": "431",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Laborers and freight, stock, and material movers, hand": {
    "ageData": {
      "2012": {
        "total": "1,849",
        "16to19": "146",
        "20to24": "356",
        "25to34": "408",
        "35to44": "324",
        "45to54": "348",
        "55to64": "211",
        "65+": "58",
        "medianAge": "211"
      }
    },
    "title": "Laborers and freight, stock, and material movers, hand",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1,849",
        "women": "18.7",
        "white": "15.9",
        "black": "2.5",
        "asian": "23.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1,322",
        "median": "510",
        "maleWorkers": "1,103",
        "maleMedian": "519",
        "femaleWorkers": "218",
        "femaleMedian": "476"
      }
    }
  },
  "Machine feeders and offbearers": {
    "ageData": {
      "2012": {
        "total": "27",
        "16to19": "1",
        "20to24": "3",
        "25to34": "5",
        "35to44": "4",
        "45to54": "6",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Machine feeders and offbearers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Packers and packagers, hand": {
    "ageData": {
      "2012": {
        "total": "431",
        "16to19": "43",
        "20to24": "46",
        "25to34": "100",
        "35to44": "93",
        "45to54": "88",
        "55to64": "45",
        "65+": "16",
        "medianAge": "45"
      }
    },
    "title": "Packers and packagers, hand",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "431",
        "women": "53.1",
        "white": "14.0",
        "black": "3.5",
        "asian": "42.0"
      }
    },
    "wageData": {
      "2012": {
        "workers": "306",
        "median": "404",
        "maleWorkers": "146",
        "maleMedian": "426",
        "femaleWorkers": "160",
        "femaleMedian": "394"
      }
    }
  },
  "Pumping station operators": {
    "ageData": {
      "2012": {
        "total": "25",
        "16to19": "0",
        "20to24": "0",
        "25to34": "9",
        "35to44": "4",
        "45to54": "7",
        "55to64": "4",
        "65+": "2",
        "medianAge": "4"
      }
    },
    "title": "Pumping station operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Refuse and recyclable material collectors": {
    "ageData": {
      "2012": {
        "total": "106",
        "16to19": "3",
        "20to24": "9",
        "25to34": "23",
        "35to44": "27",
        "45to54": "30",
        "55to64": "11",
        "65+": "4",
        "medianAge": "11"
      }
    },
    "title": "Refuse and recyclable material collectors",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "106",
        "women": "6.6",
        "white": "24.9",
        "black": "1.4",
        "asian": "29.4"
      }
    },
    "wageData": {
      "2012": {
        "workers": "75",
        "median": "501",
        "maleWorkers": "71",
        "maleMedian": "497",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Mine shuttle car operators": {
    "ageData": {
      "2012": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Mine shuttle car operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Tank car, truck, and ship loaders": {
    "ageData": {
      "2012": {
        "total": "4",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Tank car, truck, and ship loaders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Material moving workers, all other": {
    "ageData": {
      "2012": {
        "total": "45",
        "16to19": "1",
        "20to24": "1",
        "25to34": "9",
        "35to44": "12",
        "45to54": "9",
        "55to64": "10",
        "65+": "4",
        "medianAge": "10"
      }
    },
    "title": "Material moving workers, all other",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2012": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2012": {
        "workers": "40",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  }
}